import React, { useState, useEffect } from "react";

import Portada from "./Portada.js";
import Float from "./Float.js";
import Tips from "./Tips.js";
import "../App.css";

const Grid_razas = () => {
  const [aux_lista, set_aux_lista] = useState([]);
  const [lista, set_lista] = useState([]);

  useEffect(() => {
    const lista_razas = [
      {
        nombre1: "Affenpinscher",
        nombre2: "",
        pais_origen: "?",
        origen:
          "No se sabe mucho de la raza, pero se cree que ya existía en el siglo XVI debido a que aparecían ejemplares de perros affenpinscher en cuadros que datan de esa fecha. Lo más probable es que descienda de los terriers alemanes, el pinscher o del schnauzer en miniatura, entre otras opciones.",
        caracteristica:
          "Son cariñosos, inquietos, atentos y activos. Normalmente tienen carácter fuerte, siendo muy valientes y fieros para defender a sus dueños, sin importarles su reducido tamaño.",
        recomendacion:
          "Puede que sean algo traviesos, y que esto conlleve que hagan algunos destrozos en casa, por lo que será importante que les permitamos realizar actividad física diaria. Su educación temprana será la clave del éxito.",
        ideal:
          "Es una de las razas más recomendadas para la vida en familia, debido a que son muy afectuosos y adoran pasar tiempo con ellos.",
        dato: "Es una de las razas caninas más antiguas del mundo, junto con otras como el chow chow, el pequinés o el husky siberiano. Se llaman así por el parecido que pueden tener con los monos (significa literalmente “pincher mono”).  Normalmente un affenpinscher será un perro muy sano, y bastante longevo, pues si te preguntas cuál es la esperanza de vida del affenpinscher debes saber que suelen vivir entre 12 y 15 años, aunque se han registrado ejemplares que han sobrepasado esa edad.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "inline",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-affenpinscher.html",
        n: "/img/razas/82.jpg",
      },
      {
        nombre1: "Aïdi",
        nombre2: "Perro de las Montañas del Atlas",
        pais_origen: "Marruecos",
        origen:
          "Es originario del norte de África, en concreto de Marruecos. Estos perros han ejercido tradicionalmente funciones de pastoreo entre los rebaños pertenecientes a los campesinos del norte del Atlas. Es una raza popular desde hace cientos de años, siendo realmente antigua y con una amplia historia en su región de origen.",
        caracteristica:
          "Si existe una palabra para definir el carácter del perro de las montañas del Atlas es la de fidelidad. Estos canes son extremadamente leales a sus dueños, a los que defienden fieramente de cualquier posible peligro. Se caracteriza por sus dotes como guardián y por ser muy obediente.",
        recomendacion:
          "Es necesario vigilar su alimentación, pues son muy glotones y tendentes a desarrollar sobrepeso con mucha facilidad.",
        ideal:
          "Es un perro guardián acostumbrado tradicionalmente a vivir en un entorno rural en el que pueda jugar y correr a su antojo, ya que son perros muy activos y que necesitan mucho deporte.",
        dato: "Se trata de una de las razas caninas más antiguas del mundo.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 2,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/aidi-o-perro-de-las-montanas-del-atlas.html",
        n: "/img/razas/34.jpg",
      },
      {
        nombre1: "Airedale Terrier",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Se originó en Inglaterra hace unos 100 años aproximadamente. Esta raza apareció por primera vez en el valle de Aire, y originalmente fue usada para caza menor (principalmente para librarse de alimañas). Suele ser muy resistente y presenta pocos problemas de salud.",
        caracteristica:
          "Alegre, confiado, valiente e inteligente. Suele ser amigable con la gente y también con otros perros, aunque a veces es impulsivo y tiende a presentar conductas de presa. Dada su agudeza mental y su fortaleza física, resulta un excelente candidato para participar en deportes caninos.",
        recomendacion:
          "Necesita una buena socialización desde cachorro y requiere muchísimo ejercicio diario.",
        ideal:
          "Puede ser un tanto brusco al jugar con niños pequeños y con perros que no están acostumbrados al juego rudo. No es recomendable para vivir en un departamento pequeño, lo mejor es que tengan un jardín, aunque sea pequeño, para que puedan jugar.",
        dato: "Es el más grande de los terrier.",
        size: 3,
        vida: 3,
        deporte: 4,
        intel: 4,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/airedale-terrier.html",
        n: "/img/razas/132.jpg",
      },
      {
        nombre1: "Akita Americano",
        nombre2: "",
        pais_origen: "Japón",
        origen:
          "El origen se remonta al año 1603 en Japón, cuando se utilizaban a los primeros akitas americanos (por aquel entonces, Matagi Akitas) como perros de pelea, además de ser entrenados para la caza de osos, jabalís y ciervos. Dos siglos después, a partir del 1868, se empezaron a cruzar a los Akitas Americanos con Pastores Alemanes, Tosa Inus y Mastín Ingleses, lo que dio lugar al Akita Americano de hoy.",
        caracteristica:
          "Es un perro valiente, protector, audaz e inteligente, que aprenderá todo tipo de órdenes. Suele tener un carácter independiente y una actitud muy distante con las personas desconocidas (algunas personas creen que tiene el mismo carácter que los gatos). Son algo dominantes en su relación con los otros perros y tremendamente fieles a su familia, a la que nunca harán daño y protegerán por encima de todo. En casa es un perro dócil, distante y calmado.  Es un perro muy territorial, que tiende a patrullar por la casa muy seguido. ",
        recomendacion:
          "Le gusta mucho jugar y mordisquear desde que son jóvenes, es bueno darle uno o varios mordedores así como juguetes para que se mantenga entretenido en los momentos en los que tú no estás. Recomendamos socializarlo desde cachorro, porque ante un ataque violento o una actitud que puedan interpretar como mala puede mostrar una mala reacción.",
        ideal: "Es un perro muy apropiado para las familias con niños.",
        dato: "Se trata de un perro de un solo dueño, por ese motivo si intentamos educarle o enseñarle trucos sin ser el dueño probablemente no nos hará caso.",
        size: 3,
        vida: 3,
        deporte: 4,
        intel: 3,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/akita-americano.html",
        n: "/img/razas/10.jpg",
      },
      {
        nombre1: "Akita Inu",
        nombre2: "Akita Japonés",
        pais_origen: "Japón",
        origen:
          "Proviene de la región japonesa de Akita, y de ahí su nombre. Los ancestros del akita inu eran perros de tamaño mediano, que se usaban para cazar osos y se conocían con el nombre de akita matagi. A partir de 1603, estos perros se usaron para peleas de perros y, con el fin de aumentar su fuerza y resistencia, se cruzaron con tosas y mastines. Los resultados fueron perros más grandes, pero sin las características de los perros de tipo spitz. Se dedicaron a repoblar la raza con líneas de perros akita matagi, dando origen al akita inu actual que, aunque es más grande que los akita matagi originales, conserva el tipo spitz y no tiene las características de mastín y ovejero alemán.",
        caracteristica:
          "Es muy sereno y tímido, mostrándose tranquilos la mayor parte del día y adoptando una actitud calmada incluso en momentos de estrés. Se trata de una raza de perro muy equilibrada, dócil y resuelta, que ofrece una lealtad a su amo muy marcada. Aunque es muy desconfiado con los desconocidos, se trata de un perro que no atacará sin motivo, solo ante la provocación y las muestras de agresividad. Es un excelente perro guardián.",
        recomendacion:
          "Por su denso pelo es aconsejable cepillarle diariamente, epecialmente en la época de muda. No te seguirá si no te considera un líder digno, por ese motivo nunca debes ceder ante sus exigencias.",
        ideal:
          "Los niños pequeños, especialmente del hogar, son muy queridos por el akita inu, que no dudará en protegerlos ante cualquier peligro y con los que se llevará de maravilla.",
        dato: "Cuenta la historia de un perro que todos los días recogía a su dueño, un profesor, en la estación de tren después del trabajo. Luego de su muerte, el perro siguió regresando cada día durante 10 años a la estación, esperando encontrarle. Fueron varias las personas que observaron el comportamiento de Hachiko en la estación de Tokio en 1925 y empezaron a ofrecerle comida y cuidados. Años después la cuidad entera conocía su historia y las autoridades erigieron en 1935 una estatua en su nombre.",
        size: 3,
        vida: 3,
        deporte: 2,
        intel: 3,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "inline",
        salud: "none",
        ladrido: "inline",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/akita-inu-o-akita-japones.html",
        n: "/img/razas/129.jpg",
      },
      {
        nombre1: "Alaskan Malamute",
        nombre2: "Malamute de Alaska",
        pais_origen: "Ártico",
        origen:
          "Eran empleados por el pueblo de los Mahle para tirar de sus trineos y colaborar en las actividades de caza en el ártico. Su nombre proviene de Mahle muit que significaría pueblo de los mahle.  Entre sus ancestros se encuentran el lobo ártico.",
        caracteristica:
          "Es un perro grande, muy fuerte y robusto que está adaptado para tirar de cargas muy pesadas como los trineos y hasta pesos de 40 kilogramos. No lo parece, pero también es un perro dócil, sociable y cariñoso, especialmente con sus dueños e incluso con desconocidos. Es un perro muy inteligente e independiente que no aceptará órdenes solo por el hecho de alimentarles cada día.",
        recomendacion:
          "Al estar con otras mascotas debemos estar siempre mirando, ya que por su fuerte instinto de jerarquía puede verse envuelto en agresiones. (otro de los motivos por los que necesita un dueño experimentado). Requiere ejercicio diario para gastar su alta energía.",
        ideal:
          "Esta raza tiene dos mantos y por esto está preparada para soportar temperaturas frías, pero las temperaturas elevadas pueden ser un problema muy serio. Un departamento o casa pequeña no es el lugar ideal para esta raza, asi como tampoco lo es un clima muy caluroso. Es preferible si se cuenta con un jardín o patio en el que el malamute pueda descargar su energía cada día.",
        dato: "Se considera una de las razas más longevas de la historia de los perros con trineo. Provienen de una tribu inuit, los Mahlemiut, conocidos por comer carne cruda y que forjaron una relación muy estrecha con la raza. Los perros gueron utilizados para el rescate en la segunda guerra mundial.",
        size: 3,
        vida: 2,
        deporte: 2,
        intel: 3,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/alaskan-malamute.html",
        n: "/img/razas/60.jpg",
      },
      {
        nombre1: "American Bully",
        nombre2: "",
        pais_origen: "USA",
        origen:
          "Proviene de EEUU. Se trata de una mezcla entre el american pit bull terrier y el american staffordshire terrier. Cuenta además con parientes más lejanos como el bulldog inglés y staffordshire bull terrier.",
        caracteristica:
          "Los criadores de esta raza buscaban que detrás de la apariencia fiera y ruda se encontrara un compañero fiel y familiar. No dudará en demostrar su valor a su familia ante cualquier peligro. Es muy inteligente, capaz de llevar a cabo habilidades muy distintas y diversas. El comportamiento con otras mascotas suele ser también excelente. Esta raza conoce bien sus cualidades físicas y tiende a controlar adecuadamente sus movimientos para no herir a perros o mascotas más pequeñas, con los que le encanta socializar y jugar. ",
        recomendacion:
          "Los cachorros deben recibir una dosis extra de calcio en su dieta, ya que la van a necesitar para el desarrollo de sus huesos que sostendrán más peso que otro perro de su misma estatura.",
        ideal:
          "Está recomendado para personas que entienden la psicología del perro y el comportamiento de éste dentro de la manada. Necesita un tutor firme, tranquilo y consecuente. Por ello, es importante que el propietario de este tome conciencia de lo que supone ser el líder de la manada y seguir ordenes y normas.",
        dato: "Es conocida como una de las razas que mejor socializa con niños.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/american-bully.html",
        n: "/img/razas/25.jpg",
      },
      {
        nombre1: "Appenzeller ",
        nombre2: "Perro Boyero de Appenzell",
        pais_origen: "Suiza",
        origen:
          "Esta raza de perros se originó en la región de los Alpes appenzellenses, en Suiza. Su nombre proviene de la región donde se originó, Appenzell. También se la conoce como boyero de los Alpes. Antiguamente era empleado como perro boyero y como guardián de propiedade.",
        caracteristica:
          "Es dinámico, vivaz y curioso. También staca por ser inteligente y muy apegado a su familia, aunque siempre prefiere la compañía de una persona en particular, a quien le entregará su amor incondicional. Suele ser desconfiado con los extraños, por lo que es importante sociabilizarlos desde cachorros. Se lleva bien con los niños y es fácil de educar.",
        recomendacion:
          "Necesitan mucho ejercicio diario debido a su carácter dinámico e infatigable.",
        ideal:
          "Le encanta hacer ejercicios para perros y jugar al aire libre, por lo que se recomienda tenerlo en viviendas grandes y espaciosas, y de ser posible con jardín o algún terreno para que corran.",
        dato: "Este perro pertenece a las cuatro razas de perros boyeros que hay en los Alpes, junto con el boyero de Berna, el boyero de Entlebuch y el gran boyero suizo.",
        size: 2,
        vida: 3,
        deporte: 4,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/appenzeller-o-perro-boyero-de-appenzell.html",
        n: "/img/razas/150.jpg",
      },
      {
        nombre1: "Aussiedoodle",
        nombre2: "Aussiepoo",
        pais_origen: "Australia",
        origen:
          "Esta raza híbrida surge en australia del cruce de pastor ovejero australiano y de diferentes tipos de caniche. Por esta razón recibe el nombre de aussiedoodle (caniche australiano en español).",
        caracteristica:
          "Tienen un carácter ejemplar. Es un perro cariñoso, atento, afectuoso y sumamente empático, que brindará atención y cariño a todo el que esté cerca. Son muy inteligentes, por lo que aprenden muy rápido, lo cual combinado con su predisposición para el trabajo hace que aprendan a una velocidad de vértigo. Además es sociable, dulce y afectuoso con todos.",
        recomendacion:
          "Estos perros son bastante activos, por lo que necesitan hacer ejercicio físico de forma diaria.",
        ideal:
          "Tienen una gran capacidad de adaptación, siendo posible que vivan tanto en departamentos como en casas, ya sea en el campo o en la ciudad. Aunque, dado que son perros activos, se aconseja que siempre tengan un lugar donde ir (parques, campos, jardines, etc...).",
        dato: "Hay ejemplares de ojos ámbar o con heterocromía, es decir, un ojo de color distinto al otro.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/aussiedoodle-o-aussiepoo.html",
        n: "/img/razas/40.jpg",
      },
      {
        nombre1: "Australian Cobberdog",
        nombre2: "",
        pais_origen: "Australia",
        origen:
          "Del cruce entre labradores y caniches surgen los labradoodle. Sin embargo, éstos comenzaron a cruzarse de forma incontrolada, surgiendo alteraciones y problemas en la raza. Por ello se desarrolló un exhaustivo programa de cría, creando una nueva línea genética orientada a conseguir perros idóneos para terapia, y surgieron los australian cobberdog. La raza fue reconocida como raza independiente en 2012 por el el registro internacional de perros de pura raza (MDBA).",
        caracteristica:
          "Son muy apreciados como perros de terapia, porque aprenden a una velocidad de vértigo. Sensibles, receptivos , cariñosos y atentos, estando siempre pendientes de las necesidades y el bienestar de los demás. También se llevan bien con todo el mundo, sin importar género, edad o especie.",
        recomendacion: "",
        ideal:
          "Nunca se mostrarán agresivos ni tampoco excesivamente activos. Por ello, son perros ideales para todo tipo de espacios y familias, teniendo unas grandes capacidades adaptativas.",
        dato: "Puede presentar diferentes tamaños, por lo que se han establecido tres tallas distintas: miniatura (33-43 cms) , mediano (43-50) y grande (50-58).",
        size: 2,
        vida: 3,
        deporte: 2,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/australian-cobberdog.html",
        n: "/img/razas/49.jpg",
      },
      {
        nombre1: "Azawakh",
        nombre2: "",
        pais_origen: "Malí",
        origen:
          "Es una raza canina nativa de África, cuyo nacimiento se atribuye a la región entre Malí y Níger, situada al sur del desierto del Sahara. Estos perros esbeltos empiezan a ser criados y son adoptados por los miembros de la tribu nómada africana llamada Tuareg.",
        caracteristica:
          "Se caracterizan por un comportamiento extremadamente enérgico, siendo casi inagotables y mostrando gran predisposición a la actividad física. Por eso necesitan una rutina adecuada de ejercicio físico y conservan un comportamiento estable en su hogar. También son perros independientes que necesitarán tener sus momentos de paz y tranquilidad, especialmente mientras duermen y se alimentan.",
        recomendacion:
          "Son muy atentos y tienen sentidos muy bien desarrollados, por lo que suelen responder rápidamente ante cualquier estímulo extraño en su entorno, así como verse afectados fácilmente por los síntomas de estrés. Por ello, necesitan vivir en un ambiente positivo y ser socializados correctamente desde sus primeros meses de vida.",
        ideal: "",
        dato: "Su color de pelaje y su cuerpo delgado les permitían camuflarse con facilidad entre la densa arena de las zonas desérticas africanas. Ello les daba una gran ventaja en el momento de alcanzar presas como liebres, gacelas, avestruces y fennecs, ya que también alcanzan velocidades de hasta 60 km/h al correr.",
        size: 2,
        vida: 3,
        deporte: 4,
        intel: 3,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/azawakh.html",
        n: "/img/razas/41.jpg",
      },
      {
        nombre1: "Basenji",
        nombre2: "",
        pais_origen: "África central",
        origen:
          "También conocido como perro del Congo, es una raza de perro cuyo origen se remonta a África central. Por otro lado, también se ha demostrado que los antiguos egipcios utilizaban a los basenjis para la caza y los apreciaban por su valentía y devoción para el trabajo.",
        caracteristica:
          "Es alerta, independiente, curioso y afectuoso. Puede ser desconfiado con los extraños y puede responder agresivamente a provocaciones, por lo que no es la mejor opción para familias con niños pequeños. Tiene una personalidad traviesa, juguetona y muy testaruda. Este perro pierde muy poco pelo, de manera que está considerado como perro hipoalergénico y que no produce ninguna reacción alérgica a su familia.",
        recomendacion:
          "La socialización desde cachorro es una necesidad básica debido a su pasado como cazador. Es muy activo y puede ser destructivo si no se le dá el ejercicio necesario. Requiere un compañero con mucha paciencia y constancia.",
        ideal:
          "Por su predisposición a la caza, este perro no suele ser recomendado para convivir con mascotas de otras especies. Puede vivir tranquilamente en un departamento si se le brindan paseos frecuentes y el ejercicio necesario para quemar la energía acumulada.",
        dato: "Tiene dos características peculiares: nunca ladra y las hembras entran en celo solo una vez al año.  La ausencia de ladrido no significa que el basenji sea un perro mudo; emite sonidos que podrían definirse como una mezcla de canto tirolés y risa ahogada.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 1,
        clima: 2,
        child: "none",
        depa: "inline",
        antig: "inline",
        salud: "inline",
        ladrido: "inline",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/basenji.html",
        n: "/img/razas/179.jpg",
      },
      {
        nombre1: "Basset Artesiano Normando",
        nombre2: "Basset Artesiano de Normandía",
        pais_origen: "Francia",
        origen:
          "En 1870 se empieza a regular la cría del basset francés de pelo corto. A partir de esa década, surgen dos variedades de basset franceses de pelo corto: el basset de Artois o sabueso artesiano (tenía las patas delanteras rectas) y el basset normando o basset de Normandía (tenía las patas delanteras semitorcidas). La raza fue creada para participar en la cacería, sobre todo de conejos.",
        caracteristica:
          "Se destaca por ser amigable, sociable y valiente, aunque a veces terco y tenaz. Además, es un buen perro para cazar, pero también es una excelente mascota.",
        recomendacion:
          "Su estructura desproporcionada lo hace susceptible a problemas de espalda y en la columna vertebral, por lo que necesita harto ejercicio físico.",
        ideal:
          "Debido a su carácter sociable y su gran resistencia, suele ser un buen perro para los niños y también llevarse bien con otros perros (aunque su naturaleza cazadora no lo hace muy afín a mascotas pequeñas). Se adapta fácilmente a la vida en departamento.",
        dato: "Se parece mucho a la raza basset hound, pero se diferencia en que es menos pesado.",
        size: 2,
        vida: 3,
        deporte: 2,
        intel: 1,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/basset-artesiano-normando-o-basset-artesiano-de-normandia.html",
        n: "/img/razas/166.jpg",
      },
      {
        nombre1: "Basset Hound",
        nombre2: "",
        pais_origen: "Francia",
        origen:
          "La palabra basset proviene del término francés bas, que significa bajo. Por esto, algunos autores sugieren que el basset hound proviene de perros enanos nacidos en camadas de sabuesos franceses. Otros autores indican que el basset hound se originó partir de líneas del bloodhound.",
        caracteristica:
          "Es un perro notoriamente más largo que alto, diseñado para seguir el rastro de una presa en terrenos difíciles. Su carácter es afable, divertido y con buen humor, algo que no calza con su aspecto triste y solitario. Es muy familiar y le encanta disfrutar haciendo juegos, paseos y excursiones. Debido a su instinto, son muy fáciles de entrenar para cazar.",
        recomendacion:
          "Tiende a engordar fácilmente. Por este motivo, los mejores ejercicios son las caminatas largas y frecuentes, así como permitirle correr y jugar con otros perros.",
        ideal:
          "Acepta la compañía de los niños y aguanta sus travesuras de forma paciente. Puede vivir tranquilamente en un departamento.",
        dato: "La marca de zapatos Hush Puppies usa la imagen del basset hound para su logo.",
        size: 2,
        vida: 2,
        deporte: 3,
        intel: 1,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/basset-hound.html",
        n: "/img/razas/168.jpg",
      },
      {
        nombre1: "Beagle",
        nombre2: "Beagle Inglés ",
        pais_origen: "Inglaterra",
        origen:
          "Los orígenes se remontan a Jenofonte, que en su Tratado sobre la Cacería habla de un sabueso que bien podría ser el Beagle primerizo. Más adelante fue pasando todas las etapas de la caza, desde los hombres primitivos hasta los hombres medievales, llegando a los nobles y reyes de los siglos XVIII (donde se hacía una selección más selecta) hasta que encontramos el Beagle actual.",
        caracteristica:
          "Son perros muy activos. Han sido perros cazadores y les encanta buscar presas, ladrar para avisar y traerlas. Es un perro activo e impulsivo que no dudará en ir de caza. Son uno de los mejores perros para niños, siendo muy cariñosos, pacientes y jugetones con ellos.",
        recomendacion:
          "Son perros que requieren una buena educación desde cachorros pues tienden a volverse autoritarios ante un propietario que no imponga sus normas del hogar.",
        ideal:
          "Están todo el día corriendo y jugando, por lo que se les hace mejor la vida con un jardín, sin importar el tamaño de éste. No son 100% incompatibles con departamentos, pero se necesitará sacarlo por lo menos dos veces al día.",
        dato: "Los nobles y reyes de los siglos XVIII eran fanáticos de los Beagles de bolsillo (antecesor de los beagles y que están extintos). Fueron muy disfrutados por personalidades muy distinguidas como la reina Isabel I.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 1,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/beagle.html",
        n: "/img/razas/134.jpg",
      },
      {
        nombre1: "Beauceron",
        nombre2: "Pastor de Beauce",
        pais_origen: "Francia",
        origen:
          "Es un perro netamente francés y se originó en las llanuras próximas a París conocidas como La Beauce. Antiguamente se utilizaba a estos perros para múltiples funciones, desde guiar los rebaños y protegerlos de las amenazas externas, hasta la protección de bienes y personas.",
        caracteristica:
          "Son confiados, valientes y leales. Tienden a ser animales muy inteligentes, capaces de aprender una diversidad de órdenes, trucos y acciones. Suelen ser muy leales y cariñosos con los suyos, pero desconfiados con los extraños.",
        recomendacion:
          "Si no reciben ejercicio suficiente o si pasan solos mucho tiempo, pueden convertirse en perros destructores o agresivos.",
        ideal:
          "Suelen tener un trato estupendo con personas, niños y todo tipo de animales. No obstante, si tenemos niños muy pequeños en el hogar tendremos que explicarles cómo tratar correctamente al perro. Demandan mucho ejercicio y compañía. No son mascotas para personas sedentarias y tampoco se adaptan con facilidad a la vida en un departamento. ",
        dato: "Estos perros fueron usados por el ejército francés en las dos guerras mundiales.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 5,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/beauceron-o-pastor-de-beauce.html",
        n: "/img/razas/194.jpg",
      },
      {
        nombre1: "Berger de Picardie",
        nombre2: "Pastor de Picardía",
        pais_origen: "Francia",
        origen:
          "Los primeros ejemplares de los que se tiene constancia compitieron en una exposición en el año 1863, en la misma categoría que Briards y Beacuerones. Años más tarde, ya en 1898, la raza fue aumentando su popularidad y mucho después, en 1922, se elaboró el primer estándar oficial a manos de Paul Megnin. En 1959 la raza tuvo el reconocimiento definitivo",
        caracteristica:
          "Es equilibrado y obediente. Hablamos también de un perro muy sociable, tanto con las personas como con otros animales.  Como perro pastor guardián de ovejas suele ser un perro muy fiel y protector con los suyos, especialmente con los niños, con quienes se relaciona estupendamente. Es un perro especialmente inteligente, por lo que no tendrá dificultades en la educación y el adiestramiento.",
        recomendacion:
          "Es un perro muy activo, por lo que necesitará realizar ejercicio regular. Es fundamental también la socialización del cachorro, un proceso especialmente importante que recomendamos empiece a las 3 semanas y termine a los 3 meses.",
        ideal: "",
        dato: "Su nombre hace referencia a la región de Picardie del norte de Francia. ",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/berger-de-picardie.html",
        n: "/img/razas/59.jpg",
      },
      {
        nombre1: "Bernedoodle",
        nombre2: "",
        pais_origen: "USA",
        origen:
          "Su origen ocurre en Estados Unidos, al cruzar los boyeros de Berna (berne-) con los caniches (-doodle). Este nacimiento se dio en 2003, momento en el que se establece el origen de la raza bernedoodle.",
        caracteristica:
          "Es atento, afable, pacífico y relajado. Suele desarrollar cierta dependencia hacia su familia, pero mostrarse desconfiado con los desconocidos.",
        recomendacion:
          "Son testarudos y hay que comenzar con su educación lo antes posible.",
        ideal:
          "No le gusta la soledad, especialmente si no ha sido educado para eso (puede a desarrollar depresión o ansiedad por separación). De esta forma, se trata de un perro que necesita atención y mucho mucho cariño y no es un bueno para aquellos que pasen mucho tiempo fuera de casa o no puedan dedicarle tiempo de calidad que necesita. Se adapta bien a la vida con personas mayores o en hogares en los que ya viven otros perros, gatos o animales.",
        dato: "Actualmente, la raza no consta como raza independiente, pues es considerada simplemente un cruce entre dos razas.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 2,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bernedoodle.html",
        n: "/img/razas/11.jpg",
      },
      {
        nombre1: "Bichón Boloñés",
        nombre2: "",
        pais_origen: "Mediterráneo",
        origen:
          "Se originó en el Mediterráneo. Sus ancestros, comunes con los del bichón maltés, ya eran conocidos en Italia y Malta en los siglos XI y XII. Durante el Renacimiento, la raza era muy popular en la ciudad italiana de Bolonia, que es de donde viene el nombre y donde se convirtió también en un obsequio entre familias pudientes.",
        caracteristica:
          "Se caracteriza por tener un carácter dócil, tranquilo y leal. En el hogar tiende a ser poco activo, aunque afuera es más enérgico. Es muy apegado a su familia humana, por lo que necesita compañía constante y puede llegar a ser muy tímido con las personas desconocidas. No requiere mucho ejercicio físico.",
        recomendacion:
          "Si pasa mucho rato solo tiene tendencia a desarrollar problemas de comportamiento como ansiedad por separación, ladridos excesivos, protección de recursos o volverse un perro destructor.",
        ideal:
          "Se recomienda su adopción a personas adultas o familias con niños no muy pequeños que puedan dedicar al animal el tiempo que necesita. Es una excelente raza para primerizos que deciden compartir su vida con un perro por primera vez.",
        dato: "Se trata de un perro digno de una corte, querido y respetado por los monarcas, las princesas y los condes. En los siglos XV y XVI, Felipe II lo denominó como el regalo más majestuoso que se le puede hacer a un emperador”. Años después sería plasmado por Goya, Ticiano y otros maestros de la pintura.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bichon-bolones.html",
        n: "/img/razas/101.jpg",
      },
      {
        nombre1: "Bichón Frisé",
        nombre2: "Bichón de pelo rizado",
        pais_origen: "España",
        origen:
          "En el siglo XII, en la cuenca del Mediterráneo, ocurrían cruces de barbet (un antiguo perro que actualmente está extinto) con perros falderos de color blanco. El resultado de esos cruces dio origen a la familia de perros barbichones y al caniche.  El bichón Tenerife es el ancestro directo del actual bichón frisé, y debía su nombre a que se desarrolló principalmente en la isla Canaria de Tenerife.",
        caracteristica:
          "Alegre, dinámico y juguetón, al mismo tiempo que sensible, cariñoso y gentil. Le encanta recibir el afecto de su familia, descansar con ellos en casa y disfrutar de su compañía.  Tienden a socializar con facilidad, ya sea con gente, perros u otros animales. Son perros muy inteligentes pero en algunos casos pueden ladrar excesivamente.",
        recomendacion:
          "Por su dinamismo suele necesitar más ejercicio que otros perros de su misma estatura. Prestarle la atención suficiente es fundamental para conseguir que viva sano y feliz.",
        ideal:
          "Son especialmente sociables con niños y excelentes para vivir en un departamento en la ciudad, ya que se adaptan muy bien a espacios reducidos y pueden hacer ejercicio dentro del departamento. No son perros que pueden pasar mucho tiempo solos, así que no son adecuados para gente que debe pasar largas horas fuera de casa y no puede llevar a su mascota consigo.",
        dato: " No pierden pelo.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "inline",
        antig: "none",
        salud: "inline",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bichon-frise.html",
        n: "/img/razas/184.jpg",
      },
      {
        nombre1: "Bichón Habanero",
        nombre2: "Bichón Habanés",
        pais_origen: "Mediterráneo",
        origen:
          "Esta raza comparte su origen con todos los demás bichones, que descienden de cruces de barbet (un perro antiguo ya extinto) y perros falderos de la cuenca del Mediterráneo.  En los siglos XVIII y XIX, marineros españoles llevaron algunos de estos bichones a Cuba, donde ganaron la preferencia de la aristocracia cubana de esa época. En ese entonces, éstos se conocían como blanquitos de la Habana porque eran perros exclusivamente blancos. Fue recién en el siglo XIX que apareció el bichón habanero moderno, gracias al aporte de sangre de caniches y poodles alemanes.",
        caracteristica:
          "Son muy juguetones, activos, vivaces e incluso un poco payasos. Al ser tan alegres y sociables, necesitan mucha compañía y mucha estimulación mental. Lamentablemente tienden a ladrar mucho y pueden sufrir ansiedad por separación si se les deja solos mucho tiempo. No requieren de mucho ejercicio.",
        recomendacion:
          "Pueden ser agresivos o tímidos cuando su socialización ha sido baja. Por eso, es importanteque desde cachorros estén con otras personas y animales.Tienen mucho gusto por la natación, así que no está de más brindarle la oportunidad de nadar en un lugar seguro.",
        ideal:
          "Se adaptan muy bien a la vida en departamento y a vivir en ciudades densamente pobladas. Necesitan estar acompañados casi todo el tiempo y no deben vivir aislados en un patio o jardín, no siendo muy adecuados para personas que trabajan durante largas horas o no tienen tiempo para estar con ellos.",
        dato: "Son perros muy inteligentes y fáciles de adiestrar, por lo que antiguamente eran muy utilizados en circos.",
        size: 1,
        vida: 3,
        deporte: 1,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bichon-habanero.html",
        n: "/img/razas/100.jpg",
      },
      {
        nombre1: "Bichón Maltés",
        nombre2: "",
        pais_origen: "Egipto",
        origen:
          "Fueron los fenicios quiénes llevaron de Egipto hacia Italia a los ancentros de esta raza hace más de 2000 años. Los orígenes están asociados a Italia, Malta y a la isla de Mljet (Croacia).  Es un perro de los más antiguos de Europa, destacaron en la época del Imperio Romano donde eran perros callejeros que eliminaban las ratas de las ciudades. En algún momento llamaron la atención de los nobles y se instauraron en las grandes casas donde eran muy mimados y consentidos. Siglos más adelante, en el Renacimiento, también fueron la compañía de las personas nobles.",
        caracteristica:
          "Es alegre y divertido, a la vez que cariñoso con su amo. Es un buen perro de compañía y para nada solitario, a quien le gusta disfrutar de personas y mascotas. Es protector y le encantará tener a su disposición juguetes y otras cosas para morder. Sufre si pasa demasiado tiempo solo en casa.",
        recomendacion:
          "Requieren unos cuidados extras que no son tan comunes en otras razas: cuidado de pelo, aseo y alimentos de buena calidad.",
        ideal:
          "Puede no relacionarse bien con niños que exijan demasiado juego, le manipulen en exceso o le traten como a un juguete.",
        dato: "En la tumba de Ramsés II se aprecian estatuillas de piedra con forma del maltés actual.",
        size: 1,
        vida: 3,
        deporte: 1,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "inline",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bichon-maltes.html",
        n: "/img/razas/144.jpg",
      },
      {
        nombre1: "Bloodhound",
        nombre2: "San Humberto",
        pais_origen: "Bélgica",
        origen:
          "Nacen en Bélgica. Su creación está tradicionalmente atribuida a los monjes de Saint-Hubert, que habitaban en el Monasterio de Andain, situado en la parte belga de Ardenas. Estos perros podrían haber permanecido aislados en esta región durante varios años, hasta que el rey Guillermo el Conquistador decide importar a Inglaterra algunos ejemplares durante el siglo XI.",
        caracteristica:
          "Es considerado como el más poderoso entre todos los perros de tipo sabueso, según el estándar oficial de la FCI. Su personalidad es amigable, dócil y bastante tranquila. Estos perros suelen formar un vínculo muy especial con sus tutores, a quienes demuestran extrema lealtad. Son sociables con personas y animales desconocidos, y suelen resultar especialmente gentiles y pacientes con los niños.",
        recomendacion:
          "No les gusta la soledad y, si pasan muchas horas solos pueden desarrollar problemas de comportamiento, como la destructividad o la ansiedad por separación. Tiene tendencia a engordar y sufrir obesidad, por lo que debemos cuidar su alimentación y motivarlos a moverse.",
        ideal:
          "Necesita espacio para desarrollarse y expresarse libremente. Lo ideal es contar con un espacio abierto de dimensiones razonables, como un patio o un jardín, donde tu perro pueda correr, saltar, jugar y explorar los estímulos a su alrededor.",
        dato: "Es una de las razas de perros más antiguas del mundo.",
        size: 3,
        vida: 2,
        deporte: 2,
        intel: 1,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "inline",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bloodhound-o-perro-de-san-huberto.html",
        n: "/img/razas/81.jpg",
      },
      {
        nombre1: "Bobtail",
        nombre2: "Viejo Pastor Inglés",
        pais_origen: "Inglaterra",
        origen:
          "No se conocen con certeza las razas de perros que dieron origen al viejo pastor inglés. Entre los posibles ancestros se sugieren al pastor de Brie, al bergamasco, a los collies barbudos (bearded collies) y a perros originarios de Rusia (la antigua raza Ovtcharka). Lo que sí se conoce sobre el origen de esta raza es que fue creada en en oeste de Inglaterra, durante el siglo XIX, por pastores que buscaban un perro ágil y resistente para llevar sus rebaños y ganado vacuno desde los campos hasta los mercados.",
        caracteristica:
          "Enamora a quienes han tenido uno, ya que la mayoría de personas se refieren a él como un perro muy humano por la confianza, cariño y bondad de la raza. En Inglaterra es conocido como nanni-dog, ya que se trata de un can paciente, afectuoso y en el que suelen confiar muchos padres en el momento de juego con los niños. Dócil y de buen carácter, el viejo pastor inglés es un perro fiel, adaptable y digno de confianza. Es muy fácil de entrenar.",
        recomendacion:
          "Tiene un instinto de pastoreo muy marcado que puede llevarlo a tratar de dirigir a los niños, empujándolos con el cuerpo.",
        ideal:
          "Necesita grandes dosis de ejercicio, no siendo aptos para personas sedentarias.",
        dato: "La cola amputada era una característica usada en el siglo XVIII para identificar a los perros pastores, de tal forma que sus dueños no pagaran impuestos por estos perros. La costumbre, aunque ya no es de utilidad, quedó fijada en el estándar de la raza. Además, se aprovecharon para la crianza aquellas líneas de cría que no tenían cola.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 3,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bobtail-o-viejo-pastor-ingles.html",
        n: "/img/razas/207.jpg",
      },
      {
        nombre1: "Bodeguero Andaluz",
        nombre2: "Ratonero Andaluz",
        pais_origen: "España",
        origen:
          "Tienen unas raíces fuertes en todo el sur de España. Antiguamente trabajaban en las bodegas, ya que son expertos cazadores de roedores y los mantenían alejados del vino. Sus ancestros son los terriers británicos, que fueron llevados por mercaderes ingleses a la zona de Cádiz.",
        caracteristica:
          "Destacan por la vitalidad y por ser un excelente compañero de juegos para los niños de la familia. Es cariñoso, leal y alegre. Así mismo, siempre está atento ante ruidos o movimientos a su alrededor, siendo buen perro guardián. Se trata de un animal con una excelente capacidad de adaptación a diferentes lugares y formas de vida, y es muy sociable tanto con los humanos como con otros animales.",
        recomendacion:
          "Debido a sus altos niveles de energía, necesita de actividad física diaria para mantenerse equilibrado y tranquilo.",
        ideal:
          "Es especialmente indicado para aquellas familias con niños, ya que es muy juguetón y sociable.",
        dato: "Se seleccionaban aquellos cuyo pelaje era de color blanco para así poder verlos cuando estuvieran en las oscuras bodegas.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bodeguero-andaluz-o-ratonero-andaluz.html",
        n: "/img/razas/96.jpg",
      },
      {
        nombre1: "Boerboel",
        nombre2: "",
        pais_origen: "Sudáfrica",
        origen:
          "En la época de la Guerra de Bóeres la colonia holandesa (que hasta entonces habitaba en Sudáfrica) esta raza pasó a manos del Imperio Británico, que utilizó a esta raza para proteger sus granjas. Sus antepasados son el bullmastiff, el gran danés y el bullensbeisser, este último un perro ya extinto. ",
        caracteristica:
          "Es un perro equilibrado, que disfruta de la relación con su familia. Sabe comportarse, ya que se trata de un perro muy obediente que durante siglos ha servido como perro de trabajo. No tiene miedo, es confiado y seguro de si mismo. Con los niños de la familia es conocido como afable, cariñoso y cuidadoso, aunque se trate de un perro de gran tamaño. Es un excelente perro guardián, inteligente y que aprende rápido.",
        recomendacion:
          "Es un perro desconfiado con desconocidos y con un un carácter sobreprotector, que le podría hacer atacar con cierta facilidad a quienes considera que nos hacen daño. Lo más importante es el ejercicio regular ya que necesita moverse, ejercitar su musculatura y liberar el posible estrés acumulado. Necesita grandes cantidades de alimento diario (entre 600 y 800 gramos).",
        ideal: "",
        dato: "Los primeros ejemplares de boerboel datan del año 1600.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/boerboel.html",
        n: "/img/razas/212.jpg",
      },
      {
        nombre1: "Border Collie",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Algunos restos arqueológicos encontrados indican que los antecesores directos de algunas razas de perros, entre ellas el border collie, llegaron a las islas británicas entre los siglos V y I antes de Cristo de la mano de tribus celtas. De hecho, se sospecha que su nombre podría provenir del idioma de estas comunidades, puesto que collie significa útil en gaélico. El border collie se acabó de desarrollar entre Escocia e Inglaterra. Su nombre significa literalmente collie de la frontera, por los establecimientos situados entre las fronteras de Esocia e Inglaterra.",
        caracteristica:
          "Es considerado el perro más inteligente del mundo según Stanley Coren, el profesor e investigador neuropsicológico del famoso libro La inteligencia de los perros (1994). Destaca por poseer una amplia capacidad de aprendizaje en distintos ámbitos: obediencia canina básica, avanzada, habilidades caninas o pastoreo. Destaca también por ser tremendamente ágil, con una forma física idónea para hacer ejercicio, saltar y correr.  Muy fiel a sus compañeros humanos y un observador nato, que rápidamente entiende la forma de expresar el dolor, la felicidad y la excitación de las personas. Con los desconocidos puede ser un poco tímido y reservado.",
        recomendacion:
          "Necesita tiempo y dedicación, a diferencia de otras razas más tranquilas. La falta de tiempo convierte a al border collie en un perro destructivo, hiperactivo, ansioso, nervioso e incluso ladrador.",
        ideal:
          "Se trata de un perro que debería vivir únicamente en entornos rurales, pero que con una buena rutina de paseos, ejercicio y estimulación se puede adaptar bien a la vida en una ciudad. Las familias activas, con pasión por el deporte, son ideales para esta raza. Requiere un núcleo familiar que pueda dedicarle tiempo y estimulación necesaria.",
        dato: "Se ha demostrado que esta raza canina tarda una media de cinco ejercicios en aprender una nueva orden, mientras que la media general de los perros de menor inteligencia se encuentra entre las 30 y 40 repeticiones. La popularidad de la raza Border Collie empezó por la afición de la Reina Victoria, la cual tenía diversos ejemplares.",
        size: 2,
        vida: 4,
        deporte: 3,
        intel: 6,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "inline",
        ladrido: "none",
        intel2: "inline",
        link: "https://www.expertoanimal.com/razas-de-perros/border-collie.html",
        n: "/img/razas/28.jpg",
      },
      {
        nombre1: "Border Terrier",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Se desarrolló en el área de Cheviot Hills, en la frontera entre Inglaterra y Escocia. De ahí viene su nombre, ya que en castellano significa terrier de la frontera. Originalmente se usaba para cazar zorros (una plaga para los granjeros de esa zona) dado su pequeño tamaño que le permitía entrar en las madrigueras y hacerlos huir. ",
        caracteristica:
          "Es muy activo, determinado y particularmente amigable con los niños. Tiene un fuerte impulso de presa, al mismo tiempo que es sociable. Suele aprender con facilidad.",
        recomendacion:
          "Necesita compañía frecuente y mucho ejercicio. De aburrirse o sentirse ansioso, tiende a destruir cosas o cavar en el jardín.",
        ideal: "",
        dato: "Es un perro que apenas pierde pelo.",
        size: 2,
        vida: 3,
        deporte: 2,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/border-terrier.html",
        n: "/img/razas/107.jpg",
      },
      {
        nombre1: "Borzoi",
        nombre2: "Galgo Ruso",
        pais_origen: "Rusia",
        origen:
          "Forma parte de la historia y de la cultura nacional de Rusia. Fue desarrollada directamente por los grandes zares, lo que podría explicar una morfología tan elegante y singular. Se estima que fue desarrollada hace más de nueve siglos.",
        caracteristica:
          "No es fácil determinar el carácter de la raza, pero en general se trata de un perro equilibrado y tranquilo. Por su pasado como perro de caza, el borzoi puede tener una rápida e impetuosa reacción en determinadas situaciones. Son reservados, independientes y desconfiados con los extraños.",
        recomendacion:
          "Se aconseja realizar un baño cada uno o dos meses, haciendo uso de un shampoo y acondicionador específico para perros, que nos ayudará a mantener el pelo suave y brillante.",
        ideal: "",
        dato: "Es una de las razas de perros rusos más populares y apreciadas de Rusia, pues forma parte inherente de la cultura popular.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 1,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/borzoi.html",
        n: "/img/razas/84.jpg",
      },
      {
        nombre1: "Boston terrier",
        nombre2: "",
        pais_origen: "USA",
        origen:
          "La raza fue desarrollada por un cochero que trabajaba para personas ricas de boston, en 1865. Este cochero se dedicó a realizar cruces entre los perros de raza de sus empleadores, y empezó cruzando un terrier inglés con un bulldog. Se utilizaron solamente con perros pequeños con bulldogs franceses, lo que explica el gran parecido que existe entre el boston terrier y el bulldog francés.",
        caracteristica:
          "Son amigables, sociables y gentiles. Además, son muy leales e inteligentes. Su buen carácter los ha convertido en mascotas predilectas de muchas familias en todo el mundo. Son muy amistosos con la gente y tienden a llevarse bien con otros perros y otras mascotas. Aprenden con mucha facilidad.",
        recomendacion:
          "No son buenos nadadores y debemos estar atentos ante la precencia de piscinas o lagos.",
        ideal:
          "Puede ser la mascota ideal tanto para expertos en perros como para propietarios novatos. Demandan mucha atención y compañía, lo que puede complicar a quienes no tienen el tiempo suficiente para una mascota.",
        dato: "Es considerado un perro universal, que se adapta muy bien a cualquier tipo de familia, lugar donde vivir y estilo de vida.",
        size: 1,
        vida: 3,
        deporte: 1,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "inline",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/boston-terrier.html",
        n: "/img/razas/203.jpg",
      },
      {
        nombre1: "Bóxer",
        nombre2: "Bóxer Alemán",
        pais_origen: "Alemania",
        origen:
          "Son descendientes directos del bulldog y del pequeño brabante o bullenbeisser, una raza desarrollada por los cazadores. La raza se desarrolló en Alemania, gracias a Friedrich Robert, Elard König y R. Höpner, fundadores del primer Deutscher Boxer Club en el año 1895. El término bóxer es de origen británico y se debe a la predisposición que muestra la raza por utilizar sus patas delanteras, como los boxeadores. Otra hipótesis señala que el término deriva de la palabra boxl en alemán, que se usaba para llamar a los bullenbeisser.",
        caracteristica:
          "Tienen un carácter fiel, alerta, activo y amistoso. Son perros sensibles y bondadosos cuando están bien socializados, y pueden llegar a ser especialmente protectores y pacientes con los niños, a quienes aman y cuidan. Crean un vínculo muy especial con sus tutores, de los que no se separan, pues hablamos de una raza muy apegada y complaciente. Tienen una mandíbula potente.",
        recomendacion:
          "Tiene una gran fuerza física, por lo que se deben supervisar siempre los juegos con animales pequeños o niños.",
        ideal:
          "Puede encajar con distintos tipos de familias, que incluyan o no niños, siempre que tengan un estilo de vida activo y entusiasta.",
        dato: "Fue utilizado durante la Segunda Guerra Mundial como perro de guerra mensajero (entregando cables de comunicación) y como perro ambulancia (transportando cuerpos de soldados heridos).",
        size: 2,
        vida: 1,
        deporte: 3,
        intel: 3,
        clima: 3,
        child: "inline",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/boxer.html",
        n: "/img/razas/83.jpg",
      },
      {
        nombre1: "Boyero de Berna",
        nombre2: "Boyero de Montaña Bernés",
        pais_origen: "Suiza",
        origen:
          "Es un antiguo perro de granja que habitaba en la zona pre-alpina y parte de la llanura de las cercanías de Berna, Suiza. En esa región era comúnmente empleado como perro guardián, perro boyero y perro de tiro (tirando de pequeños carros con productos para el comercio, principalmente leche y sus derivados).",
        caracteristica:
          "Es un perro excelente para todo tipo de familias, siempre que tengan un estilo de vida activo y lleno de estímulos que animen a este perro a desarrollar todas sus capacidades, tanto físicas como mentales. Es un perro tranquilo dentro del hogar, independiente, seguro, dócil y pacífico. Puede relacionarse perfectamente con otros animales.",
        recomendacion:
          "Son muy inteligentes, por lo que será recomendable añadir a su educación y estimulación diaria juegos de inteligencia y actividades variadas que le ayuden a estar activo mentalmente. El choque térmico también es muy común debido al grueso pelaje, así que hay que tener precauciones para evitarlo si es que vives en un lugar templado o cálido.",
        ideal:
          "No es recomendable adoptarlo si se es una familia sendentaria, puesto que necesita altas dosis de deporte. Es perfecto tanto para familias adultas como para los que tienen niños.",
        dato: "Hoy en día esta raza es la más popular de todos los perros de montaña suizos, y tiene aficionados en diferentes partes del mundo.",
        size: 3,
        vida: 1,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/boyero-de-berna.html",
        n: "/img/razas/131.jpg",
      },
      {
        nombre1: "Boyero de Flandes",
        nombre2: "Bouvier des Flandres",
        pais_origen: "Francia",
        origen:
          "Se originaron en la Región Flamenca, también llamada Flandes, compartida por Bélgica y Francia. Es por eso que la FCI los considera de origen Franco-Belga. El nombre bouvier des Flandres es francés y en castellano significa boyero de Flandes, lo que denota su origen y su función como perros guías de ganado vacuno.",
        caracteristica:
          "Son inteligentes, enérgicos y con un temperamento estable. Por su pasado como perros multipropósito en granjas belgas, tienden a ser excelentes guardianes y protectores, pero necesitan de compañía gran parte del día. Tienden a ser esconfiados de los extraños y pueden ser agresivos con perros del mismo sexo. Tienen una excelente memoria, por lo que sorprenden a más de uno con sus habilidades cognitivas.",
        recomendacion:
          "Con la socialización correcta, pueden convertirse en excelentes mascotas y llevarse bien con personas, perros y otros animales. Requieren mucho ejercicio físico y mucha compañía. Tampoco son perros para dejar aislados en el jardín, sino que deben pasar la mayor parte del tiempo con sus familias.",
        ideal:
          "Pueden llegar a adaptarse a la vida en departamentos si reciben suficiente ejercicio al aire libre, pero viven mejor en casas con amplios jardines.",
        dato: "El estándar de la raza publicado por la FCI indica que la cola debe ser amputada por encima de la segunda o tercera vértebra, excepto en los países en que esta práctica está prohibida.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/boyero-de-flandes.html",
        n: "/img/razas/182.jpg",
      },
      {
        nombre1: "Braco Alemán de pelo corto",
        nombre2: "",
        pais_origen: "Alemania",
        origen:
          "La historia de esta raza de perros cazadores es poco conocida y muy confusa. Se piensa que lleva sangre de pointer español y pointer inglés, además de otras razas de perros cazadores, pero no se conoce con certeza su genealogía y su momento de origen.",
        caracteristica:
          "La naturaleza cazadora de este braco define su temperamento. Éste es un perro activo, vivaz, curioso e inteligente que disfruta de actividades al aire libre en compañía de su familia. Suelen ser animales ruidosos, ladrando con frecuencia.",
        recomendacion:
          "Si va a convivir con mascotas pequeñas, es importante hacer mucho énfasis en su socialización desde cachorro, ya que sus instintos cazadores pueden aflorar cuando adulto.",
        ideal:
          "Si se cuenta con un lugar adecuado y con el tiempo suficiente para mantener a estos perros, pueden convertirse en excelentes mascotas para personas y familias dinámicas que disfrutan de actividades al aire libre.No suelen ser buenas mascotas para personas o familias sedentarias o que viven en departamentos.",
        dato: "Es una de las razas de perros más saludables.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/braco-aleman-de-pelo-corto.html",
        n: "/img/razas/127.jpg",
      },
      {
        nombre1: "Braco Francés tipo Pirineos y Gascuña",
        nombre2: "",
        pais_origen: "Francia",
        origen:
          "Aunque se desconoce el inicio exacto de la raza, se estima que los primeros ejemplares surgieron a comienzos del siglo XVIII en la región sur de los Pirineos franceses. Por su genética, se cree que tiene relación con otras razas caninas, como el braco alemán o el pointer inglés.",
        caracteristica:
          "Increíblemente leal y fiel, son un excelente compañero para todos. Se lleva bien con todo tipo de personas, sin importar la edad o condición. Les encanta pasar tiempo con niños, a quienes cuidan muy bien y con quienes les encanta jugar. Son abiertos y sociables, interactuando incluso con extraños. A veces pueden ser un poco dominantes.",
        recomendacion:
          "Requiere socialización, pues sobre todo de pequeños pueden mostrarse tímidos y desconfiados a tratar con personas y situaciones nuevas. En esta raza también resulta fundamental acostumbrar al cachorro a pasar cortos períodos de tiempo solo, para evitar problemas ante la soledad cuando crezca. Es un perro sumamente activo que requiere realizar ejercicio a diario.",
        ideal: "",
        dato: "Son una de las razas con mejores capacidades olfativas y adaptativas.",
        size: 3,
        vida: 3,
        deporte: 4,
        intel: 5,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/braco-frances-tipo-pirineos-y-gascuna.html",
        n: "/img/razas/38.jpg",
      },
      {
        nombre1: "Braco húngaro",
        nombre2: "Vizsla",
        pais_origen: "Hungría",
        origen:
          "Los ancestros del braco húngaro de pelo corto eran perros que acompañaban a las tribus nómades de los Magyares, que ocupaban Europa central. Existen documentos del siglo XIV que hacen referencia a perros muy similares al vizsla, pero recién en el siglo XVIII cobra importancia como perro de caza y especialmente de muestra.",
        caracteristica:
          "Son perros que forman un vínculo muy estrecho con sus familias y tienden a estar todo el tiempo siguiendo a una persona. También son perros muy inteligentes, curiosos y dinámicos. Son grandes cazadores y todo el tiempo están dispuestos a buscar y señalar pequeños animales, especialmente aves. No suelen ser perros ladradores, aunque tienden a ser muy protectores de sus territorios y sus familias.",
        recomendacion: "Tiene necesidades de ejercicio y compañía muy altas.",
        ideal:
          "No son buenas mascotas para personas y familias sedentarias que prefieren pasar las tardes viendo películas, ya que tienen mucha energía. En cambio, son excelentes mascotas para familias o personas solas que disfrutan haciendo deporte y actividades al aire libre. No se adaptan muy bien a la vida en departamento si eso conlleva realizar pocos paseos o no poder realizar actividades fisicas.",
        dato: "Una de sus cualidades más notorias es la fascinación que tienen por el agua. Estos perros disfrutan mucho lanzarse al agua y nadar.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/braco-hungaro-o-vizsla.html",
        n: "/img/razas/188.jpg",
      },
      {
        nombre1: "Braco Italiano",
        nombre2: "",
        pais_origen: "Italia",
        origen:
          "Sus orígenes son remotos, pues surgieron en la Baja Edad Media, siendo descendientes de los mastines asiáticos y los perros de San Huberto. Las localidades en las que surgieron fueron Lombardía y Piamonte, extendiéndose por toda Italia en poco tiempo. La raza atravesó momentos difíciles durante la Segunda Guerra Mundial y se vio abocada a la desaparición. Por suerte, un grupo de protectores y criadores italianos consiguió preservarla y que esta volviera a desarrollarse, recuperándola y perpetuándola hasta la actualidad con un rotundo éxito.",
        caracteristica:
          "Tiene un temperamento noble y dócil, siendo un perro muy sociable. Atento, respetuoso y paciente, rasgos de personalidad ideales sobre todo si la familia está formada por niños pequeños.  Se peorta muy bien con otros animales.",
        recomendacion:
          "Necesitan alta necesidad de ejercicio físico. En casos de inactividad prolongada, pueden aparecer problemas como agresividad, depresión, ansiedad o comportamientos destructivos.",
        ideal:
          "Aunque se adaptan perfectamente a la vida en interiores, es decir, departamentos más o menos reducidos, es preferible que tengan espacio al aire libre donde ejercitarse y jugar libremente. Si vivimos en ciudad tendremos que realizar varios paseos y ejercicios con ellos a diario.",
        dato: "Son considerados como uno de los mejores perros de caza, sobre todo en la caza de aves.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/braco-italiano.html",
        n: "/img/razas/72.jpg",
      },
      {
        nombre1: "Broholmer",
        nombre2: "",
        pais_origen: "Dinamarca",
        origen:
          "Los ancestros del broholmer eran empleados en el norte de Europa durante la Edad Media para la caza de ciervo. Luego se utilizaron como guardianes para tierras feudales y granjas. El nombre de la raza proviene de la región de Broholm-Funen donde se originó.",
        caracteristica:
          "Es un excelente guardián, ya que siempre está alerta y es desconfiado de los desconocidos. Sin embargo, es un perro muy tranquilo y amigable, que combina bien el hecho de ser sereno pero con mucha energía. No se lleva bien con otros perros porque es muy territorial.",
        recomendacion:
          "Es importante educarlo y socializarlo correctamente desde cachorro, para alentarlo a relacionarse bien con las demás personas, los demás animales y su entorno. Tienen mucha energía y necesitan liberarla, por lo que necesitan largos paseos y espacio para correr.",
        ideal:
          "Por su tamaño, estos perros no se adaptan a la vida en departamentos o casas pequeñas, así que necesitan contar con un jardín amplio o vivir en una propiedad rural donde tengan más libertad.",
        dato: "Cayó en el olvido durante las guerras mundiales, y prácticamente desapareció. Fue en la década de 1970 que una sociedad de aficionados daneses, con apoyo del Kennel Club de Dinamarca, reconstruyó y recuperó la raza.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 2,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/broholmer.html",
        n: "/img/razas/152.jpg",
      },
      {
        nombre1: "Bull Terrier Inglés Miniatura",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          " Se desarrolló esta raza para el control de plagas de ratas, por lo que se seleccionaron solo ejemplares bull terrier de tamaño pequeño.",
        caracteristica:
          "Es una réplica en miniatura del Bull Terrier. Juguetón, activo, comprensivo y tozudo. Le gusta dormir, e incluso puede ser un poco flojo. Sociable y familiar, es muy fiel a su manada e incluso un poco sobreprotector. Es un perro difícil de adiestrar, necesitarás de mucha paciencia y cariño.",
        recomendacion:
          "Necesitará ejercicio diario y regular para no perder su forma física y manejar la ansiedad.",
        ideal: "",
        dato: "En el siglo 19 en Inglaterra existía un extraño deporte en el que se apostaba por cazar y matar ratas. Esta pequeña raza era extremadamente buena en ello.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bull-terrier-ingles-miniatura.html",
        n: "/img/razas/98.jpg",
      },
      {
        nombre1: "Bull Terrier Inglés",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Cuando las peleas de toros fueron prohibidas por ley en Gran Bretaña, allá por el 1835, se desarrollaron cruces entre los bulldog y perros terrier para conseguir animales más ligeros pero igualmente tenaces, capaces de resistir y dar lucha en el nuevo deporte: las peleas de perros. Así surgieron los ancestros del bull terrier actual, que se conocían como bull and terrier, debido a los cruces involucrados.",
        caracteristica:
          "Si está bien educado tiene un carácter equilibrado y afectuoso con las personas. Son perros fieles por naturaleza y realmente afectuosos. Además son valientes, puesto que tienen un fuerte sentido de protección y es un excelente perro guardián.",
        recomendacion:
          "Es importante preguntar en tu zona si esta raza es considerada potencialmente peligrosa, puesto que en algunos lugares lo es y en otros no. En caso de si entrar en esa categoría, será básico el uso del bozal y la correa en espacios públicos. Es recomendable supervisar siempre su juego con niños que no sepan cómo deben relacionarse con un perro. En invierno es aconsejable ponerle algún tipo de abrigo. Los bull terrier tienden a comer en exceso si se les da la oportunidad, así que debemos informarnos sobre cuánto alimento hay que darle.",
        ideal:
          "Sufre mucho con la soledad, de manera que evitaremos a toda costa adoptar a un perro de estas características si no tenemos tiempo para dedicárselo.",
        dato: "Ocurrió una vez en Estados Unidos que la policía fue alertada por la aparición de un cadáver. Al llegar allí se encontraron a un bull que se negaba a separarse del cuerpo del que hasta ahora, había sido su dueño. El perro consiguió mantener a 38ºC el cuerpo de éste durante días, apunto de fallecer él también por deshidratación. Una vez que consiguieron separarlo, el can fue a parar a un refugio de animales, pero encontró familia facilmente porque su historia dio la vuelta al mundo.",
        size: 2,
        vida: 3,
        deporte: 4,
        intel: 2,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bull-terrier-ingles.html",
        n: "/img/razas/130.jpg",
      },
      {
        nombre1: "Bulldog Americano",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Sus orígenes se remontan a los perros de combate y caza mayor que se usaban ya en la primera mitad del siglo I. En el siglo XIX llega a su auge el deporte de peleas entre perros y toros, en el cual se usaban perros bulldog. En 1835 las autoridades británicas lo prohíben y los bulldog van desapareciendo gradualmente. Con el tiempo ocurren cruces de ésos con perros más bajos y menos agresivos, los que darían origen al bulldog inglés actual.",
        caracteristica:
          "Es típico es un perro determinado y valiente, pero no debe ser innecesariamente agresivo. Excelente guardián, puede ser agresivo con extraños y con otros perros, y además es excelente cazador. El problema es que es díficil de adiestrar, siendo muy testarudo y llevado a sus ideas.",
        recomendacion:
          "Es muy importante socializarlo desde cachorro y entrenarlo en obediencia para que desarrolle el autocontrol necesario.",
        ideal:
          "Necesitan mucho ejercicio, así que es mejor si cuentan con un jardín donde poder correr con libertad. Necesita un amo firme, tranquilo y consecuente.",
        dato: "Es una de las razas con menos problemas hereditarios, siendo un perro muy saludable.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 1,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "inline",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bulldog-americano.html",
        n: "/img/razas/117.jpg",
      },
      {
        nombre1: "Bulldog francés",
        nombre2: "",
        pais_origen: "Francia",
        origen:
          "En la segunda mitad del siglo XIX, durante la revolución industrial, muchos obreros ingleses migraron a Francia. Una gran parte de esos obreros provenía de la ciudad inglesa de Nottingham, donde eran muy apreciados los perros bulldog y que fueron llevados a Francia por sus propietarios. Allí los pequeños bulldog de orejas erguidas causaron sensación, y los comerciantes de mascotas se encargaron de importar más y más hasta que empezaron a conocerse como bouledogue Francais o bulldog francés.",
        caracteristica:
          "Son amigables, juguetones, muy sociables y dulces. Se puede decir que son los perros falderos perfectos. Estos bulldog tienden a socializar fácilmente, ya sea con gente, perros u otros animales. Suelen llevarse muy bien con niños, pero pueden llegar a ser muy demandantes de compañía.",
        recomendacion:
          "Su gran necesidad de compañía puede desarrollar ansiedad por separación con cierta facilidad. No es un buen nadador y debemos tener cuidado con las piscinas.",
        ideal:
          "Son muy recomendables para familias con niños grandes o personas que viven solas. Pueden ser excelentes mascotas para la mayoría de las personas. Se adaptan con mucha facilidad a la vida en departamentos y en grandes ciudades.",
        dato: "Para finales del siglo XIX habían sido adquiridos por familias de alta alcurnia. Es a partir de entonces que la raza cobró mayor protagonismo en Francia y Europa.",
        size: 2,
        vida: 2,
        deporte: 1,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "inline",
        antig: "none",
        salud: "none",
        ladrido: "inline",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bulldog-frances.html",
        n: "/img/razas/197.jpg",
      },
      {
        nombre1: "Bulldog inglés",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Desciende de perros que eran empleados para manejar, acorralar y atacar a toros y vacas en Gran Bretaña. Esas costumbres dieron origen a las peleas de perros con toros y otros animales grandes, deporte que fue prohibido en el siglo XIX. Algunos inmigrantes ingleses radicados en los Estados Unidos mantuvieron la raza con pocos cambios, dando origen a los ancestros del bulldog americano.",
        caracteristica:
          "Es un perro determinado, fuerte, alerta, valiente y leal. También es afectuoso, calmado y tranquilo, aunque también son tenaces cuando quieren algo. No es muy ladrador, pero puede ser agresivo con otros perros (especialmente si son del mismo sexo) y con otras mascotas. Puede ser muy baboso.",
        recomendacion:
          "Demanda mucha atención y no es un animal que deba dejarse solo por períodos largos. Además, el calor es un riesgo para su salud y debemos estar atentos en verano.",
        ideal:
          "Son ideales para aquellas familias en las que se le dedique una especial atención a las mascotas, ya que es un perro que necesita estar continuamente en contacto con sus dueños.",
        dato: "Se dice que es tan leal que es imposible que cambie de dueño.",
        size: 2,
        vida: 1,
        deporte: 2,
        intel: 1,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "inline",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bulldog-ingles.html",
        n: "/img/razas/198.jpg",
      },
      {
        nombre1: "Bullhuahua",
        nombre2: "",
        pais_origen: "?",
        origen:
          "Proviene de cruces entre ejemplares de bulldog francés y de chihuahua. Pese a la creciente popularidad de la raza, se desconocen el lugar y el momento donde tiene su origen, pues no se cuenta con registros sobre los primeros ejemplares.",
        caracteristica:
          "Tiene un carácter bastante fuerte, algo normal si tenemos en cuenta las dos razas de las que provienen. Son obstinados y cabezotas, por lo que a veces pueden hacer que perdamos la paciencia. Sin embargo, suelen ser amigables y cariñosos, pero muy desconfiados ante los desconocidos, a quienes suelen ladrar cuando entran en su territorio. Son dependientes de su familia y necesitando afecto y atención constantes, pues de lo contrario suelen volverse ariscos y bastante malhumorados.",
        recomendacion:
          "Debemos poner límites a nuestro cachorro, pues pese a su carita de no haber roto un plato, si no les guiamos se vuelven gruñones y muy mandones. Son dependientes, necesitando afecto y atención constantes, sino suelen volverse mañosos y bastante malgenios. En climas fríos necesita que se le ayude a mantener su temperatura corporal con chalecos o abrigos. Si no realiza un mínimo de actividad física, se vuelve nervioso y comienza a tener diversos problemas de salud.",
        ideal: "",
        dato: "A pesar de que tanto el chihuahua como el bulldog francés cuentan con una buena cantidad de enfermedades congénitas que pueden afectarles, el bullhuahua no ha heredado casi ninguna de ellas.",
        size: 1,
        vida: 4,
        deporte: 3,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bullhuahua.html",
        n: "/img/razas/39.jpg",
      },
      {
        nombre1: "Bullmastiff",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Se originó en Gran Bretaña a fines del siglo XIX. Para protegerse y facilitar su trabajo, los guardabosques usaban perros, pero las razas que usaban (bulldog y mastiff) no daban buenos resultados, así que decidieron probar con cruces entre ambos. El resultado fue el bullmastiff, que resultó ser muy sigiloso, contar con un buen olfato y ser lo suficientemente fuerte para contener a un hombre adulto sin necesidad de morderlo.",
        caracteristica:
          "Es muy cariñoso y amigable con los suyos. No se trata de un perro juguetón y altamente sociable, sino más bien de un tranquilo perro familiar. Sólo requieren ejercicio moderado que puede cubrirse con los paseos diarios.",
        recomendacion:
          "Cuando no ha sido correctamente socializado tiende a ser desconfiado y cauto, e incluso agresivo, con personas y perros desconocidos.",
        ideal: "No es recomendado para entrenadores o propietarios novatos.",
        dato: "Algunos criadores españoles apoyan la hipótesis de que se originó en España, y que era nada más y nada menos que el alano de toros o perro de toros que se usaba en las corridas a principios del siglo XIX. Sin embargo, estas pistas no son suficientes para cambiar la nacionalidad de la raza.",
        size: 3,
        vida: 1,
        deporte: 2,
        intel: 2,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/bullmastiff.html",
        n: "/img/razas/187.jpg",
      },
      {
        nombre1: "Ca De Bou",
        nombre2: "Dogo Mallorquín",
        pais_origen: "España",
        origen:
          "En 1232 el rey Jaime I conquistó el archipiélago de las Islas Baleares. Junto a él viajaban varios perros de gran tamaño y fortaleza, entre alanos y dogos de la Península Ibérica. Esos perros darían origen al actual dogo mallorquín o ca de bou.",
        caracteristica:
          "Es un perro duro, valiente y decidido. Como muchos perros molosos, el dogo mallorquín también es tranquilo, equilibrado y muy fiel con los suyos, por lo que es un excelente guardián y protector de su familia. No suele ladrar sin motivo pero es muy desconfiado con los extraños.",
        recomendacion:
          "Tiende a ser agresivo con otros perros si no está bien socializado y necesitan una buena dosis de ejercicio diario.",
        ideal:
          "Aunque no son perros muy altos, no se adaptan bien a la vida en departamentos pequeños ni en áreas urbanas densamente pobladas, por lo que es recomendabletener un amplio espacio dónde vivir (y mejor si es al aire libre).",
        dato: "En catalán, ca de bou significa  perro de toros , y recibieron este nombre porque antiguamente se enfrentaban a los toros en las clásicas peleas de la época.",
        size: 2,
        vida: 2,
        deporte: 3,
        intel: 2,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/ca-de-bou-o-dogo-mallorquin.html",
        n: "/img/razas/151.jpg",
      },
      {
        nombre1: "Cairn Terrier",
        nombre2: "",
        pais_origen: "Escocia",
        origen:
          "En el siglo XV eran un tipo de perros cazadores de patas cortas en la isla escocesa de Skye, que eran empleados para cazar zorros, tejones y nutrias. También tenían la particularidad de ahuyentar a las nutrias de los montículos de piedra que se usaban como señales de referencia o como monumentos conmemorativos. Esos montículos se conocen en inglés como cairn y de ahí sale el nombre de esta raza.",
        caracteristica:
          "Es muy resistente al clima. Son perros muy confiados y seguros de sí mismos, que llaman la atención por su audacia. No deben ser agresivos, pero tienen tendencia a ladrar mucho y a destruir el jardín, tendiendo a cavar la tierra. Aprenden rápidamente, pero también se aburren con facilidad.",
        recomendacion:
          "Demandan mucha compañía y no se los puede dejar solos por mucho tiempo.",
        ideal: "",
        dato: "La raza se hizo especialmente popular en Estados Unidos porque un cairn terrier interpretó el papel de Toto en la película El mago de Oz.",
        size: 2,
        vida: 3,
        deporte: 2,
        intel: 4,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/cairn-terrier.html",
        n: "/img/razas/106.jpg",
      },
      {
        nombre1: "Calupoh",
        nombre2: "Perro Lobo Mexicano",
        pais_origen: "México",
        origen:
          "Se originó entre el cruce de el Lobo Gris Mexicano y diversas razas de perros, las cuales se llevaron a cabo en México hasta antes del siglo XVI. En esa época, el lobo era asociado a sacrificios muy sangrientos, mientras que el perro era considerado como un cánido muy fértil, relacionado con el ciclo de la lluvia y agrícola. El cruce era para buscar una raza que tuviese las cualidades de ambas especies y poder usarlo para la agricultura y la guerra. ",
        caracteristica:
          "Es un perro noble, fiel, leal, estable y muy tolerante. Al igual que los lobos, son tímidos con las personas desconocidas. Es  dinámico, ágil, activo y fácil de entrenar y manejar.",
        recomendacion:
          "Requiere mucho espacio para que corran, debido a que tienen mucha más energía que otras razas de perro por sus antepasados salvajes. Les gusta estar muy activos, buscando lo que sea para jugar, y es raro que se cansen. Es importante darles mucha comida y agua por su elevado tamaño y actividad física.",
        ideal: "",
        dato: "Se trata de la tercera raza de perros mexicanos, precedido por el chihuahua y el xoloitzcuintle.",
        size: 3,
        vida: 4,
        deporte: 2,
        intel: 3,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/calupoh-o-perro-lobo-mexicano.html",
        n: "/img/razas/3.jpg",
      },
      {
        nombre1: "Can de Palleiro",
        nombre2: "",
        pais_origen: "España",
        origen:
          "Se desarrolla en Galicia, principalmente como perro guardián de fincas rurales y de pastoreo de rebaños. La historia de esta raza parece ser realmente antigua, ya que proviene de los perros autóctonos que ya en el Paleolítico ayudaban a los gallegos en sus quehaceres diarios.",
        caracteristica:
          "Tiene un carácter indiferente y hasta desconfiado con los extraños. Nos alertará debidamente ante la visita de otras personas a nuestro hogar, aunque eso no significa que debamos dejarle en el exterior. Es muy sociable con la familia y con otras mascotas, y nos sorprenderá con una notable inteligencia y sensibilidad.",
        recomendacion:
          "A la hora de evaluar si el perro debe estar dentro o fuera de casa debemos tener muy en cuenta que ello puede provocar la aparición de problemas del comportamiento. Esta raza requiere actividad física diaria para mantener su musculatura a tono. También es importante socializándolo en su etapa de cachorro.",
        ideal: "",
        dato: "Es la única de las razas de perros españoles que se desarrolla en Galicia, una comunidad autónoma situada en el noroeste de la Península Ibérica.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/can-de-palleiro.html",
        n: "/img/razas/74.jpg",
      },
      {
        nombre1: "Cane Corso",
        nombre2: "Mastín Italiano",
        pais_origen: "Italia",
        origen:
          "Es descendiente directo del molossiano romano, conocido como canis pugnax, un enorme moloso que se utilizaba en el primer siglo como perro de guerra. Trabajaba en el mismo campo de batalla, junto a los combatientes, y era un excelente perro guardián. ",
        caracteristica:
          "Son muy buenos guardianes, ya sea para proteger la familia, el ganado o una casa. Es un perro muy independiente y seguro de si mismo, generalmente territorial y muy protector. Crea un vínculo muy estrecho con sus familiares, especialmente con los niños, y es distante con las personas desconocidas.",
        recomendacion:
          "Es muy importante iniciar la educación sobre las 3 semanas de vida y hasta las 12, en pleno período de socialización. Le enseñaremos a inhibir la mordida y a estar con personas desconocidas y otros animales.",
        ideal:
          "Es ideal para familias activas y con experiencia. Se recomienda su tenencia en entornos rurales en los que puedan ejercitarse y mostrar su conducta natural, no obstante no es un perro que deba vivir en el exterior porque su manto es muy fino y sensible.",
        dato: "Su nombre deriva del latín cohors que significa protector y guardián del corral.",
        size: 3,
        vida: 2,
        deporte: 2,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/cane-corso-o-mastin-italiano.html",
        n: "/img/razas/145.jpg",
      },
      {
        nombre2: "Caniche Toy",
        nombre1: "Poodle Toy",
        pais_origen: "Portugal",
        origen:
          "Es un descendiente directo del barbet, una raza de origen africano que llegó a la Península Ibérica para cruzarse con perros de agua portugueses. Gracias a su carácter sociable, extremadamente fiel y positivo, éstos dejaron de ser perros cazadores para convertirse en animales domésticos. En la Francia del siglo XV se consideraría la raza de perro nacional de Francia.",
        caracteristica:
          "Son perros activos, obedientes e inteligentes, lo que permite que sea una raza fácil de entrenar y educar. Requiere pocas repeticiones para comprender una órden, ejercicio o situación, y es capaz de desarrollar acciones o rutinas a la perfección.",
        recomendacion:
          "Tenemos que estar atentos a posibles signos de enanismo, pues sería patológico que estos aparecieran. La soledad excesiva y reiterada puede provocar que este perro tenga conductas malas como la destructividad, el estrés o la vocalización. La etapa más importante será el período de socialización, que recomendamos que empiece a las 3 semanas y termine a los 3 meses de vida.",
        ideal:
          "Es ideal para familias con niños, pues dado su buen carácter y su energía, es el compañero ideal para los pequeños de la casa. También es capaz de socializar estupendamente con otras mascotas y personas de edad avanzada.",
        dato: "Es considerado el perro más inteligente del mundo según Stanley Coren.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 6,
        clima: 2,
        child: "inline",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "inline",
        link: "https://www.expertoanimal.com/razas-de-perros/caniche-o-poodle-toy.html",
        n: "/img/razas/63.jpg",
      },
      {
        nombre2: "Caniche",
        nombre1: "Poodle Mediano",
        pais_origen: "Francia",
        origen:
          "Antes del siglo XVI eran empleados en Francia como perros de aguas, y se conocían como caniche o chien canard, ambos nombres haciendo alusión a la utilidad de la raza para cobrar patos y otras aves acuáticas.",
        caracteristica:
          "Son fieles, alegres y juguetones. Aprenden con mucha facilidad y les encanta correr, nadar y recoger cosas con su boca y llevárselas a su dueño.",
        recomendacion:
          "Necesitan mucha compañía y no son perros para vivir aislados en un jardín o en un patio, ya que pueden sufrir ansiedad por separación.",
        ideal:
          "Son ideales para familias y personas que tienen perros por primera vez, siendo mejores los de mayor talla para propietarios novatos. No son buenas mascotas para personas muy sedentarias.",
        dato: "Están considerados como uno de los cinco perros más inteligentes del mundo.",
        size: 2,
        vida: 3,
        deporte: 2,
        intel: 6,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/caniche-o-poodle-mediano.html",
        n: "/img/razas/110.jpg",
      },
      {
        nombre1: "Cavachón",
        nombre2: "",
        pais_origen: "USA",
        origen:
          "La raza surgió en Estados Unidos, concretamente en Pine, Arizona, donde unos criadores, asesorados y asistidos por genetistas y veterinarios, crearon un especial programa de cría. Fruto de este programa surgieron los primeros cavachón en 1996, mezcla de los cavalier King Charles con las de los bichones frisé. ",
        caracteristica:
          "Se caracteriza por ser cariñoso, afectuoso y atento. Resaltan por su energía, siendo perros inquietos y que necesitan estar constantemente corriendo, jugando y saltando. Algunos pueden llegar a ser hiperactivos, algo que hemos de tener en consideración antes de adoptar uno. También son bastante ladradores, estando siempre alerta ante todo lo que sea nuevo o les parezca peligroso.",
        recomendacion:
          "Si pasamos demasiado tiempo fuera de casa puede sufrir cambios emocionales bastante graves, desarrollando ansiedad por separación o depresión (lo que no quiere decir que no sean capaces de aprender a estar solos). Necesitan atención y cariño constantes, ya que estos perros no toleran la soledad, y debemos adoptarlos solo si estamos completamente seguros de poder acompañarlo el tiempo suficiente. ",
        ideal:
          "Es el perro ideal para todos, tanto para personas que vivan solas (entrega amor y compañía), familias con niños (con los que se lleva de maravilla) o para personas de avanzada edad (a quienes dará infinito cariño y alegría). También es ideal para aquellos que ya comparten su hogar con otros animales, ya que el cavachón suele ser un pero muy sociable.",
        dato: "Es uno de los denominados perros de diseño, pues se cruzaron para combinar las características físicas de los cavalier King Charles con las de los bichones frisé.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/cavachon.html",
        n: "/img/razas/45.jpg",
      },
      {
        nombre1: "Cavalier King Charles Spaniel",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Es una raza originaria de Inglaterra y los primeros ejemplares se remontan a los tiempos de Isabel I de Inglaterra. Es probable que naciera del cruce entre perros pekineses y perros de aguas japoneses. Ya en el año 1.600 empezaron a ser apreciados entre los nobles ingleses. Recibe parte de su nombre, Charles, gracias a Carlos II, el cual estaba particularmente apegado a él.",
        caracteristica:
          "Es muy apreciada por su aspecto elegante y por su manto sedoso y delicado. Su carácter es alegre, sin miedo, ansiedad o nerviosismo. Por el contrario, es un perro activo pero equilibrado. Se puede relacionar maravillosamente con todo tipo de personas y animales, lo que le convierte también en una raza estupenda para la terapia asistida.",
        recomendacion:
          "Tiene alta predisposición a padecer enfermedades hereditarias, destacando la siringomiela, una patología especialmente dolorosa y grave que ocurre por un crecimiento excesivo de la masa cerebral, que no tiene suficiente espacio en el cráneo (se estima que 1 de cada 3 perros de esta raza la padecen). Por eso es muy importante visitar al veterinario periódicamente.",
        ideal:
          "Es un perro dócil y afable, lo que le convierte en una de las razas más indicadas para la convivencia con niños y personas mayores. La vida con él es especialmente sencilla y, gracias a su pequeño tamaño, se adapta sin problemas a la vida en un departamento.",
        dato: "Es conocida por su aparición múltiples películas, y también se popularizó gracias a las celebridades que lo eligieron como perro de compañía, como Coco Chanel, Oscar Wilde o Frank Sinatra.",
        size: 1,
        vida: 2,
        deporte: 1,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/cavalier-king-charles-spaniel.html",
        n: "/img/razas/85.jpg",
      },
      {
        nombre1: "Cavapoo",
        nombre2: "Cavoodle",
        pais_origen: "Australia",
        origen:
          "Para poder crear el perro ideal como animal de compañía, los criadores realizaron cruces entre los caniches en miniatura y los cavalier king charles spaniel, y así poder combinar las bondades de ambas razas. Luego, de forma muy eficaz, nace el cavapoo.",
        caracteristica:
          "Tienen un benigno carácter. Son perros que llaman la atención por su gran inteligencia, sumada a un temperamento equilibrado, sociable y cariñoso.",
        recomendacion:
          "Estos perros son algo delicados en cuanto a la salud ocular, pudiendo desarrollar enfermedades como la atrofia progresiva de la retina o las comunes conjuntivitis. Se recomienda realizar visitas periódicas al veterinario.",
        ideal:
          "Son perros pacientes y tranquilos, por lo que se recomiendan para todo tipo de familias, tanto personas solas como familias grandes o personas mayores. Asimismo, es considerada una de las mejores razas de perros para niños.",
        dato: "Los cachorros no se diferencian de los adultos salvo por su menor tamaño, ya que su cara permanece igual aunque tengan más de 10 años de edad.",
        size: 1,
        vida: 2,
        deporte: 2,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/cavapoo-o-cavoodle.html",
        n: "/img/razas/42.jpg",
      },
      {
        nombre1: "Cazador de Alces Noruego",
        nombre2: "Elkhound",
        pais_origen: "Noruega",
        origen:
          "No se sabe mucho del momento exacto del origen, pero son muy comunes en las montañas noruegas, de donde probablemente son originarios.",
        caracteristica:
          "Son perros muy atentos, activos y alertas, por lo que son unos excelentes perros guardianes. Son bastante recelosos y reticentes ante el trato con extraños, aunque no suelen ser agresivos. Son perros de carácter fuerte. Destacan también por tener muy buena salud, sin enfermedades congénitas o hereditarias graves.",
        recomendacion:
          "Es muy independiente, por lo que hemos de dejarle su espacio para que se mueva y se entretenga solo. Es muy juguetón y activo, de manera que necesita bastante ejercicio para estar tranquilo. Para educarlo es fundamental ser constantes y pacientes.",
        ideal:
          "Son perros muy indicados para niños, pues con ellos son especialmente pacientes y atentos, cuidando de ellos y vigilando que no les pase nada. Así, son unos excelentes perros niñera.",
        dato: "Recibe el nombre de elkhound, siendo probable que sea parte de la descendencia del antiguo perro de las turberas, es decir, de los primeros perros que vivían con los poblados de Europa en la época prehistórica. Acompañaban a los vikingos en sus largos y trepidantes viajes.",
        size: 2,
        vida: 2,
        deporte: 3,
        intel: 4,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/cazador-de-alces-noruego-o-elkhound.html",
        n: "/img/razas/65.jpg",
      },
      {
        nombre1: "Chesapeake Bay Retriever",
        nombre2: "Retriever de la Bahía de Chesapeake",
        pais_origen: "USA",
        origen:
          "En 1807, naufragó un bergantín inglés en las costas de Maryland, Estados Unidos. En él iban dos cachorros de la raza Newfoundland, que fueron rescatados junto con la tripulación y la carga por un barco local llamado Cantón. Esos dos cachorros fueron entregados a aristócratas locales, quienes los emplearon para la caza. Los propietarios decidieron cruzarlos con perros locales que se empleaban para ese mismo fin, buscando mejorar aún más la habilidad de cobro en las siguientes generaciones. Así, esos Newfoundland fueron cruzados con perros retriever locales, y en las siguientes generaciones se introdujo sangre de otras razas de perros como el otterhound inglés, el curly coated retriever y el flat coated retriever, dando origen al Chesapeake bay retriever.",
        caracteristica:
          "Es amigable, despierto, alegre, dinámico e inteligente. Aunque sea afectuoso, también es un perro que protege a los suyos y puede llegar a ser desconfiado con desconocidos, mostrando un mayor grado de agresividad que otras razas de perros retriever. Debido a su naturaleza cazadora, y a diferencia de otros retriever, el Chesapeake bay retriever suele ser un perro territorial, independiente y muy resistente a bajas temperaturas.",
        recomendacion:
          "Su socialización desde cachorro es muy importante para evitar que se peleen con otros perros o que desarrollen conductas agresivas. No les gusta estar solos y necesitan compañía frecuente.",
        ideal:
          "Estos perros necesitan mucho ejercicio y de vez en cuando nadar, así que no son aptos para vivir en un departamento pequeño. También son difíciles de controlar para personas poco experimentadas.",
        dato: "Su gran resistencia física ha sido causa de la aparición de muchos mitos alrededor de esta formidable raza, como el de que pueden pasar largas horas en aguas healdas sin sufrir hipotermia.",
        size: 2,
        vida: 2,
        deporte: 3,
        intel: 4,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/chesapeake-bay-retriever-o-retriever-de-la-bahia-de-chesapeake.html",
        n: "/img/razas/165.jpg",
      },
      {
        nombre1: "Chihuahua",
        nombre2: "Chihuahueño",
        pais_origen: "México",
        origen:
          "Procede de México, concretamente del estado Chihuahua, de dónde se descubrió por primera vez. Su significado es literalmente lugar árido y arenoso.",
        caracteristica:
          "No tiene personalidad definida propia de la raza, y dependiendo de su educación podemos hablar de un perro cariñoso y tierno o de una raza algo maliciosa y astuta.  Es un perro muy inteligente y observador al que le gusta salirse con la suya. También es valiente y devoto a pesar de su reducido tamaño. En general suele ser desconfiado con los extraños, siendo territorial y posesivo con sus dueños, pero no suele mostrar actitudes violentas. No es conciente de su reducido tamaño y puede enfrentarse a personas o perros de talla grande solo para defender a los que quiere. ",
        recomendacion:
          "Por lo general, y especialmente los de pelo corto, son sensibles al frío debido a su pequeño tamaño. Puedes comprarle ropa de su tamaño para abrigarle en invierno, especialmente si vive en un entorno muy helado. No lo mimes en exceso, el chihuahua es un perro muy inteligente que no dudará en volverse frágil, caprichoso o extremadamente nervioso si cedemos ante todas sus peticiones. Tiene tendencia a la obesidad, asi que es importante que conozcamos el tipo de dieta que necesita para prevenir futuras enfermedades o problemas.",
        ideal:
          "Es un perro que se adapta perfectamente a la vida urbana y no tendrá problemas en vivir en un departamento pequeño. Aún así, el chihuahua es muy inquieto y nervioso, y deberemos sacarlo a pasear al menos dos veces al día para que se ejercite, así como jugar con él dentro del hogar.",
        dato: "A pesar de ser mañoso con otros animales, por lo general suele convivir maravillosamente con perros de su misma raza o tamaño.",
        size: 1,
        vida: 4,
        deporte: 2,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "inline",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/chihuahua.html",
        n: "/img/razas/16.jpg",
      },
      {
        nombre1: "Chodsky",
        nombre2: "Pastor bohemio",
        pais_origen: "República Checa",
        origen:
          "Es oriundo de la región de Chodsko, al suroeste de Bohemia, en la actual República Checa. Surgió hace muchos siglos pues se tiene constancia de su existencia en el siglo XIII, y ha ejercido labores de guardia de terrenos y hogares.",
        caracteristica:
          "Enérgico, pero también muy dócil y obediente. Está siempre alerta, por lo que es un excelente vigía, guardando con fiereza lo que considera suyo. Esto hace que se muestre desconfiado con los extraños, pero que le tenga mucho amor a su familia. Se lleva bien tanto con otros animales como con niños pequeños, con los que es muy cuidadoso y atento. Tienen una gran facilidad para aprender, pues son atentos y muy inteligentes, estando siempre dispuestos a adquirir nuevos conocimientos.",
        recomendacion:
          "Al ser un perro tan activo, el pastor bohemio necesita ejercitarse a diario. Si bien no necesita que sea una actividad extremadamente intensa, sí requiere que al menos sea de intensidad moderada. Otro problema es que tiene una tendencia a tener infecciones auditivas, la más frecuente siendo la otitis. Por ello es tan importante realizar limpiezas de los oídos de forma regular.",
        ideal: "",
        dato: "Se dice que hace más de 8 siglos que existe esta raza. Dada la antigüedad de esta raza y sus orígenes filogenéticos, se la considera una de los predecesores del conocido pastor alemán.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/chodsky-o-pastor-bohemio.html",
        n: "/img/razas/20.jpg",
      },
      {
        nombre1: "Chorkie",
        nombre2: "",
        pais_origen: "?",
        origen:
          "Se establece el surgimiento de la raza en los primeros años de la década de los 90, con el cruce entre yorkies y chihuahuas. La finalidad era la de tener una raza con carácter similar a ambas, pero con mejor salud. Se desconoce el lugar y momento exacto de origen.",
        caracteristica:
          "Son muy autónomos e independientes. Se llevan bien con las personas pero son una raza tozuda, que no suele tolerar recibir órdenes. Por ello, para su adiestramiento hay que ser sumamente pacientes y tolerantes, pero siempre firmes, seguros y constantes.",
        recomendacion:
          "Su relación con otros animales no siempre es buena, pudiendo mostrar comportamientos agresivos en algunos casos. Lo mejor para una buena convivencia es acostumbrar al chorkie al contacto con otros animales desde que es cachorro.",
        ideal:
          "No son la raza más idónea para familias con niños pequeños, pues son demasiado inquietos e impacientes.",
        dato: "Es considerado uno de los perros más populares del mundo.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 4,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/chorkie.html",
        n: "/img/razas/47.jpg",
      },
      {
        nombre1: "Chow Chow",
        nombre2: "",
        pais_origen: "China",
        origen:
          "Tiene sus inicios en el norte del China. Durante los primeros años del siglo XIX empieza a mostrarse en otros países, como Inglaterra, donde era exhibido en el Zoológico de Londres en la década de 1820 como perro salvaje de China. Mientras los ejemplares seguían viajando alrededor del mundo, la Reina Victoria decidió adquirir uno y fue entonces cuando la raza se popularizó enormemente en Reino Unido. El nombre del chow chow significa literalmente león suave y mullido. ",
        caracteristica:
          "Calmado, reservado, independiente y tranquilo. No destaca especialmente por ser un amante del ejercicio, sino que prefiere realizar pequeñas caminatas de vigilancia dentro su territorio y descansar. Suele mostrarse tímido con los extraños. No son ladradores y generalmente no causan muchos destrozos.",
        recomendacion:
          "No fuerces a tu perro a realizar ejercicio excesivo durante los meses de calor, ya que eso podría terminar en un golpe de calor debido a su grueso y denso pelaje.",
        ideal:
          "Estos perros pueden vivir en exteriores en climas fríos o templados, pero no toleran bien los climas cálidos. También se adaptan con facilidad a la vida en departamento si es que reciben los suficientes paseos y ejercicio físico.",
        dato: "Tiene la lengua azul. Se estima que se empezó a criar aproximadamente hace 2.000 o 3.000 años, aunque no existen estudios que lo demuestren realmente, pero se puede confirmar que es una de las razas de perros más antiguas.",
        size: 2,
        vida: 2,
        deporte: 1,
        intel: 1,
        clima: 1,
        child: "none",
        depa: "inline",
        antig: "inline",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/chow-chow.html",
        n: "/img/razas/99.jpg",
      },
      {
        nombre1: "Cimarrón Uruguayo",
        nombre2: "",
        pais_origen: "Uruguay",
        origen:
          "Es una raza de origen incierto. Lo único que se sabe es que podría ser el descendiente directo de los perros que llegaron al territorio uruguayo acompañando a los conquistadores europeos. Debido a la abundancia de alimento de las regiones en las que se empezó a reproducir, se iniciaron ataques de jaurías de cimarrones salvajes a rebaños e incluso caravanas de viajeros. Por ello, algunos fueron perseguidos y asesinados, llegándose a contabilizar miles de cimarrones muertos. Sin embargo, algunos locales sí vieron las virtudes de la raza y decidieron domesticarla e incorporarla a su vida diaria, convirtiendo al cimarrón uruguayo en un excelente perro guardián y de pastor de los diferentes rebaños de todo el territorio.",
        caracteristica:
          "Es un perro de carácter equilibrado, muy sociable y con gran seguridad y valentía. Es tenaz y no se rinde nunca. En cuanto a su relación con los demás, puede presentar respuestas agresivas ante otros perros y animales, caracterpistica que se puede cambiar si se le sociabiliza desde cachorro.",
        recomendacion: "Hay que ejercitarlo de forma diaria.",
        ideal:
          "No es una raza para aquellos que no están acostumbrados a tener perro, ya que necesitan de paciencia, constancia, compañía y bastante conocimiento previo de la raza y de la forma de llevarla. Se adapta mejor a espacios grandes y abiertos, aunque hay muchos de ellos que viven en departamentos sin problemas debido a que son correctamente estimulados.",
        dato: "Se sospecha que el actual perro cimarrón uruguayo es el fruto de la selección natural, pues los perros de los colonizadores que fueron abandonados o escaparon tuvieron que sobrevivir en un entorno nuevo y desconocido, aguantando solo los más fuertes.",
        size: 2,
        vida: 2,
        deporte: 3,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/cimarron-uruguayo.html",
        n: "/img/razas/24.jpg",
      },
      {
        nombre1: "Cockapoo",
        nombre2: "",
        pais_origen: "USA",
        origen:
          "Nacieron en la década de los 50 en los Estados Unidos, donde se volvieron muy populares en poco tiempo. Surgen por un cruce entre un cocker spaniel inglés y un caniche estándar.",
        caracteristica:
          "Tienen muy buen carácter. Son sociables, cariñosos, adoran la compañía y las atenciones, inteligentes y activos. Son populares como perros de terapia y asistencia debido a su bondad y equilibrado carácter. Establecen fuertes vínculos con sus seres queridos, y no solo con las personas, si no también con otro perros o mascotas de la familia.",
        recomendacion:
          "Pueden mostrar ansiedad por separación, lo que suele ir acompañado con mucha frecuencia de ladridos y llantos interminables. Es importante que sepamos qué es la ansiedad por separación, así como las diferentes técnicas que existen para tratarla.",
        ideal:
          "No toleran la soledad, por lo que no son buena elección si solemos pasar mucho tiempo en el trabajo o fuera de casa en general. En estos casos suelen desarrollar problemas como la ansiedad, la depresión o incluso mostrar conductas destructivas o agresivas.",
        dato: "Son considerados como una de las razas de perro ideales para personas con alergia al pelo de perro, pues apenas pierden pelo y son considerados como hipoalergénicos.",
        size: 1,
        vida: 4,
        deporte: 2,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/cockapoo.html",
        n: "/img/razas/51.jpg",
      },
      {
        nombre1: "Cocker Spaniel Americano",
        nombre2: "",
        pais_origen: "USA",
        origen:
          "En el siglo XIX llegaban los primeros ejemplares de cocker spaniel ingleses a Norteamérica, y durante las últimas décadas de ese mismo siglo la raza se extendió por todo el territorio americano.",
        caracteristica:
          "Los cocker en general son muy cariñosos y alegres. Su apariencia de peluche refuerza esa dulzura, pues nos darán ganas de abrazarlo constantemente debido a lo atentos y afectuosos que son, así como por la delicadeza con la que tratan a los niños y otros animales. Les gustan los juegos y ejercicios. A veces pueden ser obstinados y porfiados, por lo que la enseñanza puede ser un poco difícil.",
        recomendacion:
          "Para mantener el pelo limpio y sin enredos debemos cepillarlo como mínimo una vez al día.",
        ideal: "",
        dato: "Un 7 % de los cachorros nacen con sordera congénita, ya sea de uno o de ambos oídos.",
        size: 2,
        vida: 3,
        deporte: 2,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/cocker-spaniel-americano.html",
        n: "/img/razas/92.jpg",
      },
      {
        nombre1: "Cocker Spaniel Inglés",
        nombre2: "",
        pais_origen: "España",
        origen:
          "La raza original provenía de España, país en el que se utilizaba como cazador y cobrador. Los cocker spaniel llegaron a Inglaterra de la mano de propietarios Españoles. El nombre deriva del francés antiguo spaigneul, que significa literalmente perro español.",
        caracteristica:
          "Es dulce y tierno con sus familiares, pero suele mostrarse algo distante con personas desconocidas. Se trata de un perro apegado a sus humanos y adora pasar tiempo con ellos. Es muy fiel, atento, alegre, activo y con fuerte personalidad. Encajará perfectamente en una familia activa.",
        recomendacion:
          "Necesita estar siempre junto a los suyos para sentirse bien, sino podría sufrir ansiedad por separación. Los problemas de conducta más habituales son la destructividad, la persecución de animales pequeños o la agresividad (generalmente aparecen cuando no se socializa correctamente). Debemos presentarle todo tipo de personas, animales, objetos y entornos, de esta forma, al llegar a su etapa adulta, no tendrá problemas de conducta. ",
        ideal: "",
        dato: "Adquirieron una enorme popularidad por numerosas referencias de la literatura inglesa, como en obras de Sheakespeare o Chaucer.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/cocker-spaniel-ingles.html",
        n: "/img/razas/140.jpg",
      },
      {
        nombre1: "Collie Barbudo",
        nombre2: "Bearded Collie",
        pais_origen: "Inglaterra",
        origen:
          "Se cree que desciende de perros pastores polacos de las llanuras que habrían sido llevados hasta las islas británicas por comerciantes polacos. También es posible que el komondor sea otro ancestro de los collies barbudos. Esos perros se habrían cruzado con perros locales (pastores de rebaños) originando así la nueva raza, y fue utilizado por siglos para guiar y cuidar los rebaños en Gran Bretaña.",
        caracteristica:
          "Se adapta muy bien a una vida proactiva, llena de estímulos y que puedan motivarle mental y físicamente. Se trata de perros muy activos y llenos de energía, aunque algo independientes en su día a día.",
        recomendacion: "Necesitan mucho ejercicio y paseos diarios.",
        ideal:
          "Son perfectos para personas que quieran compartir con su perro unos hábitos aventureros e incansables. Es imprescindible que la familia que vaya a adoptarle tenga claras estas exigencias: no es un perro para familias sedentarias. Tampoco son perros para vivir en el exterior. Necesitan una familia y un hogar en el que pasar su tiempo junto a sus seres queridos.",
        dato: "Durante la década de los  40, G. Olive Wilson empezó a criar collies barbudos a partir de una sola pareja, sus perros Bailey y Jeannie. Ese fue un punto crítico de la historia de la raza, ya que esos perros y su descendencia se convirtieron en los principales fundadores del collie barbudo tal como lo conocemos hoy en día.",
        size: 2,
        vida: 4,
        deporte: 4,
        intel: 4,
        clima: 1,
        child: "inline",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/collie-barbudo-o-bearded-collie.html",
        n: "/img/razas/146.jpg",
      },
      {
        nombre1: "Collie de pelo corto",
        nombre2: "Collie Smooth",
        pais_origen: "Escocia",
        origen:
          "Se originaron en las tierras altas de Escocia, junto con el collie de pelo largo. Originalmente cumplían funciones de perros pastores.",
        caracteristica:
          "Amigables, suaves y sensibles, estos perros comparten el excelente temperamento del collie de pelo largo. También son perros muy inteligentes y activos que necesitan mucho ejercicio y compañía, y no suelen ser agresivos. Pierden pelo con regularidad y más aún durante las dos épocas anuales de muda.",
        recomendacion:
          "Son perros pastores y, como tales, necesitan mucho ejercicio y compañía.",
        ideal: "",
        dato: "Hoy en día, el collie de pelo largo y el de pelo corto son reconocidos como una sola raza de perros por el Kennel Club Americano, pero son tratados como razas caninas diferentes por la Federación Cinológica Internacional",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 3,
        child: "inline",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/collie-de-pelo-corto.html",
        n: "/img/razas/123.jpg",
      },
      {
        nombre1: "Collie de pelo largo",
        nombre2: "",
        pais_origen: "Escocia",
        origen:
          "Se originaron en las tierras altas de Escocia, donde cumplían funciones de perros pastores. Antiguamente, estos canes eran más pequeños y menos estilizados, pero en la segunda mitad del siglo XIX capturaron la atención de los aficionados a las exposiciones caninas y de la reina Victoria. Fue entonces que, mediante cruces elegidos cuidadosamente, se consiguió el tipo actual de la raza. ",
        caracteristica:
          "Se caracterisan por ser afectuosos, inteligentes y sensibles. Son animales dóciles que no tienden a ser agresivos, y necesitan mucho ejercicio físico y compañía para ser felices. Pierden pelo regularmente, y mucho más durante las épocas de muda (dos veces al año).",
        recomendacion:
          "No es bueno bañarlos con mucha frecuencia porque el pelaje pierde sus aceites protectores, y solo hay que hacerlo cuando el perro está realmente sucio.",
        ideal:
          "Suelen ser perfectos compañeros para personas de cualquier edad, siempre que se disponga de la fuerza y energía necesaria para seguir su ritmo de ejercicio.",
        dato: "En las décadas de los  40,  50 y  60, el collie se convirtió en una de las razas de perros más populares en el mundo. Esto debido a la fama que adquirió Lassie, el personaje de perro creado por Eric Knight, y que fue el personaje principal de novelas, radionovelas, películas y series de televisión.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "inline",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/collie-de-pelo-largo.html",
        n: "/img/razas/114.jpg",
      },
      {
        nombre1: "Coton de Tuléar",
        nombre2: "",
        pais_origen: "Madagascar",
        origen:
          "El origen de esta raza es confuso, pero se piensa que el coton de Tuléar proviene de perros europeos de la familia de los bichones que habrían sido llevados a Madagascar por tropas francesas, o tal vez por marinos portugueses e ingleses. Sea como fuere, el coton de Tuléar es un perro malgache, desarrollado en la ciudad portuaria de Tuléar, hoy conocida como Toliara.",
        caracteristica:
          "Son dulces, muy alegres, juguetones, inteligentes y sociables. Se adaptan con facilidad a diferentes situaciones y tienden a ser muy divertidos. Eso sí, necesitan compañía para sentirse bien, aunque es fácil socializarlos. Son fáciles entrenar y no presentan problemas de comportamiento. No pierden pelo.",
        recomendacion:
          "Este es un perro que necesita pasar la mayor parte del día con su familia y demanda mucha atención.",
        ideal:
          "Se trata de un can capaz de adaptarse a cualquier situación, cariñoso, sociable e ideal tanto para familias como para personas solteras o de edad avanzada. Si buscas un perro con el que pasar gran parte de tu tiempo para jugar con él y ofrecerle todo tu cariño, sin duda el coton de Tuléar es el compañero que buscas. Son excelentes mascotas para casi cualquier persona, inluyéndo un propietario novato.",
        dato: "Tradicionalmente es muy apreciado por las familias acomodadas de la isla Madagascar.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/coton-de-tulear.html",
        n: "/img/razas/204.jpg",
      },
      {
        nombre1: "Dálmata",
        nombre2: "",
        pais_origen: "Croacia",
        origen:
          "La historia antigua y los orígenes del dálmata son realmente desconocidos. Las primeras imágenes de dálmatas son de pinturas y frescos croatas que datan del siglo XVII. Este es el principal motivo por el que la Federación Cinológica Internacional (FCI) le adjudica el origen de la raza a la región croata de Dalmacia, pero existen hipótesis diferentes que sugieren que este perro se habría originado mucho antes en otros lugares.",
        caracteristica:
          "Es amistoso, seguro de sí mismo y muy activo. Por lo general adoran nadar, correr y practicar ejercicio, siguiendo rastros debido a su gran curiosidad. Suelen llevarse bien con otros perros y con otros animales. Por norma general también son amistosos con personas desconocidas, y dentro de casa es un perro tranquilo y sereno, capaz de relajarse sin problema. Debido a la diversidad de cruces que han sido sometidos durante años, es una raza muy propensa a enfermedades (la sordera tiene una incidencia muy alta, que afecta a más del 10% de los perros).",
        recomendacion: "No le gusta nada la soledad y debemos evitarla.",
        ideal:
          "Son perfectos para familias activas que practiquen ejercicio con sus perros y quieran un compañero fiel y enérgico a su lado. Toleran perfectamente a los niños.",
        dato: "A fines del siglo XVII, los nobles británicos hacían que una jauría de dálmatas acompañara sus coches para mostrar su poder, y se consagraron como los perros cocheros. Supuestamente, esto cumplía una doble función: proteger a los caballos de los perros vagabundos y proporcionar una visión más estética del coche.",
        size: 3,
        vida: 3,
        deporte: 4,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/dalmata.html",
        n: "/img/razas/189.jpg",
      },
      {
        nombre1: "Dandie Dinmont Terrier",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Nacieron en la frontera entre Inglaterra y Escocia. La raza procede de cruces entre bedlington terrier, skye terrier y el ya desaparecido terrier escocés. Se hizo muy popular entre los granjeros de la zona por sus habilidades para acabar con las alimañas que les acarreaban pérdidas económicas, y también por sus dotes como cazador de nutrias y tejones. Son una raza muy antigua, pues ya en el siglo XVIII existían ejemplares.",
        caracteristica:
          "Son unos perros realmente decididos, con un marcado carácter independiente y emprendedor, siendo también valientes y a veces un poco temerarios. Les encanta que les den cariño y que jueguen con ellos ya que son realmente cariñosos. También destacan por ser dóciles, inteligentes, fáciles de entrenar y atentos.",
        recomendacion:
          "Deben realizar ejercicio diario para mantener su carácter equilibrado y evitar que sufra sobrepeso.",
        ideal:
          "Tiene una excelente convivencia con niños, ancianos, mascotas y otros perros. En cuanto a dónde pueden vivir, el abanico de posibilidades es bastante amplio, pues se adaptan tanto a espacios pequeños y cerrados, como departamentos de ciudad, como a aquellos más amplios y abiertos, como fincas o casas con terreno.",
        dato: "Están catalogados como raza vulnerable, pues se estima que solo nacen unos 300 ejemplares al año en Irlanda y Reino Unido.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/dandie-dinmont-terrier.html",
        n: "/img/razas/77.jpg",
      },
      {
        nombre1: "Doberman",
        nombre2: "Doberman Pinscher",
        pais_origen: "Alemania",
        origen:
          "Friederich Louis Dobermann (1834 - 1894) fue el creador de esta raza. Según se sabe, Dobermann era un recaudador de impuestos que además trabajaba a medio tiempo capturando perros para la perrera. Como tenía que moverse por diferentes lugares (y algunos no muy seguros) Dobermann decidió crear una raza de perro que fuese capaz de protegerlo y que al mismo tiempo fuese apegada a las personas. No se sabe con certeza qué razas participaron en la creación del dobermann, pero se piensa que se utilizaron a unos perros conocidos como perros del carnicero, que eran similares a los rottweiler.",
        caracteristica:
          "Es uno de los perros más inteligentes que existen. Esencialmente amistoso y pacífico, aprende muy rápidamente y con facilidad. También destaca por ser dulce, afectuoso, sensible y un excelente perro guardián.",
        recomendacion:
          "Es muy desconfiado con desconocidos, por lo que es recomendable socializarlo a conciencia desde cachorro. No es un perro de exteriores y le gusta pasar tiempo dentro del hogar con su familia. Con una baja capacidad para soportar el frío, el dobermann necesita un lugar adecuado para dormir y descanzar.",
        ideal:
          "Es un perro muy dependiente de su familia, por lo que no es adecuado si pasamos la mayor parte del día fuera o no le podemos brindar los cuidados que merece esta increíble raza. Necesitan mucho ejercicio, pero igual pueden adaptarse a vivir en un departamento si es que reciben largos paseos diarios y juegos que les ayuden a quemar su energía.",
        dato: "En décadas pasadas, el dobermann tuvo mucha popularidad como perro guardián y de protección. Fue ampliamente entrenado para servir como perro policía y para cumplir trabajos en el ejército. Actualmente se utiliza más como una mascota que como guardián.",
        size: 3,
        vida: 3,
        deporte: 4,
        intel: 6,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "inline",
        link: "https://www.expertoanimal.com/razas-de-perros/doberman-pinscher.html",
        n: "/img/razas/199.jpg",
      },
      {
        nombre1: "Dogo Argentino",
        nombre2: "",
        pais_origen: "Argentina",
        origen:
          "Fue desarrollada en la provincia argentina de Córdoba durante la década de 1920, por el Dr. Antonio Nores Martínez, quien buscaba un perro excepcionalmente fuerte y resistente, que fuese un verdadero luchador. En ese entonces, las peleas de perros eran muy comunes en los campos argentinos y en otros lugares del mundo (en Córdoba se usaban los denominados perros de pelea cordobeses para esas actividades). Nores Martínez usó esos perros como progenitor para el dogo argentino, pero buscaba en él más estabilidad de carácter y mayor control de la agresividad. Para lograr el estándar que hoy en día conocemos, se cruzaron muchas otras razas de perros: bulldog inglés, el gran danés, el mastín de los Pirineos, el bóxer, el mastín español, el dogo de Burdeos, el irish wolfhound y el pointer.",
        caracteristica:
          "Afectuoso y leal, es ciertamente una raza protectora pero tolerante con otros perros y personas. Además es inteligente, devoto y muy sensible, que creará un vínculo muy fuerte con quienes considera su familia. Es muy paciente, bondadoso y muy confiable si se ha tenido la oportunidad de educarle desde su etapa de cachorro.",
        recomendacion:
          "Su piel es muy sensible, y por ello será recomendable no exponerlo al sol intenso e ir con cuidado con las bajadas de temperatura (no tolera bien el frío).",
        ideal:
          "Es perfecto para quienes tengan niños algo mayores en su hogar, ya que disfruta enormemente jugando y ofreciendo besos afectuosos, algo que sorprende y cautiva a muchas personas. Su gran inteligencia hace que se aburra con cierta facilidad y por ello necesita una persona experimentada. Es muy recomendable que tenga un espacio amplio para vivir.",
        dato: "Es la única raza argentina que no se ha extinguido.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 5,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/dogo-argentino.html",
        n: "/img/razas/175.jpg",
      },
      {
        nombre1: "Dogo de Burdeos",
        nombre2: "Dogue de Bordeaux",
        pais_origen: "Francia",
        origen:
          "La historia antigua de esta raza es prácticamente desconocida, aunque la mayoría de fuentes apuntan a un origen Celta. Se estima que se utilizaba a este perro para la caza mayor y para la protección. Sin embargo, no fue hasta el siglo XIV cuando se documenta esta raza por primera vez en Francia. ",
        caracteristica:
          "Tiene un carácter amigable y tranquilo. Es un perro cómodo, inteligente e independiente, de personalidad muy equilibrada. No suele ser escandaloso ni excesivamente movido, siendo un perro muy calmado dentro del hogar. Se trata también de una raza muy sensible que debe tratarse con afecto y cariño, de lo contrario puede empezar a sufrir problemas del comportamiento que le inciten a estar nervioso o a ser destructivo. Tiene gran valentía y afecto que entrega a su familia, siendo sus punicos problemas el ser un perro que babea mucho y que debe consumir una gran cantidad de alimento.",
        recomendacion: "",
        ideal:
          "A pesar de su gran tamaño, es un perro muy tranquilo que va a aguantar de forma paciente a los más pequeños y sus travesuras.",
        dato: "Se dice que es la raza con la cabeza más grande en proporción a su cuerpo.",
        size: 3,
        vida: 1,
        deporte: 2,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/dogo-de-burdeos.html",
        n: "/img/razas/178.jpg",
      },
      {
        nombre1: "El Perro Pekinés",
        nombre2: "",
        pais_origen: "China",
        origen:
          "Era un perro venerado por los monjes budistas en China, ya​ que sus características físicas tienen cierta similitud con el león ​de Fu​, ​un animal mítico de la tradición budista. En 1860, durante la segunda guerra del opio, tropas anglo-francesas saquearon e incendiaron el Palacio de Verano de Pekín poco después de la huída del emperador chino Xianfeng. Afortunadamente, antes de incendiarlo rescataron a cinco perros pekineses que habitaban en ese palacio. Ellos fueron llevados a Inglaterra, donde fueron regalados a nobles y aristócratas (uno de ellos incluso llegó a las manos de la Reina Victoria de Inglaterra). Esos cinco perros fueron los progenitores de la población actual del pekinés, ya que los demás pekineses de China fallecieron o fueron ocultados por la población, sin evidencias sobre su descendencia.",
        caracteristica:
          "Son leales y muy valientes a pesar de su pequeño tamaño. Sin embargo, también son independientes y reservados. Estos pequeños perros chinos no socializan con tanta facilidad como perros de otras razas, pero son muy leales con los suyos y desconfiados con los extraños. No necesita mucho ejercicio, es un perro tranquilo que prefiere pasar el tiempo sin mucha actividad. Son tercos y difíciles de entrenar.",
        recomendacion:
          "Por su hocico achatado es susceptible a sufrir un golpe de calor, por lo que evitaremos pasearle en horas de sol intenso.",
        ideal:
          "Son excelentes mascotas para personas mayores y familias sedentarias. También pueden ser buenas mascotas para propietarios primerizos, pero no es un perro para vivir aislado ya que entonces puede desarrollar ansiedad por separación. ",
        dato: "Los perros eran cuidados por la realeza de China y únicamente los nobles podían tener un pekinés en su poder. Tal era la devoción hacia esta raza que a veces hasta contaban con sirvientes para que los cuidaran.",
        size: 1,
        vida: 3,
        deporte: 1,
        intel: 1,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/el-perro-pekines.html",
        n: "/img/razas/142.jpg",
      },
      {
        nombre1: "El Perro Terranova",
        nombre2: "",
        pais_origen: "Canadá",
        origen:
          "El origen del perro terranova se sitúa en la isla Newfoundland, en Canadá, conocida en castellano como La isla del Terranova. Se cree que la raza se desarrolló a partir de los perros autóctonos de la isla y de los perros que importaron los antiguos Vikingos (como el perro oso de color negro) a partir del año 1.100.",
        caracteristica:
          "Considerada una de las razas más hermosas y trabajadoras de la historia, este perro es además cariñoso, afectuoso, muy sociable y tranquilo. No es muy juguetón pero adora el agua, pudiendo pasar horas jugando en ella. Suele tolerar el trato con otros animales y es muy paciente con los niños, a los cuales adora. Refleja bondad y dulzura, con el único problema que puede llegar a babear mucho.",
        recomendacion:
          "Recomendamos estimular su epíritu de rescate con juegos de busca y enseñándole distintos trucos.",
        ideal:
          "No olvidemos que los terranova tienden a babear mucho, y cuando toman agua mojan todo, por lo que no son los perros más adecuados para personas extremadamente preocupados de la limpieza. Se recomienda su tenencia en casas grandes, con jardín, para que el perro pueda entrar y salir.",
        dato: "Es conocido como el gigante gentil ya que se trata de uno de los perros más grandes y bondadosos que existen.",
        size: 4,
        vida: 1,
        deporte: 1,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "inline",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/el-perro-terranova.html",
        n: "/img/razas/143.jpg",
      },
      {
        nombre1: "Eurasier",
        nombre2: "Eurasian",
        pais_origen: "Alemania",
        origen:
          "A principios de los 60, el criador alemán Julius Wipfel comenzó a cruzar el chow chow, samoyedos y el wolfspitz, para crear una nueva raza que combinara las características de ambos. El resultado fue el eurasier, una raza particular que se reconoció oficialmente por la FCI el año 1973.",
        caracteristica:
          "Su personalidad es cautivadora, ya que se trata de un perro cariñoso, equilibrado, calmado y realmente sociable. No tolera bien la soledad, es muy juguetón, terco e independiente, por lo que tiende a obedecer únicamente a la persona que considera su guía y referente.",
        recomendacion:
          "Si se aburre o no recibe la estimulación mental y física adecuada, puede transformarse en un perro destructor. No suele aguantar estar mucho tiempo atado, por lo que también es recomendable pasearlo por zonas en las que pueda disfrutar de su libertad, correr y jugar con otros perros.",
        ideal:
          "Estamos ante una raza canina perfecta para una familia con niños, puesto que adora la compañía, los juegos y ser el centro de todas la miradas.",
        dato: "Su creación no fue nada fácil, pues se necesitó asistencia de científicos especializados en genética para acabar con problemas asociados a los cruces originales. Todo ello ha quedado rigurosamente documentado gracias a que se han escrito múltiples libros sobre los orígenes y los obstáculos afrontados en su creación. Una particularidad de la raza eurasian es que algunos ejemplares presentan una lengua azul, recordando que provienen del chow chow.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "inline",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/eurasier.html",
        n: "/img/razas/56.jpg",
      },
      {
        nombre1: "Fila Brasileño",
        nombre2: "",
        pais_origen: "Brasil",
        origen:
          "Los primeros documentos históricos en los que se habla de esta raza de perros datan del año 1671, pero los orígenes concretos de los fila brasileños se desconocen. Aún así, todo el mundo coincide en que surgieron gracias al cruce de 3 razas diferentes de perros: los antiguos perros de presa o bulldogs, los mastiffs ingleses y los bloodhounds.",
        caracteristica:
          "Es fiel, amigable, paciente y bondadoso con los suyos, pero desconfiado e incluso agresivo con los extraños. Es un perro guardián y de pastoreo por naturaleza, que siempre cuidará su hogar y estará atento a todo.",
        recomendacion:
          "Una buena socialización es muy importante en esta raza. Aún cuando ha sido correctamente socializado desde cachorro y entrenado, el fila tiende a ser desconfiado y cauto con desconocidos.",
        ideal:
          "Se lleva de maravillas con los niños de su familia y es un excelente compañero para los adultos. Debido a su tamaño y carácter, no se adaptan a la vida en departamentos ni a la vida en ciudades densamente pobladas.",
        dato: "En 1982, el fila brasileño llegó a considerarse como la raza de perros más popular de Brasil. Actualmente se puede ver como perro de exposición.",
        size: 3,
        vida: 1,
        deporte: 2,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/fila-brasileno.html",
        n: "/img/razas/176.jpg",
      },
      {
        nombre1: "Fox Paulistinha",
        nombre2: "Terrier Brasileño",
        pais_origen: "Brasil",
        origen:
          "La historia de esta raza es poco conocida. Algunos opinan que el fox paulistinha (como se lo conoce coloquialmente) es el descendiente de perros fox terrier de pelo liso llevados desde Europa hasta Brasil y luego cruzados con perros locales. Otros opinan que el verdadero ancestro es el Jack Russell terrier. Y hay quienes piensan que ambos (el fox terrier y el Jack Russell terrier) fueron cruzados con perros locales de Brasil para dar origen a esta raza.",
        caracteristica:
          "Alegre, vivaz, curioso, inteligente y muy independiente. A este terrier no se le escapa ningún ruido ni movimiento, y está siempre alerta a todo. Tiene muy buen temperamento y pasa mucho tiempo jugando, incluso cuando ya no es cachorro. Al ser independiente no necesita tanta compañía como otras razas.",
        recomendacion:
          "Tienden a ser desconfiados con los desconocidos, e incluso pueden llegar a ser agresivos. Por tanto, es muy importante la correcta socialización de los perros con la gente desde temprana edad. Necesita juegos intensos y educación entretenida para mantenerse ocupado tanto física como mentalmente.",
        ideal:
          "No es recomendable tenerlo con mascotas pequeñas, porque su instinto de caza es muy fuerte y tiende a perseguir y matar animales pequeños.",
        dato: "Fue la segunda raza de perros brasilera reconocida oficialmente.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/fox-paulistinha-o-terrier-brasileno.html",
        n: "/img/razas/153.jpg",
      },
      {
        nombre1: "Fox Terrier de pelo alambre",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "No se conoce a ciencia cierta el origen de esta raza, pero sí se sabe que proviene de Inglaterra, donde se empleaba para la caza del zorro (fox es zorro en inglés). La selección para este tipo de trabajo fue intensa y los perros obtenidos eran pequeños pero muy fuertes y agresivos, capaces de sacar al zorro de su madriguera.",
        caracteristica:
          "Su pelaje es denso y áspero. Derrocha energía durante todo el día y necesita mucho ejercicio físico y mental. Además, demanda mucha compañía y puede ser muy insistente cuando quiere algo. Cuando está aburrido, este terrier tiende a ladrar y cavar en el jardín, además de mordisquear todo lo que encuentra.",
        recomendacion: "Necesitan mucho ejercicio físico.",
        ideal:
          "Es un compañero perfecto para tipos de familias muy distintas que busquen tener a su lado un perro jovial, afectuoso y seguro de si mismo. Es una de las razas más complicadas para un propietario novato, porque demanda mucho tiempo. Es mejor mascota para personas muy activas, a las que les gusta realizar actividades al aire libre y tienen experiencia en el manejo de perros. El impulso de presa de estos fox terrier es muy intenso y, por tanto, tienden a cazar cualquier animal pequeño y no es la opción ideal si se tienen otras mascotas.",
        dato: "En algún momento, el fox terrier de pelo de alambre y el fox terrier de pelo liso se consideraron una misma raza. Sin embargo, a mediados de los años  80 se reconocieron como razas separadas.",
        size: 1,
        vida: 3,
        deporte: 4,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/fox-terrier-de-pelo-alambre.html",
        n: "/img/razas/201.jpg",
      },
      {
        nombre1: "Fox Terrier de pelo liso",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "El fox terrier es uno de los terrier más antiguos y al parecer ya existía a mediados del siglo XIX en Inglaterra. Al igual que muchos otros terrier, esta raza fue utilizada por los granjeros ingleses para matar de zorros y ratas que eran las plagas que azotaban Inglaterra en ese entonces.",
        caracteristica:
          "Son curiosos, activos y alertas, que demandan mucho ejercicio y compañía. Es quizás una de las razas de perros más hiperactivas y demandantes de actividad física y mental. Además, suelen ser reactivos hacia otros perros y animales si no se trabaja bien en su educación. Sus desventajas son los ladridos y que suelen cavar el jardín con frecuencia.",
        recomendacion:
          " Necesita mucho ejercicio y compañía, cuando se aburren tienden a destrozar todo lo que encuentran y a cavar en el jardín.",
        ideal:
          "No son aptos para cualquiera, pero pueden ser excelentes mascotas para quien puede cubrir sus necesidades y sabe cómo manejarlos. Suelen ser buenas mascotas para familias con niños grandes y responsables. Sin embargo, son perros reactivos que pueden responder de manera muy negativa a los malos tratos de niños pequeños. Si bien pueden vivir en un departamento, es necesario sacarlos a pasear a diario.",
        dato: "Actualmente es mucho menos popular que su primo el fox terrier de pelo de alambre, y su uso como perro de caza prácticamente se ha extinguido. Antes, la cola de los fox terrier de pelo liso se amputaba en los perros de exposición, lo que servía para evitar daños en la cola durante las cacerías.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/fox-terrier-de-pelo-liso.html",
        n: "/img/razas/205.jpg",
      },
      {
        nombre1: "Foxhound Americano",
        nombre2: "",
        pais_origen: "USA",
        origen:
          "Está estrechamente relacionada con la generación fundadora de Estados Unidos, que copió muchas de las costumbres de Reino Unido, entre ellas la tradicional caza del zorro y la importación del foxhound inglés. La élite norteamericana de la época practicaba este deporte con aquella raza. Si bien no fue muy popular como perro de exposición, el foxhound inglés destacaba en las funciones de caza, hasta que en la época postcolonial se terminó de ajustar el estándar y se terminó llamando foxhound americano. Actualmente es el perro del estado de Virginia.",
        caracteristica:
          "Es un perro de carácter dinámico, curioso y sociable. Aunque tiene un ladrido fuerte y es muy tenaz en el rastro, no es un buen guardián porque suele ser demasiado amigable. Es un perro que requiere compañía, por lo que no es adecuado para personas que pasan mucho tiempo fuera del hogar. La socialización del cachorro no es difícil, y es un perro muy fácil de cuidar y mantener.",
        recomendacion:
          "Al tratarse de un perro activo, debemos ofrecerle ejercicio diario.",
        ideal: "",
        dato: "Está estrechamente relacionado con la generación fundadora de Estados Unidos, que trasladó a las colonias de América muchas de las costumbres de Reino Unido, entre ellas la tradicional caza del zorro.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 3,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/foxhound-americano.html",
        n: "/img/razas/66.jpg",
      },
      {
        nombre1: "Foxhound Inglés",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Se desarrolló en Reino Unido durante el siglo XIII para la caza del zorro rojo a caballo. Sus antepasados directos son el bloodhound o perro de San Huberto y el greyhound o galgo inglés, entre otros perros ligeros. Se estima que la raza tiene más de 200 años.",
        caracteristica:
          "Tiene un temperamento sociable y amistoso, pero demanda compañía frecuente. La socialización del perro no suele ser un problema y tampoco demanda excesivos cuidados. El potencial es su olfato, pudiendo encontrar rastros fácilmente y realizar juegos de búsqueda. Pueden ser algo ladradores.",
        recomendacion:
          "Demanda mucha actividad física, sino se vuelve destructor y ansioso.",
        ideal: "",
        dato: "Ha destacado notablemente como perro cazador gracias a su prodigioso olfato.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "inline",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/foxhound-ingles.html",
        n: "/img/razas/67.jpg",
      },
      {
        nombre1: "Frenchton",
        nombre2: "",
        pais_origen: "USA",
        origen:
          "Estados Unidos muchos criadores comenzaron con cruces genéticos entre distintas razas que permitieran acabar, o al menos paliar, muchos problemas congénitos que tienen el bulldog francés y el boston terrier. De esta forma, y a mediados de los 90, surgen los primeros ejemplares de frenchton.",
        caracteristica:
          "Desde una edad muy temprana son perros atentos y muy cariñosos, que les encanta interactuar con las personas y con otros animales.  Además, no son nada ruidosos, lo que quiere decir que no tendremos problemas con los vecinos debido a ladridos. Y son bastante tranquilos, siempre estando calmados y felices.",
        recomendacion:
          "Si van a convivir con otras mascotas, mientras son cachorros es el mejor momento de realizar las correspondientes presentaciones y así sea más sencillo que se establezca una buena relación entre ellos. Al tener esa morfología, a los frenchton se les dificulta respirar, por lo que ante mucho deporte puede presentar dificultades para respirar con normalidad.  Presentan tendencia a desarrollar sobrepeso y obesidad, por lo que es muy importante vigilar su alimentación. ",
        ideal:
          "Dado el buen carácter y la gran sociabilidad de este perro, es una raza apropiada para casi cualquier tipo de familia, adaptándose con facilidad a diferentes condiciones. Pueden vivir tanto con familias compuestas por una sola persona, como por personas mayores o niños de cualquier edad.",
        dato: "Es una de las razas caninas que más popularidad ha ganado en los últimos años, especialmente en Estados Unidos.",
        size: 1,
        vida: 4,
        deporte: 3,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/frenchton.html",
        n: "/img/razas/29.jpg",
      },
      {
        nombre1: "Galgo Afgano",
        nombre2: "",
        pais_origen: "Afganistán",
        origen:
          "Es un perro que procede de Afganistán. Se cree que desciende del Saluki, un perro Iraní de características similares. Se utilizaba para la caza o como perro pastor, y es registrado por primera vez en el siglo XIX.",
        caracteristica:
          "Es un perro algo independiente, aunque no por eso deja de ser leal, dulce y cariñoso con su familia. Se trata de un perro valiente y enérgico, al que hemos de socializar correctamente desde su juventud para potenciar sus cualidades. También son tranquilos y amables, desconfiados con los extraños (aunque no agresivos ni hostiles) y su relación con otras mascotas suele ser positiva y agradable para él.",
        recomendacion:
          "El galgo afgano es un perro que en un pasado fue pastor, corría por las montañas y guiaba a las ovejas. Por ese motivo se trata de un perro con altas necesidades de ejercicio físico.",
        ideal: "",
        dato: "El primer ejemplar del galgo afgano se encuentra en el año 1000 a.C",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 1,
        clima: 1,
        child: "inline",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/galgo-afgano.html",
        n: "/img/razas/211.jpg",
      },
      {
        nombre1: "Galgo Español",
        nombre2: "",
        pais_origen: "España",
        origen:
          "No se conoce con certeza el origen del galgo español. Algunas teorías sugieren que el podenco ibicenco, o algún ancestro de éste, habría tenido participación en el desarrollo de la raza. Otros piensan que el galgo árabe (saluki) es uno de sus ancestros.Fue una raza ampliamente utilizada para la caza durante la Edad Media.",
        caracteristica:
          "Es tímido y desconfiado, especialmente con desconocidos. Con la familia son perros gentiles, amables y afectuosos, además de ser sensibles y muy dulces. Suelen ser amigables con animales pequeños como gatos y perros de razas pequeñas.",
        recomendacion:
          "Se recomienda socializarlos en su etapa de cachorro y seguir haciéndolo en su etapa adulta.",
        ideal:
          "Suelen ser amigables con animales pequeños como gatos y perros de razas pequeñas. Disfrutan de un ambiente relajado dentro de casa pero fuera se vuelven animales veloces y activos que disfrutarán muchísimo al realizar excursiones, paseos largos y visitas a la playa. Es importante que sea adoptado por una familia proactiva y cariñosa.",
        dato: "Tal fue la importancia de estos perros para la caza en España, y la fascinación que causaron en la aristocracia, que incluso fueron inmortalizados en la obra Partida de caza (también conocida como Caza de la codorniz) del genial pintor español Francisco de Goya y Lucientes.",
        size: 3,
        vida: 3,
        deporte: 4,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/galgo-espanol.html",
        n: "/img/razas/155.jpg",
      },
      {
        nombre1: "Galgo Italiano",
        nombre2: "Pequeño Lebrel Italiano",
        pais_origen: "Egipto",
        origen:
          "Una de las razas más antiguas del mundo, pues existen pruebas arqueológicas que datan del año 3000 a. C. que prueban que los lebreles italianos ya existían en la Antigua Grecia. Incluso hay evidencia de que acompañaban a los faraones egipcios hace más de 6000 años. De esta forma, aunque el origen exacto del galgo italiano se desconoce, se sospecha que desciende de este lebrel de tamaño medio que ya existía en Grecia y Egipto.",
        caracteristica:
          "La dulzura y la inteligencia sobresalen. No son nada nerviosos y bastante silenciosos. Son animales muy hogareños, que requieren de mucha atención de su familia, con la que le encanta tener tanto momentos de juego y actividad como de descanso y tranquilidad.",
        recomendacion:
          "Necesitan un ambiente que les permita estar alejados de ruidos y agitaciones, porque son animales muy sensibles que se estresan fácilmente. Al tener el pelaje corto son más sensibles al frío.",
        ideal:
          "Se considera un muy buen compañero de gente mayor o de familias con hijos mayores.",
        dato: "Es uno de los 5 perros más pequeños del mundo. En Europa la raza fue muy apreciada durante siglos, acompañando a nobles y reyes en sus cacerías y reuniones, apareciendo así en pinturas y retratos de la Edad Media y el Renacimiento.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 2,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/galgo-italiano-o-pequeno-lebrel-italiano.html",
        n: "/img/razas/93.jpg",
      },
      {
        nombre1: "Goldador",
        nombre2: "Golden Lab",
        pais_origen: "Europa",
        origen:
          "Proviene del cruce entre los golden retriever y el labrador retriever. Recibe otros nombres como mix golden lab, golden retriever mix o goldador retriever. ",
        caracteristica:
          "Son increíblemente leales, de manera que se mantienen al lado de los suyos pese a cualquier problema o imprevisto. Dada su bondad y lo sociables que son, hasta con extraños, no resultan ser buenos perros guardianes. Eso sí, son muy buenos perros para cuidar a los niños (los adoran) y se llevan genial con otros animales (ya sean perros o cualquier otro animal). Son perros inteligentes que necesitan estimulación cognitiva para mantenerse activos mentalmente.",
        recomendacion:
          "El cachorro ha de ser vigilado continuamente, porque es muy curioso y esto puede hacer que no vea posibles peligros y se lance a la aventura.",
        ideal: "",
        dato: "Este cruce en particular comenzó a realizarse con la principal finalidad de obtener una raza óptima para ejercer como perros de terapia. Esta labor la desarrollan con gran éxito porque son tranquilos, pacientes y muy atentos.",
        size: 2,
        vida: 3,
        deporte: 2,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/goldador-o-golden-lab.html",
        n: "/img/razas/30.jpg",
      },
      {
        nombre1: "Golden Retriever",
        nombre2: "Cobrador dorado",
        pais_origen: "Escocia",
        origen:
          "Es originario de Escocia.  Según el Kennel Club de UK, Lord Tweedmouth es considerado el fundador de la raza, consecuencia del cruce del cobrador de pelo liso con el tweed water spaniel. Curiosamente, el fruto de ambas razas resultó en un perro de pelaje claro. Más adelante se añadieron a línea de sangre otras razas, como el bloodhound, el setter irlandés y otros perros perdigueros. La raza fue conocida como retriever amarillo o retriever de oro en 1913, y el nombre oficial fue modificado en 1920 cuando se le nombró golden retriever.",
        caracteristica:
          "Tiene un temperamento estable, gentil, paciente e inteligente, siendo además fáciles de adiestrar y muy dinámicos. Se demoran en madurar, siendo necesarios unos tres años o un poco más para que desarrollen su carácter definitivo.Tienen instintos relacionados con la caza y tienen una marcada predisposición a perseguir y atrapar objetos que son lanzados o presas que han caído. La sociabilidad del golden retriever con las personas suele ser excelente, llevándose muy bien con otros perros y personas, y tiende a evitar las peleas. ",
        recomendacion:
          "Es importante enseñarle a quedarse solo por determinados períodos de tiempo y desde cachorro, para que no desarrolle conductas inapropiadas o ansiedad por separación cuando sea adulto.",
        ideal:
          "Son excelentes perros de asistencia, de trabajo, de terapia y de compañía. Tienen a ser muy juguetones incluso cuando son adultos, por lo que son muy apreciados por las familias con niños.",
        dato: "Es un perro al que le encanta zambullirse en el agua y nadar por mucho tiempo. Su pelaje impermeable lo favorece en esta actividad, ya que le protege del frío. Otra particularidad es el interés que le despiertan las aves, y en inglés se conoce como birdy y en castellano podría decirse que el golden es un perro pajarero. Es considerado el cuarto perro más inteligente del mundo según Stanley Coren.",
        size: 2,
        vida: 2,
        deporte: 3,
        intel: 6,
        clima: 2,
        child: "none",
        depa: "inline",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "inline",
        link: "https://www.expertoanimal.com/razas-de-perros/golden-retriever-o-cobrador-dorado.html",
        n: "/img/razas/21.jpg",
      },
      {
        nombre1: "Goldendoodle",
        nombre2: "",
        pais_origen: "USA",
        origen:
          "Son perros mestizos nacidos del cruce entre un golden retriever y un caniche. Se empezaron a desarrollar para contar con más razas consideradas como hipoalergénicas(pierden poco pelo y no generan reacciones alérgicas, virtud que posee el caniche). De esta forma compensaban la exagerada caída de pelo de los golden retriever. La raza es alabada por sus dotes como perro guía y perro terapia. Nacieron en 1992 en Australia y en Estados Unidos al mismo tiempo.",
        caracteristica:
          "Tienen muy buen carácter, pues suelen ser increíblemente sociables, cariñosos y delicados. Dada su bondad y carácter extrovertido no son adecuados como perros vigía ni guardianes, pues no rechazan a los extraños.Tienen un carácter dócil y colaborativo en los entrenamientos, lo que los hace una de las razas híbridas más fáciles de entrenar. ",
        recomendacion:
          "Son muy activos, por lo que hay que asegurarse de que realizan suficiente actividad física de forma diaria. Si esto no se cumple pueden darse casos de goldendoodles traviesos que vuelcan sus energías en destrozos, o exceso de ladridos.",
        ideal:
          "Se llevan genial con todos: perros, gatos, niños, personas mayores, familias, personas solas… Ideal prácticamente para casi cualquier hogar y familia. Sin embargo, no lo es tanto para aquellos que suelan pasar mucho tiempo fuera de casa, pues no soportan la soledad prolongada.",
        dato: "Cuando nacen, los goldendoodle tienen un pelo liso y muy abundante, pero a partir de las 6 semanas de edad, ese pelo comienza a rizarse poco a poco. A los 3 meses de edad su pelo es ondulado, y a los 6 meses es completamente rizado.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/goldendoodle.html",
        n: "/img/razas/52.jpg",
      },
      {
        nombre1: "Gran Danés",
        nombre2: "",
        pais_origen: "Alemania",
        origen:
          "Los ancestros conocidos más antiguos de esta raza son el bullenbeisser (raza alemana extinta) y los perros alemanes usados para cazar jabalíes. Cruces entre esos perros dieron origen a diferentes tipos de dogos, a partir de los cuales se creó al gran danés actual en 1878.",
        caracteristica:
          "Son muy amistosos y cariñosos con su familia, aunque pueden ser desconfiado con los extraños. No suelen ser agresivos y siempre son buenos amigos de los niños, aunque mientras son perros jóvenes pueden resultar torpes para los más pequeños.No suelen ser destructores, pero pueden llegar a serlo cuando se quedan solos por mucho tiempo o si se aburren. También pueden ser destructores por su gran tamaño, especialmente cuando son cachorros y adolescentes, pero no son muy activos dentro del hogar.",
        recomendacion: "Necesitan compañía frecuente.",
        ideal:
          "Aunque son perros muy grandes, no se adaptan bien a vivir fuera en el jardín. Es mejor si se les permite vivir dentro del hogar, en el núcleo familiar, y salir solo para hacer ejercicio.",
        dato: "Con un mínimo de 70 cms de altura, es uno de los perros más grandes del mundo. Lo curioso del nombre de esta raza es que hace referencia a Dinamarca, cuando en realidad la raza se creó en Alemania a partir de perros alemanes. Es la raza del popular personaje Scooby-Do.",
        size: 4,
        vida: 1,
        deporte: 2,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "inline",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/gran-danes.html",
        n: "/img/razas/167.jpg",
      },
      {
        nombre1: "Gran Sabueso Anglo-francés Tricolor",
        nombre2: "",
        pais_origen: "Francia",
        origen:
          "Es el tercero de los grandes sabuesos franceses, desarrollados mediante cruces entre diferentes razas de caza francesas e inglesas (como el Foxhound inglés y el Pointevin).  Esta raza se recuperó a mitad del siglo XIX después de haberse casi extinguido durante la Revolución Francesa.",
        caracteristica:
          "Es muy activo durante la cacería y se obsesiona con la misma. Son valientes, dinámicos, inteligentes y colaboradores con los demás perros de la jauría, con los que se lleva muy bien. No son muy juguetones ni afectuosos.",
        recomendacion: "Requiere ejercitarse a diario para botar su energía.",
        ideal:
          "Criarlo junto con gatos u otros animales puede ser problemático. Además, es necesario que vivan en un lugar amplio con jardín o que tengan acceso al campo cada cierto tiempo, para que puedan gastar sus energías y satisfacer sus instintos cazadores. Por eso, no se adaptan bien a la vida en ciudad ni a la vida en departamentos o casas pequeñas.",
        dato: "Hoy en día todavía es empleado en Francia para la caza mayor, pero la raza no goza de mucha popularidad y es casi desconocida en el resto del mundo. Como su nombre indica solo puede ser tricolor, es decir blanco, marrón y negro.",
        size: 3,
        vida: 2,
        deporte: 4,
        intel: 4,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/gran-sabueso-anglo-frances-tricolor.html",
        n: "/img/razas/157.jpg",
      },
      {
        nombre1: "Greyhound",
        nombre2: "Galgo Inglés",
        pais_origen: "Inglaterra",
        origen:
          "El origen oficial de esta raza es Gran Bretaña. Si bien no se conocen los detalles del origen del greyhound, se piensa que en el año 900 D.C. Los ejemplares fundadores de la raza habrían sido transportados desde Arabia hasta Gran Bretaña por comerciantes, siendo éstos el galgo árabe.",
        caracteristica:
          "Son perros amables, sensibles y tiernos. Sin embargo, tienden a ser independientes y reservados, por lo que también necesitan sus tiempos y espacios. Su instinto cazador es muy fuerte, por lo que también tienden a perseguir todo lo que se mueve rápidamente.",
        recomendacion:
          "Debido a que son perros desconfiados, es importante sociabilizarlos desde cachorros. Es mejor si se cuenta con un jardín grande donde pueda correr, y también es importante sacarlo a pasear con frecuencia.",
        ideal:
          "Suelen llevarse bien con los niños, pero no disfrutan los juegos rudos, así que no son la mejor mascota para niños muy pequeños. Los niños más grandes, más respetuosos con los animales, son mucho más adecuados para criarlos.",
        dato: "Es el perro más rápido del mundo, capaz de alcanzar velocidades de hasta 65 kilómetros por hora.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 3,
        clima: 3,
        child: "inline",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/greyhound-o-galgo-ingles.html",
        n: "/img/razas/126.jpg",
      },
      {
        nombre1: "Grifón Belga",
        nombre2: "Petit Brabancon",
        pais_origen: "Bélgica",
        origen:
          "Descienden del Smousje, un antiguo perro tipo terrier con el pelo duro que vivía en Bruselas y se usaba para eliminar ratas y ratones en establos. Durante el siglo XIX, estos perros belgas fueron cruzados con pugs, carlinos y con King Charles spaniels, dando origen a los actuales grifones belgas.",
        caracteristica:
          "Son un poco nerviosos, pero activos, alertas y valientes. Normalmente se apegan a una sola persona, a quien acompaña la mayor parte del tiempo. Son difíciles de socializar con otros perros de compañía, ya que su carácter es fuerte y temerario, y pueden enojarse con otros perros. Necesitan mucha actividad física.",
        recomendacion:
          "Como estos perros necesitan mucha compañía, son de personalidad fuerte y tienden a seguir a una misma persona. En caso de estar solos por mucho tiempo pueden sufrir de ansiedad por separación.",
        ideal:
          "Son excelentes mascotas para personas adultas que tienen tiempo suficiente para dedicarles a sus canes. No son buenas mascotas para propietarios primerizos, ya que necesitan mucha atención. Tampoco lo son para familias con niños, porque suelen reaccionar mal ante los movimientos repentinos y los ruidos. Se adaptan bien a vivir en un departamento, pero es mejor que vivan en una zona calmada y tranquila y no en el centro de grandes ciudades.",
        dato: "La popularidad de esta raza  creció repentinamente en Bélgica y toda Europa cuando la reina María Enriqueta introdujo la cría y tenencia de estos animales.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 2,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/grifon-belga.html",
        n: "/img/razas/102.jpg",
      },
      {
        nombre1: "Harrier",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Fue desarrollada en Reino Unido con el objetivo de crear un perro hábil y atlético que fuera apto para la caza de liebres en manada. El primer grupo de harriers del que se tiene constancia data del año 1260, por lo que se trata de una raza canina especialmente antigua. No obstante los orígenes siguen siendo inciertos y actualmente se considera que es una versión reducida del foxhound inglés, algo que se ha logrado gracias a la crianza selectiva.",
        caracteristica:
          "Destaca principalmente por ser extrovertido, sociable y amistoso, tanto con las personas como con otros perros. Por lo mismo suele ser muy cariñoso con los desconocidos y no cumplir bien la función de perro guardián.",
        recomendacion:
          "Teniendo en cuenta que se trata de una raza especialmente activa, necesitará realizar por lo menos un paseo al día, combinando con ejercicio físico. Es especialmente importante que ejercitemos a este perro para evitar problemas de comportamiento, como el estrés y la destructividad.",
        ideal: "",
        dato: "El perro harrier destaca como sabueso por su increíble y potente olfato, que le ha convertido actualmente en uno de los perros detectores de sustancias olorosas más cualificados.",
        size: 2,
        vida: 2,
        deporte: 3,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/harrier.html",
        n: "/img/razas/94.jpg",
      },
      {
        nombre1: "Husky Inu",
        nombre2: "Shiba Husky",
        pais_origen: "Siberia",
        origen:
          "Es una raza mixta que nace del cruce de un ejemplar de pura raza de husky siberiano y otro de shiba inu. Los husky son perros de origen ruso, populares por protagonizar diversas expediciones realizadas en Alaska durante el pasado siglo. Los shiba inu, a su vez, son de origen japonés y recuerdan en apariencia a un zorro rojo. Se desconoce con exactitud el momento y lugar de aparición de la raza híbrida husky inu.",
        caracteristica:
          "El carácter depende fundamentalmente de la genética predominante. Si se parece más al husky, suele ser atento y muy cariñoso, mientras que si se asemeja más al shiba inu, es probable que sea más independiente y reservado. De esta forma, el husky inu será más o menos dependiente y afectuoso en función de la herencia genética, aunque siempre se le considera una raza que se vale por sí misma y no necesita atención constante.",
        recomendacion:
          "Se recomienda comenzar con los entrenamientos cuando son apenas unos cachorros, sino se vuelven traviesos y muestran conductas no deseadas.",
        ideal:
          "El alto porcentaje de estos perros muestra un carácter dominante, especialmente con otros animales, aunque también puede darse con las personas. Esto puede llevar a que en muchos casos esa dominancia genere situaciones adversas o comportamientos agresivos por parte del husky inu. Por ello, esta raza no está recomendada para novatos que no estén acostumbrados a educar a sus perros, ya que requiere atención y experiencia para no tener problemas.",
        dato: "Es relativamente frecuente encontrar ejemplares con heterocromía (que tienen un ojo de cada color).",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/husky-inu.html",
        n: "/img/razas/33.jpg",
      },
      {
        nombre1: "Husky Siberiano",
        nombre2: "",
        pais_origen: "Rusia",
        origen:
          "Nace gracias a la tribu Chukchi, originaria de Chukotka, Rusia. La tribu lo utilizaba como perro de compañía, pastor de ciervos, tirador de los trineos e incluso para mantener calientes a los niños en las noches de frío.",
        caracteristica:
          "Cariñosos, juguetones y afables que disfrutan encontrándose en medio del núcleo familiar. A veces su carácter puede ser tímido y distante con personas desconocidas. Es una raza que disfruta de la compañía de otros perros, y son utilizados para diversos deportes gracias a su resistencia y excelente forma física.",
        recomendacion:
          "Al tratarse de una raza muy activa, es muy importante que le les demos juguetes para que se entretenga solo y que les demos una alta dosis de ejercicio diario. Se le conoce como un perro andarín, que si no permanece bajo vigilancia es capaz de andar y olvidarse de dónde está su hogar. Por este motivo recomendamos la utilización del chip y tener una placa con su nombre y tu número de teléfono en su collar.",
        ideal: "",
        dato: "Se originó hace más de 3000 años, lo que las convierte en una de las razas de perros más antiguas del mundo.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 3,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "inline",
        salud: "inline",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/husky-siberiano.html",
        n: "/img/razas/8.jpg",
      },
      {
        nombre1: "Jack Russell Terrier",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Su origen ocurrió en Reino Unido, siglo XVIII. Entre 1795 y 1883, el reverendo John Jack Russell, un apasionado de la caza de los zorros, compró una hembra de fox terrier a la que llamó Trump. Ésta era una perra de trabajo ideal, por lo que empezó a criar una línea de terriers con grandes capacidades para la caza del zorro, los cuales pasarían a llamarse Jack s Russell (Russells de Jack , en español). A John Russell, al cual se le consideraría más adelante como el padre de la raza jack russell terrier, no le importaba tanto lograr un aspecto físico homogéneo en esa nueva raza, sino conseguir una línea perfecta de perros para el trabajo en la madriguera.",
        caracteristica:
          "Temperamental, trabajador, audaz, intrépido, curioso, muy activo y siempre está alerta. También es inteligente, muy fiel y valiente a pesar de su reducido tamaño. Es un excelente perro de trabajo, al que le podremos enseñar técnicas relacionadas con la tierra por su habilidad rastreadora. Al estar siempre alerta y ser tan curioso, tiende a ladrar mucho, sobre todo cuando scucha algún ruido extraño o aparezca alguien que no conoce.",
        recomendacion:
          "Mientras el perro crece, los paseos también deben ir aumentando y ser cada vez más largos. Tiene tendencia a padecer obesidad si no se cuida su alimentación, así como problemas de carácter osteoarticular por su rápido crecimiento. De ahí, también, la importancia del ejercicio. Eso sí, al ser tan excitable, activo, enérgico y temperamental, si disponemos de jardín y no le ofrecemos el ejercicio suficiente es posible que nos encontremos con algunos hoyos cavados por él.",
        ideal:
          "Debido a su temperamento, es altamente beneficioso su convivencia con niños, porque es un perro que raras veces se cansa y necesita jugar para quemar energía. Si no hay niños en casa ni somos personas activas no se recomienda adoptalo. Es ideal para vivir tanto en departamentos chicos como en casas más grandes, ya que se adapta a todos los espacios siempre y cuando disponga de un tiempo mínimo de ejercicio al día.",
        dato: "A pesar de tener varios años de historia, la FCI reconoció la raza recién en el año 2000.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/jack-russell-terrier.html",
        n: "/img/razas/9.jpg",
      },
      {
        nombre1: "Kangal",
        nombre2: "",
        pais_origen: "Turquía",
        origen:
          "Forma parte de un grupo de razas de perros pastores o guardianes de ganado llamados Çoban Köpegi. Proviene de Turquía y ya existía en el imperio romano, donde los soldados los usaban para acompañar al ejército en sus marchas. Se cree que proviene de 3 cruces: los perros del imperio Asirio, que eran de tipo mastín (llamados molosos de Asiria), los molosos romanos provenientes de Grecia y los mastines ingleses. Se supone que los romanos crearon a este potente híbrido para usarlo como protector y guardián de sus rebaños en tiempos de conquistas.",
        caracteristica:
          "Es serio y reservado, típico de perro guardián. Puede ser agresivo con personas desconocidas y generalmente es agresivo con otros perros, especialmente del mismo sexo.  Con su familia es muy amigable, tolerante y protector. Las desventajas son sus ladridos excesivos y la destrucción de cosas.",
        recomendacion:
          "Su socialización desde temprana edad es muy importante.",
        ideal:
          "No son aptos para vivir en departamentos o casas pequeñas. Necesitan un jardín grande para poder caminar y correr cuando les plazca, y mejor aún si es en una zona rural. La valla debe ser suficientemente alta y bien construida, ya que los kangales pueden saltar muy alto.",
        dato: "Es la raza nacional de Turquía.",
        size: 4,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/kangal.html",
        n: "/img/razas/190.jpg",
      },
      {
        nombre1: "Keeshond",
        nombre2: "Spitz tipo lobo",
        pais_origen: "Holanda",
        origen:
          "Es de origen Holandés y en el siglo XVIII era conocida como el perro de la gente. Proviene de sus parientes los chow chow, los elkhound, los samoyedos y los pomerania. Se llaman keeshond porque a principios de la Revolución Francesa, un patriota llamado Gyselaer, que tenía un perro de esta raza, lo llamó Kees y lo hizo símbolo de la Patria Holandesa.",
        caracteristica:
          "Esta raza de perros es alegre, alerta, dinámica y está muy apegada a sus familia. También son reservados con los extraños y ladradores, por lo que pueden ser buenos perros guardianes, aunque no son buenos como perros de protección.",
        recomendacion:
          "Hay que tener especial cuidado con otros perros del mismo sexo. Toleran muy bien los climas fríos a temperados, pero no el calor intenso, del que tenemos que tener cuidado. ",
        ideal:
          "No suelen ser buenos perros para niños muy pequeños, ya que su comportamiento es reactivo y pueden mordisquear si son maltratados de alguna manera, aunque sea sin querer. Pueden adaptarse bien a vivir en departamento o casas pequeñas, pero es mejor si cuentan con un pequeño jardín.",
        dato: "La cabeza del keeshond es mediana y vista desde arriba tiene forma de cuña, muy parecida a la cabeza de un zorro.",
        size: 2,
        vida: 3,
        deporte: 1,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/keeshond.html",
        n: "/img/razas/113.jpg",
      },
      {
        nombre1: "Kelpie Australiano",
        nombre2: "",
        pais_origen: "Australia",
        origen:
          "El origen de la raza es incierto, pero se ha podido demostrar que son descendientes de perros diversos tipos de collie escoceses que fueron llevados a Australia para utilizarlos como pastoreo. Estos perros sustituyeron a los convictos que antes se encargaban de pastorear las ovejas, y que se habían vuelto poco prácticos al aumentar el número y el tamaño de los rebaños. Fue ahí cuandose decidieron recurrir a los perros pastores, y debido al clima el más adecuado era el kelpie australiano, que terminó con una gran popularidad entre los terratenientes.",
        caracteristica:
          "Son perros muy activos, sociables y predispuestos a realizar tareas. Además son extremadamente obedientes (lo cual hace recordar que provienen de los collie), inquietos y muy inteligentes.",
        recomendacion:
          "Hay que dedicarle tiempos de juegos y ejercicios diarios, ya que estos animales necesitan liberar la cantidad de energía que tienen. Se muestran fuertes aun cuando están enfermos, por lo que a veces es difícil saber qué les pasa algo hasta que ya están bastante mal (se recomienda llevarlo al veterinario de forma regular).",
        ideal:
          "Se adaptan fácilmente a la vida en cualquier parte: departamentos, casas o terrenos. Aunque si viven en un lugar con poco espacio debemos de ser muy rigurosos en cuanto al tiempo que pasan realizando actividad física, algo fundamental para que permanezcan sanos y equilibrados.",
        dato: "Son animales muy resistentes debido a la doble capa de pelaje que aísla su piel de las altas temperaturas y los rayos ultravioleta. Este manto mide entre 2 y 3 centímetros de largo y es denso y duro, lo que hace que también sea resistente al agua. ",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/kelpie-australiano.html",
        n: "/img/razas/50.jpg",
      },
      {
        nombre1: "Kerry Blue Terrier",
        nombre2: "",
        pais_origen: "Irlanda",
        origen:
          "Su origen tuvo lugar en el condado de Kerry, al suroeste de la provincia irlandesa de Munster. Esta raza era muy típica en la región, ejerciendo las labores de un perro de caza. Destacaban sus dotes para la caza de nutrias (incluso cuando éstas estaban sumergidas en profundas aguas) y de los tejones (a los que perseguían a través de sus túneles subterráneos). ",
        caracteristica:
          "Son muy activos física y mentalmente, siendo inquietos y curiosos. Como perros terriers que son, destacan su permanente estado de alerta, su astucia y por ser verdaderos amantes de su familia. También son teztarudos y territoriales, con carácter bastante potente, el cual puede hacer que tengan una difícil educación.",
        recomendacion: "",
        ideal:
          "Les gusta mucho dedicarse a su familia y pasar el tiempo en compañía, la cual requieren para no sufrir alteraciones como la ansiedad por separación. Por este motivo, el kerry blue terrier no es adecuado para la vida en solitario.",
        dato: "Pese a ser una raza tan común, no existen datos que permitan datar con exactitud la fecha de origen del kerry blue. Sin embargo, se cree que lleva presente en Irlanda desde hace varios siglos (las primeras referencias datan del año 1847).",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/kerry-blue-terrier.html",
        n: "/img/razas/14.jpg",
      },
      {
        nombre1: "Kishu Inu",
        nombre2: "Kishu Ken",
        pais_origen: "Japón",
        origen:
          "Tienen una larga historia: estos perros ya estaban presentes en el archipiélago japonés hace ya unos 3 000 años. Se desconoce su procedencia exacta, aunque se especula que probablemente provienen de perros que acompañaron a grupos de nómadas originarios de China.",
        caracteristica:
          "Vivaz, muy despierto y siempre alerta. Siempre ha sido considerado como un cazador excelente. También, esto unido a su desconfianza hacia los extraños, lo ha llevado en muchas ocasiones a ejercer como perro de vigilancia. Es curioso y le encanta explorar sin parar.",
        recomendacion:
          "No soporta la soledad. Con su familia es un perro muy cariñoso, confiado, dócil y muy fiel, pero con los extraños se muestra tímido, reticente y, si ve peligro, hasta agresivo, por lo que una temprana socialización es importante.",
        ideal: "",
        dato: "La historia de la raza dejó de ser un camino de rosas con la llegada de la Segunda Guerra Mundial, siendo prácticamente aniquilada. Actualmente la raza parece haberse recuperado, restableciéndose paulatinamente, aunque no saliendo en general de las fronteras japonesas.",
        size: 2,
        vida: 2,
        deporte: 3,
        intel: 4,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/kishu-inu-o-kishu-ken.html",
        n: "/img/razas/23.jpg",
      },
      {
        nombre1: "Kuvasz",
        nombre2: "",
        pais_origen: "Hungría",
        origen:
          "Es un perro autóctono de Hungría, país en el que se lo conoce desde la Antigüedad. Si bien se sabe poco sobre sus orígenes, se cree que sus antepasados descienden de perros asiáticos que solían acompañar a los pueblos nómadas Magyares, quienes migraban a través de la cuenca de los Cárpatos. Los Magyares utilizaban a estos canes robustos y de denso pelaje para proteger a sus rebaños de depredadores naturales y eventuales ladrones.",
        caracteristica:
          "Tienen gran valentía y seguridad. Generan un vínculo muy profundo con sus tutores y familiares, quienes no dudará en defender frente a cualquier amenaza. Es tranquilo, estable y muy afectuoso.",
        recomendacion:
          "Son desconfiados en la presencia de animales y personas extrañas, y necesitan ser socializados correctamente para aprender a relacionarse bien. Así van a entender a tratar a los demás como miembros de su familia, y no de una manada que debe pastorear.",
        ideal:
          "No es un perro recomendable para tutores poco experimentados o que no cuentan con el tiempo y la paciencia necesarias. Necesita espacio para desarrollarse y expresarse. No es aconsejable su tenencia en espacios especialmente reducidos, pues se adapta mejor a hogares con un espacio abierto con jardín, donde pueda correr, saltar, jugar y explorar su entorno.",
        dato: "Ganaron mucha popularidad entre la aristocracia húngara, acompañando a los noble en sus jornadas de cacería durante el siglo XV. Actualmente es entrenado para acompañar al ejército y la policía de Hungría.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 3,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/kuvasz.html",
        n: "/img/razas/76.jpg",
      },
      {
        nombre1: "Labradoodle ",
        nombre2: "Australian Labradoodle",
        pais_origen: "Australia",
        origen:
          "El primer ejemplar reconocido de labradoodle fue registrado en el año 1955. Sin embargo, no fue hasta 1988 que el criador australiano Wally Conron dio a conocer al mundo esta raza híbrida llamada “Guía de Perros Victoria”. El objetivo de este cruce era el de obtener un perro hipoalergénico, cariñoso, leal y con grandes dotes para el aprendizaje.",
        caracteristica:
          "Son sumamente sociables e inteligentes, algo que no es de extrañar porque tanto el caniche como el labrador retriever se encuentran en las primeras posiciones del ranking de perros más inteligentes. También destacan por ser equilibrados, tranquilos, dóciles y dispuestos al aprendizaje.",
        recomendacion:
          "Una de las más importantes es la compañía, además de muchísimo cariño, pues se trata de un perro que necesitan estar acompañado para mantenerse feliz y equilibrado. Ante la soledad se vuelve taciturno, triste y esquivo, ya que le genera mucha frustración y ansiedad. Es importante socializar al perro a una edad temprana, puesto que así será tan extrovertido y amigable en vez de tímido y desconfiado.",
        ideal:
          "Muy adecuado para familia, pues adoran a los niños y les encanta pasar tiempo con ellos, cuidándolos y jugando. También son buenos perros de terapia, así como reconocidos perros guías hábiles y colaborativos. Se adaptan bien a todos los espacios y compañías, siendo amigables con todos.",
        dato: "Los cachorros no siguen un estándar concreto, existiendo una inmensa variabilidad de unos a otros. Incluso los cachorros de una misma camada y un mismo sexo pueden tener tremendas diferencias.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/labradoodle-o-australian-labradoodle.html",
        n: "/img/razas/54.jpg",
      },
      {
        nombre1: "Labrador Retriever",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Su origen comienza en la isla de Newfoundland (Canadá). En la isla se habría desarrollado el perro de San Juan, que era utilizado por los pescadores ingleses para ayudar en las actividades pesqueras, arrastrando hasta la orilla líneas de redes de pesca. Estos perros debían ser resistentes, trabajadores y buenos nadadores, además de necesitar un pelaje denso que los protegiese de las gélidas aguas del norte y colas gruesas que sirvieran como timón. A mediados del siglo XIX, algunos perros de San Juan fueron exportados a Inglaterra, donde fueron empleados por un puñado de criadores para obtener el perro cobrador perfecto. Fue así que, tras varias generaciones y una selección minuciosa, nació en Inglaterra el perro labrador retriever.",
        caracteristica:
          "Tiene una apariencia amigable y un carácter excepcionalmente sociable, leal, inteligente y amante de la diversión. Es fácil de entrenar, por lo que resulta una buena compañía si se cuenta con el tiempo y el espacio suficiente. También presenta una notable predisposición a aprender rutinas y acciones, aunque sean complejas. Es relativamente sano y longevo, destacándose por su buena forma física y su excelente estado de salud.",
        recomendacion:
          "Tiene mucha energía y necesita mucho ejercicio. Por esto, aunque puede adecuarse a vivir en un departamento, es necesario que reciba largos paseos y pueda jugar con otros perros. A pesar de sus grandes cualidades, el labrador retriever tiende a solicitar atención frecuentemente y es importante educarlo desde cachorro para evitar problemas de búsqueda excesiva de atención y de ansiedad por separación.",
        ideal:
          "Suelen tener una adolescencia prolongada, por lo que no son las mejores mascotas para personas que prefieren llevar una vida sedentaria. Sí son una buena opción para quienes disfrutan de actividades físicas al exterior.",
        dato: "Es uno de los perros preferidos para los grupos K-SAR (perros de búsqueda y rescate), los guías para ciegos, los perro de asistencia y los perros de terapia. Es la mascota canina más popular en el mundo y con mayores mascotas registradas.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 6,
        clima: 2,
        child: "inline",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "inline",
        intel2: "inline",
        link: "https://www.expertoanimal.com/razas-de-perros/labrador-retriever.html",
        n: "/img/razas/97.jpg",
      },
      {
        nombre1: "Lebrel Escocés",
        nombre2: "Deerhound",
        pais_origen: "Escocia",
        origen:
          "A pesar de que no se conoce con detalle el origen del lebrel escocés, se suele asociar a esta raza con el galgo inglés o greyhound debido a sus similitudes morfológicas. Se cree que la misma línea de lebreles que originó el greyhound en Inglaterra dio origen al deerhound en Escocia, debido al clima más frío de las tierras altas de ese país.",
        caracteristica:
          "Es tranquilo, cariñoso, sociable y gentil, tanto con las personas como con otros perros. Además suele ser leal y valiente, aunque no sirve como perro guardián porque tiende a hacerse amigo de todos. Son fáciles de entrenar, debido a que les gusta complacer a sus familiares.",
        recomendacion:
          "Se lo debe socializar desde cachorro para reducir cualquier posibilidad de agresión o de timidez, ya que es un perro muy grande y rápido. Sin embargo, tenemos que considerar que no son tan activos como los cachorros, y necesitan contar con un espacio propio en el que no sean molestados.",
        ideal: "Son excelentes compañeros de los niños.",
        dato: "En la Edad Media, el lebrel escocés era empleado para cazar ciervos (de ahí su nombre Deerhound). Por esa época era el perro preferido por los jefes de los clanes escoceses, e incluso llegó a ser considerado como el perro real de Escocia.",
        size: 4,
        vida: 1,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/lebrel-escoces-o-deerhound.html",
        n: "/img/razas/177.jpg",
      },
      {
        nombre1: "Lhasa apso",
        nombre2: "",
        pais_origen: "China",
        origen:
          "El Lhasa apso proviene de la ciudad de Lhassa en el Tíbet y originalmente fue criado como perro guardián de los monasterios tibetanos. Mientras el mastín del Tíbet era empleado para la guardia afuera de los monasterios, el Lhasa apso era el preferido para la guardia adentro de los mismos. ",
        caracteristica:
          "Es uno de los mejores ejemplos de que un perro pequeño puede ser un gran guardián. Dado su uso como perro de guardia, el Lhasa apso ha evolucionado como un perro seguro de sí mismo, fuerte y activo, que requiere de bastante ejercicio físico y mental. En general hablamos de un perro muy sano.",
        recomendacion:
          "Tiende a ser independiente, por lo que la socialización temprana es muy importante. Necesitan cepillado frecuente, incluso más de una vez por día, sino el pelo se enredará y se formarán nudos.",
        ideal:
          "Será una buena compañía para cualquier familia, pero los niños representan una amenaza aparente (y muchas veces real) para la mayoría de los perros pequeños. Por tanto, el Lhasa apso es más adecuado para familias con hijos ya crecidos o con niños los suficientemente maduros para cuidar adecuadamente de su perro. Puede vivir perfectamente en un departamento.",
        dato: "En su tierra natal todavía es conocido como Abso Seng Kye, que significa algo así como perro-león centinela. Posiblemente lo de león venga de su abundante melena, o tal vez de su gran valor y coraje.",
        size: 1,
        vida: 4,
        deporte: 2,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "inline",
        antig: "inline",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/lhasa-apso.html",
        n: "/img/razas/206.jpg",
      },
      {
        nombre1: "Lobero Irlandés",
        nombre2: "Lebrel Irlandés",
        pais_origen: "Irlanda",
        origen:
          "Se cree que estos perros descienden de los primeros lebreles egipcios que llegaron a Irlanda a través de los celtas, quienes se interesaron por criar perros altos y de gran tamaño. Ya constaba la existencia de estos perros en el año 391 d.C.. Antiguamente era también conocido como cu, pues en la Antigua Roma se le bautizó como Cú Faoil, que en gaélico significa sabueso.",
        caracteristica:
          "Son muy dóciles y muy pacíficos. Antiguamente se les atribuía el dicho Corderos en el hogar, leones en la caza, debido al contraste entre lo tranquilos que son con la familia y loa ctivos al momento de cazar. Es una raza relativamente sencilla de entrenar, pues son inteligentes y responden bien a la educación.",
        recomendacion:
          "Estos perros necesitan realizar como mínimo una hora de ejercicio físico al día. Para evitar la torsión estomacal hay poner la comida alta en lugar de a nivel del suelo, evitar que realicen actividad física justo después de haber comido o darles grandes cantidades de alimento en una sola vez.",
        ideal:
          "Se amoldan casi a cualquier tipo de convivencia, ya sea esta con niños, ancianos, mascotas, otros perros... Su nobleza es tal, que difícilmente existirán enfrentamientos con cualquiera que forme parte de su familia, a la que defiende sin dudarlo, siendo un gran perro protector. Sin embargo, se recomienda tenerlo en un lugar espacioso, como una casa en el campo o algún terreno por el que puedan moverse, no siendo la mejor opción tenerlos en un departamento.",
        dato: "La esperanza de vida se sitúa tan solo entre los 6 y 8 años, siendo una de las razas con más problemas de salud del mundo.",
        size: 4,
        vida: 1,
        deporte: 3,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/lobero-irlandes.html",
        n: "/img/razas/75.jpg",
      },
      {
        nombre1: "Mal-Shi",
        nombre2: "Tzu Maltés",
        pais_origen: "Australia",
        origen:
          " Se desconoce el lugar y momento de aparición de los primeros ejemplares. Lo que sí puede afirmarse es que proviene del cruce de dos razas puras, el shih tzu y el bichón maltés. ",
        caracteristica:
          "Tierno, cariñoso,, muy sociables y realmente familiares, y que disfrutan mucho de la compañía de su familia y de otras mascotas. No duda en acercarse incluso a desconocidos, buscando su atención y su cariño, lo que también lo hace ser un mal perro guardián.",
        recomendacion:
          "Se aconseja realizar una socialización temprana, comenzando con ello lo antes posible. Así, conseguiremos un perro realmente abierto y flexible a los cambios y en lo referente a la convivencia con otros . Como es un perro tan juguetón, adora tener juguetes por todos lados, algo que recomendamos para evitar que se aburra y pueda terminar haciendo travesuras indeseadas.",
        ideal:
          "Se adaptan bien a la vida en departamentos y casas. Lo más importante es que tengan compañía.",
        dato: "Sus ojos son peculiares e increíblemente dulces y expresivos, presentando un color oscuro y una forma redondeada.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 1,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/mal-shi.html",
        n: "/img/razas/35.jpg",
      },
      {
        nombre1: "Maltipoo",
        nombre2: "",
        pais_origen: "USA",
        origen:
          "De origen realmente reciente, en 1990 que hicieron su aparición los primeros cachorros de maltipoo. Ocurrió en Estados Unido y se cree que la finalidad era conseguir perros con pelaje hipoalergénico, ya que ambas razas originarias (caniche toy y el bichón maltés) son consideradas como aptas para alérgicos.",
        caracteristica:
          "Destaca por su inteligencia y vivacidad. Es igualmente cariñoso y le encanta pasar tiempo con su familia, además de ser sumamente alegre y bondadoso.",
        recomendacion:
          "Como animal de compañía, lo que más ha de preocuparnos es estar seguros de que dispondremos del tiempo suficiente para estar con él, enseñarle y entregarle cariño.",
        ideal:
          "No tolera en absoluto la soledad, por lo que si solemos pasar mucho tiempo fuera de casa esta no es nuestra raza. Estar solo durante horas le genera tal ansiedad y tristeza que puede caer en profundas depresiones, llegando a estar realmente mal si esto se prolonga. Se lleva de maravilla con niños y ancianos, por lo que es fabuloso para familias con hijos o personas mayores: con ambos es respetuoso y atento.",
        dato: "Es un perro bastante fácil de adiestrar debido a que proviene de dos razas dóciles e inteligentes. De esta forma, se combina la inteligencia y la curiosidad de caniches y malteses con un carácter afable y dócil propio de los maltipoo.",
        size: 1,
        vida: 2,
        deporte: 2,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/maltipoo.html",
        n: "/img/razas/53.jpg",
      },
      {
        nombre1: "Mastín del Pirineo",
        nombre2: "",
        pais_origen: "España",
        origen:
          "Originada en los Pirineos, en concreto del Pirineo aragonés. Tradicionalmente el mastín del Pirineo era utilizado para cuidar los rebaños bovinos en las travesías que los pastores realizaban antiguamente. Sus orígenes genéticos muestran que provienen de cruces entre perros de montaña y mastines españoles.",
        caracteristica:
          "Destaca por la nobleza y la lealtad. Así mismo, debido a la selección de la raza, hablamos también de perros especialmente fieles, valientes y protectores, pero a la vez calmados, relajados y seguros de sí mismo.",
        recomendacion:
          "Debemos socializarlo desde cachorro para evitar el desarrollo de un carácter excesivamente territorial, debido a su pasado como perro guardián y pastor. Por su gran tamaño no siempre controlan bien sus fuerzas, por lo que deberemos ser cuidadosos con animales pequeños, niños y objetos.",
        ideal: "",
        dato: "Los machos pueden llegar a alcanzar los 100 kilos de peso.",
        size: 4,
        vida: 1,
        deporte: 3,
        intel: 1,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/mastin-del-pirineo.html",
        n: "/img/razas/69.jpg",
      },
      {
        nombre1: "Mastín Español",
        nombre2: "",
        pais_origen: "España",
        origen:
          "Desde antaño, el mastín español ha estado muy presente en las fincas y terrenos de la España más rural. Se duda acerca de sus orígenes, puesto que por una parte se cree que llegó a través de los celtas y los fenicios, y por otra se sospecha que los romanos lo usaban como perro de combate.  Lo que es cierto es que en el año 1273, año de fundación de la Mesta, los mastines ya llevaban a cabo labores de pastoreo en la península ibérica.",
        caracteristica:
          "Es equilibrado y muy cariñoso, dócil y extremadamente leal, considerándose una de las razas de perros más tranquilas del mundo. Es un animal apto para cualquier familia que pueda ejercitarlo y educarlo. Destaca también por ser muy inteligente e intuitivo, por lo que es fácil educarlo.",
        recomendacion:
          "Es importante cuidar todo lo que entra en lo que ellos consideran su territorio, ya que se trata de una raza guardiana por excelencia y pueden atacar a aquellos que consideran intrusos. Necesita mucha actividad física y muchos paseos, sobre todo si es que vive en un departamento, para así evitar el sobrepeso. Hay que iniciar el proceso de socialización del cachorro lo antes posible.",
        ideal:
          "Podríamos tener problemas con los vecinos debido a sus ladridos, por lo que no es aconsejable para departamentos o comunidades muy cerradas.",
        dato: "Está considerada como la raza canina más grande de España. Los machos pueden llegar a pesar hasta 100 kilos.",
        size: 4,
        vida: 3,
        deporte: 3,
        intel: 1,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/mastin-espanol.html",
        n: "/img/razas/70.jpg",
      },
      {
        nombre1: "Mastín inglés",
        nombre2: "Mastiff",
        pais_origen: "Bretaña",
        origen:
          "Comenzaron en la época del Imperio Romano, en Bretaña (siglo VI a.C). Se cree que fueron los fenicios los que introdujeron los primeros perros del mastín inglés y el mastín napolitano. Fue utilizada en arenas de combate debido a su fuerza y contextura.",
        caracteristica:
          "Es muy tranquilo y dócil, además de cariñoso y muy valiente.  Su instinto protector es muy marcado y es desconfiado con extraños, pero nunca agresivo. No resalta por ser de gran inteligencia, ya que generalmente suele actuar por instinto y es algo torpe.",
        recomendacion:
          "Necesita hacer ejercicio diario de al menos una hora, ya que podría volverse algo perezoso. Cuando son cachorros no es recomendable el ejercicio excesivo, ya que son propensos a desarrollar problemas óseos, lo que durante la época de crecimiento podría traer problemas con esguinces o desgarros.",
        ideal:
          "Leal compañero para niños mayores, teniendo mucha paciencia con ellos y con los juegos, sobre todo si tiene un espacio apropiado a su tamaño.",
        dato: "En la actualidad existen dos líneas de springer, el inglés y el galés, siendo el inglés la raza de perros cazadores más antigua y la que hasta el día de hoy se mantiene pura.",
        size: 4,
        vida: 3,
        deporte: 2,
        intel: 1,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/mastin-ingles-o-mastiff.html",
        n: "/img/razas/4.jpg",
      },
      {
        nombre1: "Mastín Napolitano",
        nombre2: "Mastino Napoletano",
        pais_origen: "Italia",
        origen:
          "Cuando los romanos invadieron las Islas Británicas, llevaron consigo sus enormes molosos que eran empleados como perros de guerra, atacando sin piedad las huestes enemigas. Sin embargo, se encontraron con perros más feroces aún que defendían las islas. Los romanos quedaron tan impresionados con esos ancestros del mastín inglés que los cruzaron con sus molosos y así aparecieron los predecesores del mastín napolitano moderno. Con el paso del tiempo, estos mastines quedaron relegados casi exclusivamente a la región de Nápoles y fueron empleados principalmente como perros guardianes.",
        caracteristica:
          "Firme, decidido, independiente, cauteloso y leal. Tiende a ser reservado y desconfiado con los extraños pero puede convertirse en un perro muy sociable si les enseñamos desde cachorro. No ladra sin motivo y no es demasiado activo para su tamaño.",
        recomendacion:
          "Puede ser muy destructor si no tiene la compañía y el cariño que requiere. Puede no ser totalmente consciente de su gran tamaño, por lo que los juegos con niños y desconocidos deben estar siempre supervisados.",
        ideal:
          "Es recomendable es que sean adoptados por personas ya experimentadas en cuidar a perros.",
        dato: "Hoy en día es un perro muy conocido en todo el mundo y ha perdido gran parte del temperamento agresivo y violento de sus ancestros.",
        size: 3,
        vida: 1,
        deporte: 3,
        intel: 2,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/mastin-napolitano-o-mastino-napoletano.html",
        n: "/img/razas/170.jpg",
      },
      {
        nombre1: "Mastín Tibetano",
        nombre2: "Dogo del Tíbet",
        pais_origen: "China",
        origen:
          "Es una de las razas orientales más antiguas que existen. Fue conocida por ser una raza de trabajo de los antiguos pastores nómadas del Himalaya, así como un perro de protección de los monasterios tibetanos. Cuando el Tíbet fue invadido por China, en la década de los 50, estos dogos prácticamente desaparecieron de sus tierras originales. Afortunadamente para la raza, muchos de estos enormes perros fueron a parar a India y Nepal y no se extinguieron.",
        caracteristica:
          "Es un perro fuerte y poderoso, de tamaño gigante, carácter independiente, pero muy leal y protector con la familia. Aunque no es un perro apegado, disfruta con la presencia de sus familiares, quienes no dudará en proteger. Suele ser desconfiado con personas extrañas pero llevarse bien con otros perros y animales. Tienden a ser ladradores por su pasado como perros guardianes.",
        recomendacion:
          "En casa es un perro tranquilo, pero fuera de casa requiere sesiones de deporte para mantener en forma su musculatura y aliviar el estrés del día a día.",
        ideal:
          "Es dócil y amigable con los niños del hogar, no obstante, y aunque se trata de un perro tranquilo en casa, por su gran tamaño y fuerza puede lastimarles sin querer. No se trata de una raza apropiada para propietarios poco experimentados. También es muy recomendable que pueda vivir en una casa grande, con jardín al que pueda acceder siempre que lo desee.",
        dato: "Su ladrido es único y se considera una característica de la raza muy valorada.",
        size: 4,
        vida: 3,
        deporte: 2,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "inline",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/mastin-tibetano-o-dogo-del-tibet.html",
        n: "/img/razas/115.jpg",
      },
      {
        nombre1: "Morkie",
        nombre2: "",
        pais_origen: "?",
        origen:
          "Surgió en la década de los años 80, cuando un criador decidió cruzar un yorkshire terrier con un bichón maltés. Se desconoce el lugar exacto de origen.",
        caracteristica:
          "Se caracteriza por tener un temperamento fuerte, destacando su tozudez y determinación. Sin embargo, aunque por su gran seguridad en sí mismo pueda dar la imagen de no necesitar nada de nadie, es un perro muy dependiente. Esto hace que sea necesario prestarle mucha atención y cariño si no queremos que se sienta tristes y solo.",
        recomendacion:
          "Este perro puede presentar problemas al relacionarse con otros si no se le socializa a conciencia, que pueden surgir tanto con otras mascotas como con las personas. Es importante que se sienta querido y atendido, pues la mayor parte de los problemas son la ansiedad por separación y el sentimiento de abandono.",
        ideal:
          "No realiza mudas del pelo, por lo que se le considera parte de los perros hipoalergénicos y son ideales para personas alérgicas.",
        dato: "Son sumamente populares, siendo común que se vean junto a personalidades del mundo del cine, la música o los deportes.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/morkie.html",
        n: "/img/razas/48.jpg",
      },
      {
        nombre1: "Mucuchíes",
        nombre2: "",
        pais_origen: "Venezuela",
        origen:
          "Wilender Ferrari crió la primera camada en Venezuela. Surge del cruces entre perros llevados a ese país por los colonos para ejercer como perros guardianes y pastores en el siglo XV-XVI.Tiene una ascendencia de renombre, con razas como el mastín español, el mastín del Pirineo o el Aïdi en su línea genealógica.",
        caracteristica:
          "Se caracteriza por ser fuerte pero equilibrado: son de carácter decidido y carecen de miedo o cobardía, pero a la vez son muy inteligentes, activos, nobles y dóciles. Aunque son muy desconfiados con los desconocidos, son muy cariñosos y afectuosos con su familia y con sus seres queridos. Son perros de tradición guardiana, habiendo cumplido siempre tareas de vigilancia en fincas y hogares.",
        recomendacion:
          "Le encanta correr, por lo que suele necesitar amplios espacios abiertos para poder hacerlo de forma libre y segura, lejos de peligros como carreteras, coches o trenes. Al ser un perro activo, es fundamental ofrecerle juguetes variados y practicar juegos de inteligencia en la casa.",
        ideal:
          "Hay que destacar que se trata de un perro que necesita espacio, tanto interior como exterior, por eso no es aconsejable mantenerlo en un departamento. Necesita realizar abundante actividad diaria, ya que se pone muy inquieto y nervioso si lleva una vida sedentaria.",
        dato: "Uno de estos canes acompañaba a Simón Bolívar, tras serle entregado como regalo, llegando a salvarle la vida en sus campañas. Esto hizo que se proclamase como raza de la nación, expandiéndose a pasos agigantados por toda Venezuela. En 1961 se creó un club oficial de la raza, que fue declarada como raza oficial de Venezuela en el año 1964.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/mucuchies.html",
        n: "/img/razas/17.jpg",
      },
      {
        nombre1: "Norfolk Terrier",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Originalmente criados como perros cazadores de ratas, zorros y otros animales pequeños, los norfolk terrier comparten sus orígenes con los norwich terrier. Tanto es así, que ambas razas eran consideradas una sola hasta la década de los  30, bajo el nombre de norwich terrier.  Cuando la legislación británica prohibió el corte de orejas por fines estéticos, los criadores de norwich terrier decidieron separar a los perros de orejas caídas, a los que les llamaron norfolk terrier y convirtieron en la raza que actualmente conocemos.",
        caracteristica:
          "Tiene un pelo de alambre, caracterizado por ser duro y áspero. Su carácter es amigable, extrovertido y juguetón, aunque siempre alerta. Así pues, se trata de un perro sociable tanto con personas como con otros animales, y que no acostumbra a ser pretencioso ni agresivo, aunque sí puede ser ladrador sin la educación adecuada. Es muy valiente, alegre, inteligente, cariñoso y activo. Entre los problemas comunes de esta raza se encuentran los ladridos excesivos y la destrucción del jardín. Tiende a ser un perro muy saludable y no se conocen enfermedades características de la raza.",
        recomendacion:
          "El pelo tiende a enredarse, pero es relativamente fácil de mantener (el peinado dos o tres veces por semana puede evitarlo). Necesita realizar ejercicio diario.",
        ideal:
          "Se trata de un perro ideal para departamento, casas y todo tipo de viviendas, y puede convertirse en el perfecto compañero de personas adultas y niños. Debido a su carácter activo y juguetón, no recomendamos su adopción a personas de edad avanzada.",
        dato: "Está considerado como uno de los más pequeños dentro de los perros tipo terrier.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/norfolk-terrier.html",
        n: "/img/razas/136.jpg",
      },
      {
        nombre1: "Nova Scotia Duck Tolling Retriever",
        nombre2: "",
        pais_origen: "Canadá",
        origen:
          "Conocido en español como perro cobrador de Nueva Escocia, Canadá,  fue creado en el siglo XIX para atraer, guiar hacia el cazador y cobrar aves acuáticas.  Parece ser que los perros fundadores de la raza pertenecían a un grupo de perros señuelos rojos (red decoy dog) llevados desde Europa hasta Canadá por los primeros colonos. Aunque no se conocen con exactitud las razas de perros que participaron en el cruce, se cree que fueron perros tipo setter, spaniel y diferentes tipos de retriever.",
        caracteristica:
          "Es entusiasta, juguetón, muy activo, confiado, gentil y dulce. Además es un perro muy inteligente, que resulta fácil de entrenar. Tiene mucha energía, pero a la vez suele ser muy paciente con los niños y muy obediente. Debido a su manto doble, es un perro muy resistente al agua que disfruta mucho nadar.",
        recomendacion:
          "Necesita mucho ejercicio físico y mental, así como juegos o paseos diarios.",
        ideal: "",
        dato: "Originalmente se conocía a estos perros como perros de patos del río pequeño (little river duck dog) o como Yarmouth toller. Estos nombres surgieron por la particular forma con que se usaban estos perros para la caza: el estilo consiste en que el perro va desde y hacia el escondite donde se esconde el cazador, recogiendo una vara o una pelota él le lanza, lo que llama la atención de los patos. Entonces, los patos se acercan a la orilla hasta que llegan a estar dentro del rango de tiro. Es en ese momento que el cazador puede disparar y, posteriormente, el perro trae los patos heridos o muertos. Aunque ese estilo de caza es practicado desde hace mucho tiempo, algunos cazadores consideran que es simplemente un mito.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/nova-scotia-duck-tolling-retriever.html",
        n: "/img/razas/159.jpg",
      },
      {
        nombre1: "Pachón Navarro",
        nombre2: "",
        pais_origen: "España",
        origen:
          "Se origina en España. Es un reconocido perro de caza y búsqueda, que tiene una larga historia, apareciendo incluso en obras del Barroco y siendo exportado en el siglo XVIII a otros lugares de Europa. En 1911 se reconoce como raza oficial por parte de la Real Sociedad Canina.",
        caracteristica:
          "Es un animal realmente bueno, muy tranquilo y calmado, pero con mucha fuerza y energía para el deporte o la caza (en la que históricamente ha destacado). No tolera muy bien la soledad y siempre le gusta estar cerca de sus seres queridos.",
        recomendacion:
          "En esta raza la higiene de los dientes es uno de los aspectos clave, por lo que es aconsejable realizar cepillados frecuentes. Aunque al principio puede resultar difícil que el perro no se resista y se enfade, es cosa de ir acostumbrándolo poco a poco.",
        ideal:
          "Aunque lo típico es verlo en campos y terrenos, o como mucho en casas con amplios jardines, su docilidad le permite adaptarse con rapidez a la vida en la ciudad, incluso en pisos sin balcón. Eso sí, se recomienda que tenga acceso al exterior todos los días, no siendo un perro aconsejable para personas ancianas o sedentarias. ",
        dato: "Es una de las razas españolas más antiguas, y que ha superado grandes crisis incluyendo la Guerra Civil Española.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pachon-navarro.html",
        n: "/img/razas/18.jpg",
      },
      {
        nombre1: "Papillón",
        nombre2: "",
        pais_origen: "Francia",
        origen:
          "Proviene de Francia y Bélgica. Cambió ligeramente su morfología física en el siglo XIX, cuando los aficionados a la cría empezaron a seleccionar ejemplares con las orejas erguidas, aspecto con el que conocemos hoy en día el perro papillón. La raza no fue reconocida hasta 1935.",
        caracteristica:
          "Es un perro muy inteligente y social, capaz de relacionarse perfectamente con personas y otros animales. La educación es la clave para lograr un perro obediente y estable emocionalmente. No es especialmente sociable con los extraños, con quienes se muestra desconfiado, lo que lo transforma en un excelente perro guardián.",
        recomendacion:
          "Son especialmente juguetones y activos, por lo que necesitarán paseos regulares. No tolera bien las temperaturas bajas.",
        ideal: "",
        dato: "Se trata de uno de los perros más elegantes del mundo. Se hizo realmente popular cuando Tiziano Vicelli lo pintó en el siglo XVI, con lo que muchos otros pintores de renombre empezaron a incluirlo en sus obras. Fue entonces cuando los perros de raza papillón se consideraron como perros de la realeza, y los más importantes reyes de Europa los empezaron a incluir en sus pinturas familiares.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 6,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "inline",
        link: "https://www.expertoanimal.com/razas-de-perros/papillon.html",
        n: "/img/razas/210.jpg",
      },
      {
        nombre1: "Parson Russell Terrier",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Las raíces son inglesas. En concreto esta raza tiene su origen en la ciudad de Birmingham, donde el reverendo John Russell, miembro fundador del Kennel Club de Reino Unido, consiguió criar a este subtipo de russells en 1863.",
        caracteristica:
          "Es una raza muy activa y juguetona, adorando todo tipo de juegos y el deportes, los cuales necesitan para invertir toda su energía de una forma productiva. También son inteligentes y asertivos, siendo capaces de percibir el estado de ánimo de sus dueños, con quienes son muy cariñosos y afectuosos. Suelen ser bastante dominantes con otros perros, y no toleran a otras mascotas como gatos o conejos. ",
        recomendacion:
          "Necesita que se les dedique todo el tiempo posible para estar equilibrados y saludables. Cuando se aburren suelen cavar en patios y jardines o destrozar algunos muebles, pero nada que no se pueda evitar educándolo y proporcionándoles atención y juguetes. Al educarlo debemos ser constantes y pacientes, ya que a veces pueden resultar porfiados y tercos.",
        ideal: "",
        dato: "La Federación Cinológica Internacional lo reconoció como raza oficial recién en 2001.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/parson-russell-terrier.html",
        n: "/img/razas/91.jpg",
      },
      {
        nombre1: "Pastor Alemán",
        nombre2: "",
        pais_origen: "Alemania",
        origen:
          "La historia del pastor alemán se remonta a 1890, cuando el capitán de caballería Max Emil Frederick von Stephanitz empezó a seguir su sueño de desarrollar una raza de trabajo de apariencia noble. En 1899, este capitán de caballería encontró, en una exposición canina a Hektor Linkrshein, el perro que se convertiría en el fundador de la raza.",
        caracteristica:
          "Es equilibrado, seguro y confiable. El coraje de estos perros es legendario, lo mismo que su instinto de defensa, por lo que es uno de los perros más solicitados para la guardia y protección. Aunque el pastor alemán tiende a ser un tanto desconfiado con los extraños, no es un perro agresivo por naturaleza y no ataca sin razón. Es muy inteligente, fácil de entrenar y se adapta muy bien a cualquier técnica de educación. Uno de sus pocos problemas es la pérdida de pelo contante.",
        recomendacion:
          "Si bien es un perro que se adapta a vivir en las ciudades, lo mejor es que tengan un espacio al aire libre donde puedan ejercitarse por sí solos.",
        ideal:
          "Se puede adaptar a vivir en un departamento, pero necesita mucho ejercicio y paseos largos. Este ágil y activo y necesita ejercitar sus músculos al aire libre.",
        dato: "Se hizo muy popular por su desempeño en las dos guerras mundiales. Tan grande fue la impresión que causó, que incluso los ejércitos enemigos le tenían admiración.",
        size: 3,
        vida: 1,
        deporte: 2,
        intel: 6,
        clima: 1,
        child: "inline",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "inline",
        link: "https://www.expertoanimal.com/razas-de-perros/pastor-aleman.html",
        n: "/img/razas/164.jpg",
      },
      {
        nombre1: "Pastor Belga Groenendael",
        nombre2: "",
        pais_origen: "Bélgica",
        origen:
          "El primer criador de pastores belgas groenendael fue Nicholas Rose. El nombre de esta variedad proviene del nombre de la propiedad que el señor Rose tenía en el bosque de Soignes. Groenendael, en flamenco, significa pequeño valle verde. En 1896, el groenendael fue la primera variedad reconocida de pastor belga.",
        caracteristica:
          "Aunque es un perro fuerte, resistente y corpulento, no es pesado. Tiende a ser alerta, inteligente, valiente y leal. Tiene muy marcado los instintos de protección, territorialidad y pastoreo, aunque no le gusta la soledad y debemos preocuparnos de darle harto cariño.",
        recomendacion:
          "Es necesario socializarlo correctamente desde cachorro. Como tiende a ser un perro muy activo, necesita alguna ocupación que lo mantenga entretenido durante el día. Si no se le proporciona suficiente ejercicio físico y mental podría desarrollar problemas de conducta. ",
        ideal:
          "Puede vivir tranquilamente en un piso o en una casa amplia con jardín. Sin embargo, en cualquiera de los dos casos, se le debe proporcionar suficiente ejercicio físico.",
        dato: "D ebido a su hermoso pelo negro es el segundo más popular de los cuatro pastores belgas que existen.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pastor-belga-groenendael.html",
        n: "/img/razas/202.jpg",
      },
      {
        nombre1: "Pastor Belga Laekenois",
        nombre2: "",
        pais_origen: "Bélgica",
        origen:
          "El pastor belga laekenois es originario de Antwerp y recibe su nombre gracias a la princesa Henrieta Maria Charlotte de Bélgica, que utilizó su residencia (el castillo de Laeken) para nombrar a su raza favorita. Al margen de su papel como perro de pastoreo, fue un excelente y clave perro mensajero en la primera y la segunda guerra mundial.",
        caracteristica:
          "Su pelaje es duro, áspero, seco y de tipo alambre, y pierde muy poco pelo durante el año. Su carácter tiende a ser vigilante, activo y de gran vitalidad. Se trata de un perro muy inteligente y con aptitudes innatas para el pastoreo y la guardia de rebaños. Además es una raza dinámica, enérgica y muy trabajadora.",
        recomendacion:
          "Es aconsejable que los propietarios poco experimentados trabajen con la ayuda de un educador canino el adiestramiento desde que el perro, de esta forma podremos sacar todo el potencial de la raza.",
        ideal:
          "Puede adaptarse sin problema a la vida en un departamento, pero será imprescindible ofrecerle un paseo diario en el que se incluya algo de ejercicio o estimulación física.",
        dato: "A diferencia de sus hermanos, pastor belga malinois, pastor belga tervueren y pastor belga groenendael, esta es la variedad menos popular y conocida de todeos los perros pastores belgas. Sin embargo, es la variedad más antigua.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 1,
        child: "inline",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pastor-belga-laekenois.html",
        n: "/img/razas/135.jpg",
      },
      {
        nombre1: "Pastor Belga Malinois",
        nombre2: "",
        pais_origen: "Bélgica",
        origen:
          "Se origina en la ciudad de Malinas, Bélgica. Recién en 1908 se le dio un nombre, aunque la raza ya existía desde mucho antes. Su selección se basó concretamente en la búsqueda de un perro de utilidad que fuese apto para el adiestramiento, inteligente y ágil.",
        caracteristica:
          "Se le llama el fórmula uno de los perros por su carácter y sus habilidades físicas. Es un perro muy inteligente y con un coraje difícil de superar, además de ser muy fácil de educar y adiestrar. Hablamos de un perro tremendamente fiel y bondadoso con sus familiares. ",
        recomendacion:
          "Aunque el pastor belga malinois puede adaptarse a vivir en un departamento, sería ideal ofrecerle un hogar amplio para que pudiera disfrutar ejercitándose. Este perro derrocha energía por lo que es imprescindible proporcionarle mucho ejercicio y paseos largos a diario. ",
        ideal: "",
        dato: "Su gran capacidad para los deportes lo ha llevado a posicionarse en los primeros puestos de las competencias internacionales en los últimos años. Bien puede ser el más activo e incansable de todos los pastores belgas.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "inline",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pastor-belga-malinois.html",
        n: "/img/razas/12.jpg",
      },
      {
        nombre1: "Pastor Belga Tervueren",
        nombre2: "",
        pais_origen: "Bélgica",
        origen:
          "Debe su nombre a la villa belga de Tervueren.  Después de dos épocas en que la población de esta variedad estuvo punto de desaparecer, el tervueren logró cobrar popularidad en 1945. Resulta del cruce entre el pastor belga groenendael y el collie de pelo largo.",
        caracteristica:
          "Vigilante, activo y de gran vitalidad, el tervueren es un excelente perro guardián y protector de los suyos. Pierde pelo de forma regular durante todo el año, sobre todo los machos. Es fácil de entrenar y que pocas veces presenta problemas de salud.",
        recomendacion:
          "Como tiene muy desarrollados los instintos de protección y territorialidad, es necesario socializarlo desde cachorro. Tiene tanta energía como cualquier otro pastor belga, por lo que necesita mantenerse activo y quemar toda su energía. La falta de ejercicio físico puede causarle problemas de comportamiento.",
        ideal:
          "Lo mejor es tenerlo con un jardín o patio donde pueda salir a jugar y descanzar.",
        dato: "De las cuatro variedades de pastor belga, solamente el pastor belga tervueren y el pastor belga groenendael tienen el pelo largo.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pastor-belga-tervueren.html",
        n: "/img/razas/116.jpg",
      },
      {
        nombre1: "Pastor Bergamasco",
        nombre2: "",
        pais_origen: "Italia",
        origen:
          "El origen de esta raza es desconocido, ya que la misma es muy antigua. Sin embargo, se sabe que el pastor bergamasco habitó toda la región de los Alpes italianos y era muy numeroso en los valles bergamascos de Lombardía, de donde toma su nombre.",
        caracteristica:
          "Son inteligentes, atentos y pacientes. Tienen un temperamento estable y gran concentración, por lo que son excelentes perros para múltiples funciones, especialmente para conducir y cuidar rebaños. Son pacíficos que no suelen mostrar agresión pero a la vez muy desconfiados con los extraños, por lo que pueden ser buenos perros guardianes.",
        recomendacion:
          "La sociabilización desde pequeño es muy importante para que nos sean tímidos o rabiosos con desconocidos.",
        ideal:
          "Pueden ser excelentes mascotas para familias con niños. Necesitan mucho ejercicio y no son perros adecuados para vivir en departamento.",
        dato: "Al contrario de lo que muchos puedan pensar, no necesita ningún cuidado especial en su abundante pelaje, ya que los mechones que tiene se le forman naturalmente y solo es necesario bañarlos cuando realmente los necesitan.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pastor-bergamasco.html",
        n: "/img/razas/147.jpg",
      },
      {
        nombre1: "Pastor Catalán",
        nombre2: "Gos d Atura Català",
        pais_origen: "España",
        origen:
          "Gran parte de la historia que envuelve esta raza es desconocida. Se sabe que es muy antigua y se estima que desciende de perros llevados por los conquistadores romanos a la península ibérica, alrededor del año 150 a.C.",
        caracteristica:
          "Es un perro muy fiel y cariñoso con los suyos, pero algo tímido con los extraños. Como la mayoría de los perros pastores, el gos d atura català es un perro muy inteligente, valiente, estable, vigilante y trabajador. Además, sus instintos de pastoreo son tan fuertes que suele dirigir al rebaño incluso sin ningún guía por parte del pastor. Crea un vínculo especial con un solo miembro de la familia y tiende a comportarse maravillosamente con adultos y niños.",
        recomendacion:
          "El deporte diario e intenso es fundamental para esta raza.",
        ideal: "",
        dato: "La muda de pelo es muy curiosa en esta raza, ya que ocurre en dos etapas.Primero se le cae el pelo de la mitad anterior del cuerpo y luego el pelo de la mitad posterior. Por tanto, durante algún tiempo, parece que se tratara de un perro con dos pelajes distintos.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/gos-d-atura-catala-o-pastor-catalan.html",
        n: "/img/razas/111.jpg",
      },
      {
        nombre1: "Pastor de los Cárpatos",
        nombre2: "",
        pais_origen: "Rumania",
        origen:
          "Los primeros registros datan del siglo XV, aunque se cree que es anterior a esta fecha. Es un perro que durante siglos ha ejercido como perro de pastoreo y como guardián de tierras y rebaños. Es endémica de la región del Cárpato-Danubio, siendo muy valorada por los pastores rumanos de aquel lugar.",
        caracteristica:
          "Es apreciado no solo por sus dotes para el pastoreo, sino también por su fiereza y arrojo en la defensa de los rebaños que tiene que guardar. Sin embargo, para nada son perros agresivos, y destacan por su afabilidad y el amor incondicional que demuestran a todos, siendo fieles, obedientes, cariñosos y nobles. Solo atacan para defenderse a sí mismos y a su rebaño, al que cuidan con mimo y dedicación. Son perros muy tranquilos, de carácter equilibrado y atentos. Destaquen por tener una salud sólida y muy estable.",
        recomendacion:
          "Es un perro muy territorial, por lo que es importante dedicar parte del adiestramiento a este aspecto. Sus instintos protectores hacen que a veces se muestre agresivo si considera que hay un intruso en su territorio. Es interesante entrenar al pastor de los Cárpatos en actividades deportivas, como pueden ser los circuitos de agility o juegos de inteligencia, que además de mantenerlo activo físicamente hacen que aprenda a responder ante las órdenes más básicas (y luego pasar a algunas más complejas).",
        ideal:
          "Suelen necesitar algo de espacio para poder moverse o pueden agobiarse un poco, por lo que se recomienda tenerlos en casas con jardines o terrenos, aunque pueden acostumbrarse a la vida en departamentos. Se adaptan bien a la vida en familia con niños o con otros animales.",
        dato: "En esta raza canina existe un marcado dimorfismo sexual, pues los machos son mucho más altos y grandes que las hembras. Es considerado uno de los mejores perros del mundo para el pastoreo.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pastor-de-los-carpatos.html",
        n: "/img/razas/15.jpg",
      },
      {
        nombre1: "Pastor de los Pirineos de pelo largo",
        nombre2: "",
        pais_origen: "Francia",
        origen:
          "La historia de esta raza se pierde en los tiempos, y su origen es desconocido. Sin embargo, la raza habita desde hace siglos en la cordillera de los Pirineos, al sur de Francia. En esas montañas, estos perros cumplían y siguen cumpliendo funciones de pastores, guiando y cuidando los rebaños.",
        caracteristica:
          "Son muy inteligentes, valientes y activos. Gracias a su inteligencia son muy versátiles y capaces de desempeñar varias funciones. También son perros muy leales a los suyos, y tienden a formar un vínculo muy estrecho con una sola persona. Tienden a ser territoriales y reservados con los extraños.",
        recomendacion:
          "Aunque no suelen ser agresivos, la socialización desde cachorros es muy importante para reducir la territorialidad y permitir que sean menos desconfiados. Sus fuertes instintos de pastoreo pueden llevarlos a tratar de juntar en grupos a los niños o a las mascotas de la casa.",
        ideal:
          "Viven mejor en un ambiente rural, pero también pueden ser excelentes mascotas si se entrega suficiente ejercicio y la compañía que necesitan.",
        dato: "La tradición indicaba que la cola debía amputarse, pero esa costumbre se ha perdido en gran parte del mundo. Desgraciadamente, todavía sigue vigente y es legal en muchos países.",
        size: 2,
        vida: 2,
        deporte: 3,
        intel: 2,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-pastor-de-los-pirineos-de-pelo-largo.html",
        n: "/img/razas/128.jpg",
      },
      {
        nombre1: "Pastor de Shetland",
        nombre2: "Sheltie",
        pais_origen: "Escocia",
        origen:
          "Aunque el origen exacto de esta raza canina es incierto, los datos registrados muestran que el pastor de Shetland se reconoció por primera en las islas que llevan su mismo nombre, pertenecientes a Escocia. Aunque la raza fue reconocida oficialmente en el 1908, se han hallado documentos que la sitúan alrededor del 1800 . Surgió a raíz del cruce de varios perros de tipo collie.",
        caracteristica:
          "Es un perro pequeño de pelo largo y gran belleza. Muy leales, inteligentes y cariñosos con su familia. Sin embargo, tienden a ser más bien tímidos con las personas desconocidas, y tienen fuertes instintos de pastoreo que pueden causar algunos conflictos si no se entrenan de forma correcta.",
        recomendacion:
          "Resulta fundamental socializar a estos perros desde que son cachorros, tanto para reducir su timidez con los extraños como para evitar que no se relacionen con otros animales. Necesitan buenas dosis de ejercicio físico.",
        ideal:
          "Pueden vivir bien en un departamento siempre que reciban el ejercicio necesario. Tienden a ser ladradores y eso puede causar conflictos con los vecinos.",
        dato: "Se empleaba en Escocia para guiar y proteger ovejas de razas enanas, ponies e incluso gallinas. Sin embargo, y debido a su belleza, rápidamente empezó adoptarse como animal de compañía.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 6,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "inline",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-pastor-de-shetland.html",
        n: "/img/razas/121.jpg",
      },
      {
        nombre1: "Pastor del Cáucaso",
        nombre2: "Pastor Caucásico",
        pais_origen: "Rusia",
        origen:
          "El origen data del siglo I a.C., en Rusia, y es fruto de la selección llevada a cabo por los campesinos durante muchos años. Ellos querían a los ejemplares más fuertes y valientes que encontraran para proteger sus rebaños de depredadores.  El nombre original de la raza es kavkazkaïa ovtcharka.",
        caracteristica:
          "Famoso por su valerosidad, el pastor caucásico no teme a nada, haciendo frente a todo aquel que ose entrar en su terreno o dañar a los suyos. Esto puede hacer que se muestre territorial y dominante, pero también muy atento y cariñoso, acostumbrado a llevarse muy bien con los niños y otros animales.",
        recomendacion:
          "Es un perro muy activo y enérgico, por ello es necesario proporcionarles hartas horas de ejercicio. Tiende a mostrarse desconfiado con los desconocidos, por lo que tenemos que socializarlo desde cachorro para que aprenda a relacionarse correctamente con otras personas y animales.",
        ideal: "",
        dato: "Son unos de los perros con la mordida más fuerte y potente de todos.",
        size: 4,
        vida: 2,
        deporte: 3,
        intel: 2,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pastor-del-caucaso-o-pastor-caucasico.html",
        n: "/img/razas/57.jpg",
      },
      {
        nombre1: "Pastor ganadero australiano",
        nombre2: "Boyero Australiano",
        pais_origen: "Australia",
        origen:
          "Se originó en Australia en 1840. Un hombre de nombre Hall decidió cruzar algunos collies azul-mirlo de tierras altas con dingos, y el resultado fue el precursor del boyero australiano actual. Posteriores cruces incluyeron al dálmata, el bull terrier y el kelpie australiano. ",
        caracteristica:
          "Es un perro infatigable y valiente, capaz de manejar el ganado más difícil en las condiciones más extremas. Son muy leales, enérgicos, incansables, valientes, tenaces y terriblemente inteligentes. Son muy apegados a una sola persona, por lo que se dice que son perros de un sólo amo. Además, son excelentes guardianes y pueden ser muy fieros cuando tienen que defender su hogar.",
        recomendacion:
          "Necesitan mucho ejercicio y mucha atención. Debemos recordar que no son perros para dejar solos en el jardín.",
        ideal:
          "No es un perro para cualquier persona. Su inquietud, inteligencia y fuerza física necesitarán de un propietario proactivo, enérgico y con ganas de estimular a su perro. No son buenas mascotas para familias sedentarias ni para personas inexpertas en el manejo de perros.",
        dato: "Recibe dos nombres distintos dependiendo del tipo de pelaje que desarrolla: blue heeler o red heeler.",
        size: 2,
        vida: 3,
        deporte: 4,
        intel: 6,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "inline",
        intel2: "inline",
        link: "https://www.expertoanimal.com/razas-de-perros/pastor-ganadero-australiano-o-boyero-australiano.html",
        n: "/img/razas/193.jpg",
      },
      {
        nombre1: "Pastor Holandés",
        nombre2: "",
        pais_origen: "Holanda",
        origen:
          "Son originarios de Holanda, donde los pastores los empleaban como perros guía de los rebaños de ovejas. Su principal función no solo el dirigir a estas ovejas, sino también vigilar que no pasaran de ciertos límites, preservando los regadíos, plantaciones y manteniéndolas unidas.",
        caracteristica:
          "Extremadamente activa, muy fiel, cariñoso y dócil, aprende muy rápido y siempre está atento a las necesidades de su hogar. Adora a todo su familia, incluyendo niños y ancianos, con los que son muy pacientes y afectuosos. Son inteligentes y normalmente es fácil enseñarles cualquier cosa.",
        recomendacion:
          "Deben realizar actividad física diaria, incluyendo ejercicios de alta intensidad que les permitan liberar toda su energía. A veces se muestran excesivamente enojones y hostiles con las visitas desconocidas, por lo que es importante que se les socialice adecuadamente y que estén en contacto con otras personas y animales.",
        ideal:
          "Son incansable, por lo que quizá no sean el mejor compañero si no podemos permitirles realizar mucho ejercicio diario (son considerados como perros hiperactivos).",
        dato: "Existen tres variedades de pastor holandés: pelo corto, pelo largo y pelo duro.",
        size: 2,
        vida: 3,
        deporte: 4,
        intel: 5,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pastor-holandes.html",
        n: "/img/razas/78.jpg",
      },
      {
        nombre1: "Pastor ovejero australiano",
        nombre2: "",
        pais_origen: "España",
        origen:
          "Paradójicamente, el pastor australiano no tiene nada que ver con Australia, sino que es una más de las razas de perros desarrolladas en Estados Unidos y de origen español. Algunos emigrantes vascos se trasladaron a Australia para probar suerte en la cría de sus ganados ovinos, y llevaron con ellos a sus perros pastores. Sin embargo, alrededor del año 1800, esos mismos pastores decidieron ir para América. Los colonos que estaban establecidos en Estados Unidos, dieron el nombre de Australian shepherd, o perros de pastor australianos, a los perros recién llegados",
        caracteristica:
          "Tienen un temperamento seguro y muy enérgico, parecido al de los border collie. Se caracterizan por sus fuertes instintos guardianes y de pastoreo, siendo muy curiosos e inteligentes. También son animales amistosos y leales. No suelen ser agresivos, aunque pueden ser algo desconfiados cuando conocen a alguien por primera vez. Por su gran inteligencia, los pastores australianos pueden ser entrenados con facilidad.",
        recomendacion:
          "Demandan muchísimo ejercicio y muchísima atención. La mayoría de las personas no tiene suficiente energía ni disponibilidad de tiempo para tener uno de estos perros.",
        ideal:
          "Pueden llevarse bien con otros perros y otros animales. No son aptos para vivir en departamento por su gran cantidad de energía, pero tampoco para estar aislados en el jardín. Lo ideal es que vivan en casas con amplios jardines o en propiedades rurales.",
        dato: "Es uno de los mejores perros pastores que existen.",
        size: 3,
        vida: 3,
        deporte: 4,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pastor-ovejero-australiano.html",
        n: "/img/razas/200.jpg",
      },
      {
        nombre1: "Pequeño Perro León",
        nombre2: "Lowchen",
        pais_origen: "Francia",
        origen:
          "Esta es una de las razas caninas más antiguas que se conocen. Se sabe de su existencia en el siglo XVI por pinturas en las que aparece retratado un perro exactamente igual. Sin embargo, no se conoce el origen de la raza y aunque la FCI lo asigna a Francia, otros países como Alemania y Rusia reclaman su nacionalidad.",
        caracteristica:
          "Afectuosos, relajados y juguetones, los pequeños perros leones son mascotas ideales. Aunque son buenos para jugar, también pueden comportarse con calma y tranquilidad tanto en el hogar como fuera de él. Estos perros son muy apegados a sus familias y suelen ser especialmente unidos a una persona, a la que siguen la mayor parte del tiempo. Son fáciles de socializar, pero comportamiento más comunes se encuentran los ladridos excesivos y los agujeros en el jardín. Son perros hipoalergénicos que no pierden pelo y causan pocas reacciones alérgicas.",
        recomendacion:
          "Son propensos a desarrollar ansiedad por separación si se los deja solos. Es importante darles la compañía que necesitan, pero también hay que enseñarles a permanecer solos sin angustiarse.",
        ideal:
          "Son excelentes mascotas para personas y familias que disponen del tiempo suficiente para pasar con ellos. Aunque estos perros se llevan bien con los niños, no son buenas mascotas para niños pequeños.",
        dato: "El nombre de perro león proviene del corte de pelo típico en la raza, y no de alguna característica natural.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pequeno-perro-leon.html",
        n: "/img/razas/185.jpg",
      },
      {
        nombre1: "Perro Bedlington Terrier",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Surgieron en el pueblo de Bedlington, del que tomaron su nombre y donde eran sumamente apreciados por los lugareños. Son fruto de cruces entre tres razas caninas diferentes: los caniches (de los que han heredado el pelaje ensortijado y lanudo), los whippets y los dandie dinmont terriers. También se encuentra emparentado con otras razas como los otterhounds. No se conoce la fecha exacta de aparición de la raza, pero se estima que ya en los años 80 del siglo XVIII existían ejemplares.",
        caracteristica:
          "Destacan por tener un carácter tenaz, valiente y confiado. Esta mezcla hace que los bedlington sean animales que no tienen miedo a afrontar peligros o retos, siendo a la misma vez amigables y cariñosos.  Tienen un alto nivel de inteligencia y mucha nobleza. Les encanta escarbar y ladrar.",
        recomendacion:
          "Necesitarán hacer ejercicio físico todos los días. Tiene un instinto cazador marcado, y si no se les ha acostumbrado desde cachorro a sociabilizar pueden mostrarse poco dispuestos a compartir su hogar con otras mascotas, sobre todo con gatos o roedores.",
        ideal:
          "Son equilibrados, tranquilos y fantásticos para la convivencia con niños, personas mayores o otros perros. Sdemás se adaptan perfectamente tanto a departamentos como a casas o terrenos agrícolas. Son considerados como perros hipoalergénicos, y, aunque tienen abundante pelo, éste no suele producir alergias.",
        dato: "Debido a su pelaje, se dice que los bedlington terriers son como ovejitas en miniatura.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-bedlington-terrier.html",
        n: "/img/razas/80.jpg",
      },
      {
        nombre1: "Perro Crestado Chino",
        nombre2: "",
        pais_origen: "China",
        origen:
          "Se sabe que estos canes existían en el siglo XIII en China y que, tradicionalmente, eran empleados como perros ratoneros en barcos mercantes. Fue a finales del siglo XIX que Ida Garrett, una criadora aficionada a los perros sin pelo, empezó a promocionar la raza en Europa. ",
        caracteristica:
          "Agradable, sensible y muy alegre. Tiende a ser muy leal con los suyos y permanecer muy apegado a una persona en particular, la que considera su dueño y amigo. Así mismo, suele presentar una personalidad tímida y siempre alerta. Son inteligentes y fáciles de entrenar.",
        recomendacion:
          "Es muy importante la socialización desde cachorro para que no sea tímido con los que no conoce. Al no contar con la protección del pelo, su piel se encuentra más expuesta a los cambios de temperatura, rayos solares y otros factores que pueden dañarla, por lo que es importante ponerle protector solar y cuidarlo del frío. Además, son perros que necesitan mucha compañía.",
        ideal:
          "Es una raza de perro perfecta para principiantes, puesto que su inteligencia y carácter dócil hacen de su adiestramiento una tarea sencilla. Eso si, es fundamental disponer de tiempo, debido a que no puede pasar largas horas solos.",
        dato: "Existen dos variedades diferenciadas: el perro crestado chino sin pelo y el powder puff. El primero de ellos presenta una larga cresta, pelaje en las patas y la punta de la cola, mientras que el powder cuenta con un manto en forma de velo por todo su cuerpo.",
        size: 2,
        vida: 3,
        deporte: 2,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-crestado-chino.html",
        n: "/img/razas/108.jpg",
      },
      {
        nombre1: "Perro Crestado Rodesiano",
        nombre2: "Rhodesian Ridgeback",
        pais_origen: "Sudáfrica",
        origen:
          "El origen se sitúa entre los siglos XVI y XVII, cuando los europeos colonizaron Sudáfrica. Los antepasados del eran perros del Cabo Colonia de Sudáfrica, cruzados con perros de los pioneros y perros cazadores de Hottentot con cresta. Es la única raza registrada de África del Sur.",
        caracteristica:
          "Es curioso, muy leal y enérgico, pero en ocasiones independiente o reservado con los extraños. Es muy apegado a su familia, con quien crea un vínculo muy fuerte, y además muy protector y un buen guardián. El trato con los niños es excelente, pero debido a su nivel de energía puede resultar un poco torpe con ellos.",
        recomendacion:
          "Para evitar conductas agresivas o problemas, será muy importante socializarlo desde cachorro. El trato con los niños es excelente, pero por su nivel de energía puede resultar torpe en el trato con ellos y debemos tener cuidado.",
        ideal:
          "Tolera bien el clima cálido o templado, pero no se adapta a los climas fríos, por lo que no se recomienda para los sureños.",
        dato: "Se trata de la única raza sudafricana registrada por la FCI, la cual era conocida anteriormente como perro león.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 3,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-crestado-rodesiano.html",
        n: "/img/razas/137.jpg",
      },
      {
        nombre1: "Perro de Agua Español",
        nombre2: "",
        pais_origen: "España",
        origen:
          "Tiene como predecesor al antiguo perro barbet, el perro de agua que ha dado paso a otras razas como el caniche o poodle y a las distintas razas de perros de agua (español, portugués, francés o romagna entre otros). Su presencia en la Península Ibérica se remonta, por lo menos, al año 1100 a.C., pero se desconoce exactamente cuál es el origen exacto y si existieron otras razas en su desarrollo. Su población principalmente se encontraba en Andalucía y era conocido como El perro Turco.",
        caracteristica:
          "Es muy obediente y con una predisposición natural para el aprendizaje. Además es muy fiel y apegado a sus dueños, así como valiente y con un carácter muy equilibrado.",
        recomendacion:
          "El cuidado del pelo requerirá un esfuerzo extra, ya que son habituales los enredos y la acumulación de suciedad. Es un perro activo que necesitará un mínimo de un paseo diario.",
        ideal: "",
        dato: "Se considera uno de los perros más sanos que existen y no tiene tendencia a sufrir problemas hereditarios.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-de-agua-espanol.html",
        n: "/img/razas/149.jpg",
      },
      {
        nombre1: "Perro de Agua Portugués",
        nombre2: "Cão de Agua Português",
        pais_origen: "Portugal",
        origen:
          "La raza es bastante antigua, pues se estima que ya en el siglo XV existían. Se han encontrado documentos de la época que relatan cómo estos perros acompañaban a los marineros de Portugal en sus viajes pesqueros y comerciales. Aunque durante el siglo XX la raza sufrió un grave declive que casi la lleva a la extinción, un grupo de criadores consiguió que remontara, volviéndose muy popular en la década de los 80 en Estados Unidos y siendo aceptada por la AKC en 1984.",
        caracteristica:
          "Famosa por sus dotes para la natación, muy fuerte, con unos potentes y desarrollados músculos. Bastante afable, no se trata de perros pegajosos ya que son bastante independientes, inteligentes y activos.",
        recomendacion:
          "Necesitan bastante estimulación, tanto física como mental. Tiene una extraña enfermedad llamada la enfermedad de almacenamiento (una alteración de la producción de algunas enzimas) por lo que es importante llevarlo regularmente al veterinario y aprender sus causas.",
        ideal:
          "Aunque son capaces de convivir con otro canes, no se recomienda tenerlo junto con roedores o pájaros, ya que no siempre se puede asegurar que no vayan a atacarlos o a dañarlos pretendiendo jugar con ellos.",
        dato: "La principal labor era acompañar a los pesqueros y lanzarse al agua para que los peces, huyendo de ellos, se precipitaran a las redes que se habían tendido.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-de-agua-portugues.html",
        n: "/img/razas/79.jpg",
      },
      {
        nombre1: "Perro de Montaña de los Pirineos",
        nombre2: "Gran Pirineo",
        pais_origen: "España",
        origen:
          "Tiene sus orígenes en la cordillera montañosa del Pirineo, entre España, Andorra y Francia. Se estima que su historia se remonta incluso antes de la Edad Media, aunque fue entonces cuando alcanzó verdadera popularidad por su utilización como guardián de castillos. Es mencionado por primera vez por el conde y vizconde Gastón III de Foix-Bearne en el siglo XIV.",
        caracteristica:
          "Es protector, leal y algo independiente, por lo que necesitará de sus espacios para estar solo y tranquilo.",
        recomendacion:
          "No son muy dinámicos, pero necesitan largos paseos diarios. Podemos realizar además otras actividades físicas con él, ya sea senderismo, natación, jugar con una pelota o lanzarle un fresbee. Problemas son la destructividad o las conductas ladradoras pueden prevenirse si pasamos tiempo con nuestro perro.",
        ideal:
          "Puede vivir bien en exteriores cuando el clima es templado o frío, pero no tolera bien el calor, por lo que será fundamental tener un lugar fresco para que descanse.",
        dato: "En el siglo XVII y debido a su trabajo como perro protector y guardián, se ganó el favoritismo de los nobles franceses, así como el del propio rey Luis XIV, quien le nombró perro real de la Corte Francesa.",
        size: 4,
        vida: 2,
        deporte: 3,
        intel: 2,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-de-montana-de-los-pirineos.html",
        n: "/img/razas/141.jpg",
      },
      {
        nombre1: "Perro Leopardo de Catahoula",
        nombre2: "",
        pais_origen: "USA",
        origen:
          "Surge en el estado de Louisiana (Estados Unidos) y debido a eso es también conocido como Catahoula Louisiana. Se desconoce el momento exacto en el que se origina, pero parecen ser descendientes de cruces entre mastines y perros de razas europeas, las cuales fueron llevadas a América por los colonos en el siglo XVI.",
        caracteristica:
          "Tiene un temperamento fuerte, enérgico y desafiante. Es un perro muy protector, por lo que es un excelente perro guardián, lo que lo hace desconfiado con los desconocidos. Incluso puede tener conductas agresivas con las personas que no conoce, sobre todo si les asocian o ven algún tipo de amenaza.",
        recomendacion:
          "Es un perro bastante enérgico que necesita realizar ejercicio a diario, requiriendo paseos largos y ejercicios como correr o jugar a la pelota. La socialización temprana es todavía más relevante que en otras razas, debido a su temperamento y a que suele ser un can muy territorial.",
        ideal:
          "Hay que tener muy en cuenta que son perros de carácter fuerte, lo que puede implicar complicaciones a la hora de convivir con ellos si no se educan y entrenan apropiadamente.",
        dato: "Existe tanta variedad entre ejemplares que cada uno de ellos es prácticamente único. Se dice que su nombre proviene de una palabra india “choctaw”, que era el nombre que denominaba a una tribu de nativos americanos, el cual fue evolucionando hasta llegar a ser catahoula. Fue decretado como el perro oficial del estado de Louisiana en 1979.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-leopardo-de-catahoula.html",
        n: "/img/razas/13.jpg",
      },
      {
        nombre1: "Perro Lobo Checoslovaco",
        nombre2: "",
        pais_origen: "Checoslovaquia",
        origen:
          "Esta raza es muy nueva y se originó a partir de un experimento realizado en 1955 en la desaparecida Checoslovaquia. Querían conseguir descendencia a partir de perros y lobos, para lo que se usaron lobos de los Cárpatos con pastores alemanes. Al finalizar dicho experimento se empezó la crianza de esta raza, con la intención de conseguir en un solo animal las mejores cualidades de ambos padres.",
        caracteristica:
          "Activos, curiosos y valientes, pero también desconfiados y con reacciones rápidas y enérgicas. Suelen ser muy leales con los suyos y también necesitar de harto deporte. Estos perros pierden pelo regularmente, pero especialmente durante las épocas de muda, y se considera un perro muy sano.",
        recomendacion:
          "Dado que son descendientes directos de los lobos, estos perros pueden ser muy poco sociables. Y al tener impulsos cazadores muy intensos, es importante socializarlos lo antes posible con la gente, perros y con otros animales. Son perros muy activos que tienen una fuerte inclinación a vivir en sociedad, así que no son canes para dejar solos en el jardín.",
        ideal: "",
        dato: "Es en realidad una subespecie del lobo (aunque con características ecológicas y etológicas muy diferentes).",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 2,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-lobo-checoslovaco.html",
        n: "/img/razas/87.jpg",
      },
      {
        nombre1: "Perro Lobo de Saarloos",
        nombre2: "",
        pais_origen: "Holanda",
        origen:
          "A pesar de su apariencia lobuna y comportamientos primitivos, esta es una de las razas caninas más recientes y planificadas. Fue creada por Leendert Saarloos, un holandés aficionado al perro pastor alemán, para conseguir mejores características físicas. Saarloos cruzó un macho de pastor alemán, Gerard van der Fransenum, con una hembra de lobo siberiano. Esos perros se constituyeron en la raza que posteriormente se llamaría perro lobo europeo.",
        caracteristica:
          "Estos perros no fueron creados para cumplir un trabajo en particular, y por eso su temperamento no refleja el típico carácter de los perros pastores. Al contrario, los Saarloos son perros con comportamientos muy primitivos (desde el punto de vista evolutivo), que recuerdan al lobo. Son muy enérgicos, activos, independientes e inteligentes, pero difíciles de entrenar. También son muy reservados y tímimdos con los extraños.",
        recomendacion:
          "Es muy importante socializarlos desde muy temprana edad, ya que la ventana en la que se puede hacer es menor que en otras razas de perros. Necesitan mucho ejercicio físico.",
        ideal:
          "No suelen ser buenos compañeros ni para otras mascotas ni para niños, ya que sus instintos cazadores son fuertes. No son perros adecuados para la vida en departamento o casa pequeña.",
        dato: " Tiene la apariencia y muchas conductas de los lobos, del cual desciende. La población inicial de esta raza tenía un 25% de sangre de lobo.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-lobo-de-saarloos.html",
        n: "/img/razas/120.jpg",
      },
      {
        nombre1: "Perro pastor blanco suizo",
        nombre2: "",
        pais_origen: "Suiza",
        origen:
          "En 1899 el capitán de caballería Max Emil Frederick von Stephanitz compró a Hektor Linkrshein, el primer perro registrado como pastor alemán. Hektor tenía por abuelo a un perro pastor de color blanco llamado Greif. Al ser descendiente de un perro blanco transmitió esos genes aún cuando él no era un perro blanco. Así, los pastores alemanes originales podían ser de colores oscuros, claros o blancos, de donde apareció esta raza.",
        caracteristica:
          "Son inteligentes y leales. Su temperamento puede ser algo nervioso o tímido, pero cuando están bien educados se adaptan con facilidad a diferentes situaciones, por lo que pueden vivir en diferentes lugares y bajo diferentes condiciones. Pueden ser agresivos hacia otros perros del mismo sexo, y debido a su gran inteligencia aprenden con facilidad nuevas enseñanzas y trucos.",
        recomendacion:
          "La socialización de los cachorros es muy importante ya que, por su naturaleza de perro pastor, tienden a ser desconfiados y cautelosos con desconocidos. Siempre hay que supervisar los juegos con los niños para evitar situaciones riesgosas.",
        ideal:
          "Con una buena socialización y educación, los pastores blancos pueden ser excelentes perros mascota, ya sea para familias con niños o para personas adultas.",
        dato: "A lo largo de su historia la raza ha recibido diferentes nombres, entre los que se encuentran: pastor americano-canadiense, pastor alemán blanco, pastor blanco americano y pastor blanco. Finalmente se ha terminado llamando pastor blanco suizo, porque la Sociedad Canina Suiza fue la primera en reconocer esta raza como independiente.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 6,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-pastor-blanco-suizo.html",
        n: "/img/razas/192.jpg",
      },
      {
        nombre1: "Perro Pastor Croata",
        nombre2: "Hravtski Ovcar",
        pais_origen: "Croacia",
        origen:
          "Se originó en Croacia y era empleado como pastor y guardián en las llanuras de Eslavonia, región agrícola al este de Croacia, limitada por los ríos Drava, Sava y Danubio.",
        caracteristica:
          "Son inteligentes, atentos, activos y leales. Sus instintos de pastoreo y de guardia son muy fuertes, y son perros que aprenden con facilidad. Además, son tranquilos, estoicos y nada agresivos. No tienden a ser cazadores, pero sí tienen fuertes instintos territoriales, por lo que es importante educarlos correctamente para evitar problemas con los vecinos.",
        recomendacion:
          "Si no reciben el suficiente cariño y compañía pueden llegar a convertirse en perros destructores. También necesitan mucho deporte. Son perros que evolucionaron para trabajar en compañía de seres humanos y de animales de corral, por lo que demandan mucho ejercicio físico y mental, así como mucho tiempo de compañía. En caso de cubrir esas necesidades, no tendrán problemas de comportamiento.",
        ideal:
          "Con el adiestramiento canino adecuado, los pastores croatas pueden vivir bien en departamento pequeños, siempre y cuando se les permita hacer suficiente ejercicio.",
        dato: "Es de las pocas razas que no presentan enfermedades hereditarias.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-pastor-croata.html",
        n: "/img/razas/32.jpg",
      },
      {
        nombre1: "Perro Pastor Polaco de las Llanuras",
        nombre2: "Polski Owczarek Nizinny",
        pais_origen: "Polónia",
        origen:
          "El origen es desconocido, igual que el de la mayoría de las razas de perros antiguas. Sin embargo, esta can es conocido desde la Edad Media por sus habilidades como perro de pastoreo en las llanuras de la antigua Polónia. Se piensa que es el resultado de cruces entre perros tibetanos de pelo largo y perros húngaros de pelo acordonado/trenzado. ",
        caracteristica:
          "Vigilantes, despiertos, vivaces y muy inteligentes. La selección a la que fueron sometidos como perros pastores les ha dejado un temperamento estable y paciente. El problema son sus ladridos excesivos y su conducta de morder los talones para arrear a la gente.",
        recomendacion:
          "Necesita hacer mucha actividad física para que no se aburra y no desarrolle algún mal comportamiento (como los ladridos excesivos).",
        ideal:
          "Son excelentes mascotas para familias dinámicas a las que les gustan las actividades al aire libre. Tienden a llevarse bien con los niños.",
        dato: "Es poco conocido fuera de Europa, pero tiene aficionados en diferentes países de ese continente, especialmente en Polonia y Gran Bretaña. ",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-pastor-polaco-de-las-llanuras.html",
        n: "/img/razas/169.jpg",
      },
      {
        nombre1: "Perro Peruano",
        nombre2: "Perro sin pelo",
        pais_origen: "México",
        origen:
          "Es oriundo de las civilizaciones preíncas, ya que son muchas las pruebas arqueológicas existentes que datan su aparición en el año 500 a. C., e incluso se han encontrado momificados en las tumbas de los nobles de aquella época. Los incas lo llamaban Allqu o Kaclla.",
        caracteristica:
          "Dóciles, inteligentes y tranquilos. Suelen ser confiados y cariñosos con sus tutores, aunque se muestran más cautelosos con los extraños.  Tienen un carácter atento y protector.",
        recomendacion:
          "Debido a su delicada piel y que no tiene pelo, es mejor que viva al interior de la casa. Así se protegerá de la lluvia, el sol o el frío y el calor, etc…",
        ideal: "",
        dato: "Es una de las pocas razas de perro sin pelo. Además, está reconocida como patrimonio nacional por el Congreso de la República del Perú. En civilizaciones preincas desempeñaba distintos roles, pero uno de los más llamativos era que participaba en diferentes ceremonias y rituales llevados a cabo por curanderos y chamanes, pues se creía que estos animales tenían propiedades curativas. Cuando uno de ellos fallecía su cuerpo se aprovechaba según la necesidad que se tuviera, por ejemplo, se creía que su sangre beneficiaba a aquellos que padecían asma.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 4,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-peruano.html",
        n: "/img/razas/95.jpg",
      },
      {
        nombre1: "Perro Pomsky",
        nombre2: "Mini Husky",
        pais_origen: "Noruega",
        origen:
          "Se trata de la mezcla entre dos razas nórdicas muy populares: el husky siberiano y el pomerania. Se originaron en Estados Unidos, siendo una de las razas de perros más recientes que existen.",
        caracteristica:
          "Su comportamiento dependerá de qué porcentaje genético haya heredado de cada progenitor. De esta forma, si es más pomerania, se tratará de perros más territoriales y apegados a su tutor (incluso algunos pueden presentar problemas a la hora de relacionarse con niños y otros animales de compañía). Si los genes predominantes son los del husky, no tendrán ninguna dificultad para adaptarse a la vida familiar, aunque también puede ser necesario o recomendable un entrenamiento adecuado a sus necesidades.",
        recomendacion:
          "No soportan el calor, y es importante que les tengamos siempre un lugar fresco y sin sol para que puedan descanzar, así como no llevarlos a paseos muy intensos y largos (especialmente en verano).",
        ideal: "",
        dato: "El aspecto del perro pomsky recuerda a un husky en miniatura.",
        size: 1,
        vida: 3,
        deporte: 1,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/perro-pomsky.html",
        n: "/img/razas/88.jpg",
      },
      {
        nombre1: "Pinscher Alemán",
        nombre2: "",
        pais_origen: "Alemania",
        origen:
          "Oriunda de Alemania, esta raza suele conocerse como pinscher estándar dado lo frecuentes que son en ese país.",
        caracteristica:
          "Es un perro realmente vivaracho. Su vivacidad y energía son brutales, siendo un perro notablemente activo, que adora los juegos y paseos al aire libre (ha sido tradicionalmente un perro de granja y campo).  Acostumbra a ser un perro muy posesivo si no ha sido educado correctamente, lo que despierta en él comportamientos algo agresivos y muy posesivos ante otros animales y personas.  No es una raza indicada para la soledad y son realmente testarudos (constará que obedezcan y que aprendan rutinas).",
        recomendacion:
          "Tenemos que asegurarnos de que realiza suficiente deporte todos los días.",
        ideal:
          "Son una gran elección para personas activas, pues antes de adoptarlo lo que hay que tener muy muy en cuenta es que son animales que requieren mucho deporte. Algunos incluso los consideran hiperactivos.",
        dato: "Este perro ya acompañaba a nobles alemanes hace más de 6 siglos, de manera que estamos ante una raza bastante antigua.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pinscher-aleman.html",
        n: "/img/razas/27.jpg",
      },
      {
        nombre1: "Pinscher Austriaco",
        nombre2: "",
        pais_origen: "Austria",
        origen:
          "Los ancestros de esta raza se usaban en las granjas austriacas para cuidar el ganado, arrearlo y eliminar ratas y otras alimañas. Algunos autores piensan que este perro está emparentado con el pinscher alemán y con el pinscher miniatura, pero casi nada se sabe acerca de su historia. La historia moderna es más conocida, ya que el estándar de la raza actual se definió en 1928 (en esa época llamado pinscher austriaco de pelo corto).",
        caracteristica:
          "Dinámicos y curiosos. Son juguetones y afectuosos con los suyos, pero reservados e incluso perros mordedores cuando se encuentran con extraños o en situaciones que desconocen. También tienden a ser agresivos con otros perros, por lo que no es buena mascota si no va a ser el único.",
        recomendacion:
          "Suelen ser excelentes guardianes, pero es muy importante socializarlos desde cachorros para evitar que sean agresivos de adultos. Necesita hacer mucho ejercicio.",
        ideal:
          "Es importante que dispongan de grandes espacios donde no corran peligro para que jueguen y gasten sus energías, y que vivan mejor en lugares amplios como casas o apartamentos con jardín. Por su tendencia a ladrar, no se adapta muy bien a la vida en departamentos ni en ciudades densamente pobladas. Necesita un jardín grande donde ejercitarse o, mejor aún, vivir en una propiedad rural donde disfrute de mayor libertad.",
        dato: "Aún hoy en día este pinscher sigue siendo prácticamente desconocido.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pinscher-austriaco.html",
        n: "/img/razas/171.jpg",
      },
      {
        nombre1: "Pinscher miniatura",
        nombre2: "",
        pais_origen: "Alemania",
        origen:
          "Se originó en Alemania, a partir de cruces entre el pinscher alemán, el galgo italiano y el dachshund (perro salchicha). También se lo conoce como pin min, min pin y pinscher enano. El nombre original en alemán es zwergpinscher.",
        caracteristica:
          "Están llenos de vida, son dinámicos, curiosos e intrépidos. Son perros de temperamento fuerte y aguerrido, a pesar de su pequeño tamaño. Tiende a ser un perro saludable y la raza no es particularmente propensa a enfermedades.",
        recomendacion:
          "La socialización de estos perros es muy importante y no hay que tomarla a la ligera. Cuando no están correctamente socializados tienden a ser desconfiados con los extraños y agresivos con otras mascotas, incluso pueden ser destructivos si se aburren o si se quedan solos por períodos muy largos. La obesidad también puede llegar a ser un problema, porque estos perros suelen ser muy buenos para comer.",
        ideal:
          "Se adaptan perfectamente a vivir en departamentos o casas pequeñas. Aunque disfrutan de un jardín para jugar, no son perros aptos para vivir en exteriores.",
        dato: "Aunque lo parece, no comparten origen ni antepasados con el Doberman.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 4,
        clima: 3,
        child: "none",
        depa: "inline",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/petit-brabancon.html",
        n: "/img/razas/103.jpg",
      },
      {
        nombre1: "Pit Bull Terrier Americano",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Tenen sus orígenes en la Gran Bretaña del siglo XIX, pero su historia se remonta a la época del imperio romano. Esta raza desciende de perros molosos de pelea, que originalmente se usaban para peleas contra toros y osos. ",
        caracteristica:
          "Hoy en día la mayoría de la gente piensa que son perros peligrosos, inestables y muy agresivos, pero eso ocurre solo para algunos perros y no para la raza en general. Es un perro con un impulso de presa muy desarrollado, pero no es un asesino por naturaleza. De hecho, tiende a ser un perro muy sociable con la gente, amigables, juguetones y confiables. Además es entusiasta, muy vital y divertido. No es un buen perro guardián, porque suele ser amigable con los extraños, pero es muy bueno para cuidar niños ya que es paciente y tolerante. Es una de las razas de perros más resistentes a las enfermedades.",
        recomendacion:
          "Al tratarse de un perro poderoso y fuerte, hay que sociabilizarlo desde muy pequeño para que no ocurran accidentes. Al ser tan activo y enérgico necesita por lo menos un paseo diario.",
        ideal: "",
        dato: "Hay un mito que dice que es incapaz de soltar la presa porque sus quijadas se traban de alguna manera (es falso). Australia prohíbe la importación del pit bull y obliga a todos los ejemplares existentes en el país a ser castrados en un intento por eliminar lentamente la población. En Malta es ilegal tener a un pit bull y en caso de tenencia la persona responsable será juzgada y se sacrificará a la mascota. España, Colombia y Chile consideran al pit bull terrier un Perro Potencialmente Peligroso (PPP) y su tenencia necesita una licencia, un seguro de responsabilidad civil y el uso de bozal y correa en espacios públicos.",
        size: 2,
        vida: 2,
        deporte: 3,
        intel: 2,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pit-bull-terrier-americano.html",
        n: "/img/razas/112.jpg",
      },
      {
        nombre1: "Podenco Andaluz",
        nombre2: "",
        pais_origen: "España",
        origen:
          "Desarollado en Andalucía, al sur de la Península Ibérica, estos perros descienden de los antiguos perros egipcios que llegaron gracias a los comerciantes fenicios que viajaron a la península. Se estima que los podencos llegaron a nuestra península hace más de 3.000 años.",
        caracteristica:
          "Son sociables, inteligentes, afectuosos y con un temperamento equilibrado y mesurado. Es un cazador innato, estando siempre alerta y reaccionando muy rápido. Es extremadamente fieles a los suyos, perspicaces y atentos, y aprenderán con facilidad las órdenes básicas de obediencia.",
        recomendacion:
          "El cachorro deberá permanecer junto a su madre y hermanos hasta los dos meses y medio de vida aproximadamente, para garantizar una buena socialización. De no ser así, es muy probable que en su etapa adulta presente miedos e inseguridad. También tenemos que estar atentos a que no sufra un golpe de calor o shock térmico, especialmente en verano (aseguremonos de que tenga un lugar fresco y sin sol donde pueda descanzar).",
        ideal:
          "Tiene una capacidad de adaptación muy alta, por lo que puede vivir tanto en departamentos pequeños como en casas rurales.",
        dato: "Ya acompañaban a los egipcios hace más de tres milenios.",
        size: 2,
        vida: 2,
        deporte: 4,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/podenco-andaluz.html",
        n: "/img/razas/61.jpg",
      },
      {
        nombre1: "Podenco Canario",
        nombre2: "",
        pais_origen: "España",
        origen:
          "Su origen se dá en las Islas Canarias, siendo un perro muy común en esta zona del territorio español. Se sospecha que su llegada a la isla es fruto del desplazamiento de Griegos, Fenicios o Cartagineses.",
        caracteristica:
          "Es considerado un perro de rastro, nervioso, inquieto y dinámico. Así mismo, es también un perro de temperamento noble, valiente y dócil y de fácil manejo. El nerviosismo característico de la raza destacará mucho más en su etapa de juventud.",
        recomendacion:
          "El carácter dependerá mayormente de su genética, aprendizaje y experiencias vividas, por lo que debemos socializar al perro desde que es cachorro. También debemos preocuparnos de que realice harto ejercicio físico, lo que es fundamental para mantener su musculatura en forma y lograr que queme todo el exceso de energía acumulada.",
        ideal: "",
        dato: "Su aspecto, que recuerda al de las figuras de vestigios, grabados, estatuas o bajorrelieves, hace sospechar que se trata de una raza muy antigua, con más de 7.000 años de antigüedad.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 2,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/podenco-canario.html",
        n: "/img/razas/68.jpg",
      },
      {
        nombre1: "Podenco Ibicenco",
        nombre2: "",
        pais_origen: "España",
        origen:
          "Se originó en las islas de Mallorca, Ibiza, Menorca y Formentera. En ellas, así como en otras regiones de España, es empleado para la caza del conejo, de la liebre y para la caza mayor. Se piensa que descienden de perros egipcios llevados a las islas por comerciantes hace mucho tiempo y que es una raza antigua, pero últimos estudios del genoma canino sugieren que en realidad es una raza reciente.",
        caracteristica:
          "Es muy independiente, curioso, dinámico y enérgico, capaz de animar a cualquier persona floja o sin energía. Sus instintos cazadores son muy fuertes y se hacen evidentes a temprana edad. No toleran bien el frío y responden bien a las enseñanzas.",
        recomendacion:
          "La socialización es muy importante, ya que tienden a ser desconfiados con los extraños y con perros del mismo sexo. Hay que tener cuidado si se tienen otras mascotas pequeñas, ya que sus fuertes instintos cazadores pueden llevarlos a atacarlos. Esta raza necesita mucho ejercicio diario y no son particularmente ladradores, pero pueden serlo si se quedan solos por mucho tiempo.",
        ideal:
          "Es útil contar con un jardín grande donde pueda correr libremente, o tener acceso a algún espacio público cercado. Pero no se recomienda tenerlo en departamentos o casa pequeñas.",
        dato: " Antiguamente, estos perros eran utilizados para cazar conejos y otras presas, por lo que aún perduran sus instintos naturales de cazadores.",
        size: 2,
        vida: 2,
        deporte: 4,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/podenco-ibicenco.html",
        n: "/img/razas/62.jpg",
      },
      {
        nombre1: "Podenco Portugués",
        nombre2: "Podengo Português",
        pais_origen: "España",
        origen:
          "Se estima que sus primeros antepasados fueron introducidos a la Península Ibérica por los fenicios alrededor del año 700 a.C. La raza de hoy empieza a desarrollarse en mediados del siglo XV, cuando solían acompañar a los navegantes portugueses en sus embarcaciones para evitar la proliferación de roedores y sus enfermedades.",
        caracteristica:
          "Son perros enérgicos, con una personalidad fuerte y bastante independiente. Eso no le impide disfrutar enormemente de las caricias y de la compañía de sus tutores y familiares, con quienes suele compartir un vinculo de confianza mutua y gran lealtad. Necesitarán que respetemos sus momentos de paz y tranquilidad, por ejemplo cuando se alimentan y descansan. Son excelentes perros guardianes, astutos, activos e inteligentes.",
        recomendacion:
          "Pueden comportarse de forma desconfiada y reservada en la presencia de personas y animales que no conocen. La socialización será clave para que aprenda a relacionarse de forma positiva con los diferentes personas, animales y estímulos con los que se encontrará a lo largo de su vida. Tiene una personalidad fuerte y mañosa requiere una mayor dedicación de tiempo para su educación. ",
        ideal: "",
        dato: "Es una raza canina muy antigua, que está clasificada por la FCI dentro del grupo 5, que comprende a perros de tipo Spitz y perros primitivos. ",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/podenco-portugues.html",
        n: "/img/razas/55.jpg",
      },
      {
        nombre1: "Pointer Inglés",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Aunque se acepta que el pointer actual es de Inglaterra, su historia es poco conocida. Ya existía en el siglo XVII, y algunos opinan que un antiguo pointer español fue el precursor de esta raza, aunque no existan datos precisos que soporten esta hipótesis.",
        caracteristica:
          "El carácter del pointer inglés viene marcado, en parte, por su pasado como perro cazador. Suelen ser muy dinámicos, curiosos y alertas, además de ser muy amables y de baja agresividad. Se llevan bien tanto con personas como con otros perros y animales.",
        recomendacion:
          "No es necesario bañarlos con frecuencia, ya que se mantienen limpios con facilidad. Realizar un baño cada dos o tres meses será suficiente.",
        ideal:
          "Resultan excelentes perros para familias con niños o con otras mascotas, ya que es muy sociable. Vive mucho mejor en el interior del hogar que afuera.",
        dato: "Su nombre proviene del inglés to point, que significa mostrar o señalar, y que hace alusión a los momentos de caza, en donde las personas apuntaban a los animales para que ellos los cazaran.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pointer-ingles.html",
        n: "/img/razas/138.jpg",
      },
      {
        nombre1: "Pomerania",
        nombre2: "",
        pais_origen: "Alemania",
        origen:
          "Nace en un antiguo ducado llamado Pomerania, situado entre Alemania y Polonia. A diferencia del pomerania actual, los primeros ejemplares eran de un tamaño mucho mayor. Controlaban ovejas, bovinos y ciervos. Su nombre original era “Wolfspitz”, que significa lobo de spitz.",
        caracteristica:
          "Es un perro hogareño, muy cariñoso y faldero, el cual odia la soledad y la falta de atención. También es muy activo, despierto e inteligente, incluso curioso. Suele ser muy ladrador.",
        recomendacion:
          "Su pelaje es bastante largo y sedoso por lo que será fundamental peinarlo con regularidad. Es importante cuidarlo del frío.",
        ideal:
          "Es un perro perfecto para familias muy distintas, pero debemos tener claro que va a necesitar varios paseos, atención constante y tiempo para educarle. Es hipoalergénico, por lo que es perfecto para las personas alérgicas.",
        dato: "A diferencia de los antiguos pomerania que pesaban alrededor de 23 kilogramos, el actual estándar de la raza se sitúa sobre los 1,8 y 2,5 kilogramos. ",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "inline",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pomerania.html",
        n: "/img/razas/163.jpg",
      },
      {
        nombre1: "Presa Canario",
        nombre2: "Dogo Canario",
        pais_origen: "España",
        origen:
          "Proviene del Archipiélago Canario, principalmente de las Islas de Tenerife y Gran Canaria (España). Descienden de los antiguos perros majoreros, que existían en el archipiélago desde tiempos prehispánicos (antes del siglo XIV). La raza moderna termina de definirse en el siglo XVIII, cuando ocurre una fuerte migración inglesa hacia las islas. Los ingleses llevaron al archipiélago perros tipo bulldog y bull terrier que empleaban en las crueles peleas de perros, y la cruza entre las dos razas dio origen al presa canario.",
        caracteristica:
          "Es un perro tranquilo y con un temperamento calmado, atento y especialmente seguro de sí mismo. Su pasado como perro guardián le predispone a tener una actitud tímida y reservada con desconocidos, pero muy noble y serena con sus familiares cercanos. Es sin duda uno de los perros más leales que existen.",
        recomendacion:
          "La socialización del cachorro es uno de los factores más importantes.",
        ideal:
          "No es la raza más adecuada para propietarios novatos e inexpertos, ya que necesita a su lado una persona responsable y experimentada.",
        dato: "Es el símbolo nacional de la Isla de Gran Canaria (España) y uno de los perros más antiguos de españa.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 2,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/presa-canario-o-dogo-canario.html",
        n: "/img/razas/124.jpg",
      },
      {
        nombre1: "Pug",
        nombre2: "Carlino",
        pais_origen: "China",
        origen:
          "Su origen es incierto y polémico. Se sabe que procede de China y que eran,  junto a los pekineses, los animales favoritos en los monasterios tibetanos. Probablemente hayan sido llevados a Holanda por comerciantes holandeses, desde donde se habría difundido la raza en Francia, Inglaterra y el resto de Europa.",
        caracteristica:
          "Es el típico de un perro de compañía: cariñoso, alegre y juguetón. Tiene una personalidad fuerte y le gusta llamar la atención, pero es de carácter estable. Estos perros son fáciles de socializar se llevan bien con personas adultas, niños, otros perros y otros animales. Sin embargo, aunque son juguetones, no soportan bien los juegos intensos y las bromas de niños muy chicos.",
        recomendacion:
          "Necesita tener compañía constantemente ya que son muy juguetones, y si están solos pueden desarrollar ansiedad por separación. Tienden a padecer obesidad, asi que es importante acostumbrar a nuestro perro desde que es pequeño al ejercicio moderado, pero nunca intenso (debido a su achatada nariz podría ahogarse). Necesitan compañía constante y pueden volverse perros destructores cuando quedan solos por mucho tiempo. Pierden mucho pelo, por lo que puede ser deseable cepillarlos con frecuencia para mantener los muebles y la ropa limpios.",
        ideal:
          "Son excelentes mascotas para la mayoría de las personas y familias con niños grandes, e incluso para propietarios novatos. Sin embargo, esta raza no es aconsejable para familias con niños muy pequeños, ya que éstos suelen maltratar sin intención a los perros pequeños. Son perros para vivir dentro de casa con la familia y se adaptan muy bien a la vida en departamentos y en grandes ciudades.",
        dato: "Y el lema oficial de la raza es multum in parvo (len latín: mucho en poco - mucha sustancia en pequeño espacio).",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 2,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "inline",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/pug-o-carlino.html",
        n: "/img/razas/6.jpg",
      },
      {
        nombre1: "Puggle",
        nombre2: "",
        pais_origen: "USA",
        origen:
          "Surge del cruce entre perros de la raza beagle y aquellos de la raza pug. Normalmente, en el cruce, la hembra es la beagle y el macho el pug, dándose muy raramente el caso contrario. No se conocen ni el momento ni el lugar exacto en el que se origina este particular perro híbrido, solo se cuenta con un primer registro en Wisconsin, que data del año 1980.",
        caracteristica:
          "Son sumamente cariñosos y sociables. Adoran vivir en familia, compartiendo hogar con mayores y pequeños, así como con otras especies animales. No toleran la soledad, algo que ha de tenerse muy en cuenta si se pretende adoptar uno, ya que pueden sufrir trastornos como la ansiedad por separación o estrés.",
        recomendacion:
          "Destaca la necesidad de estar acompañado en todo momento. Recordemos que el puggle es un perro con tendencia a desarrollar ansiedad por separación si no se le enseña a estar solo, por lo que es fundamental trabajar en eso desde el primero momento, sobre todo si lo adoptamos siendo un cachorro. Uno de los principales problemas es la sobreprotección, algo que mucha gente hace pero que no les beneficia para nada. El puggle acostumbra a ser un perro muy sensible, que tiende a llorar o a mostrar una actitud temerosa si siente que lo están retando. ",
        ideal:
          "Tienen la capacidad de adaptarse a distintas situaciones y entornos. De esta forma, el puggle es un perro que puede vivir perfectamente en departamentos, casas o grandes terrenos. Para él, lo más importante es la compañía y el cariño.",
        dato: "",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 2,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/puggle.html",
        n: "/img/razas/43.jpg",
      },
      {
        nombre1: "Ratón de Praga",
        nombre2: "Ratonero de Praga",
        pais_origen: "República Checa",
        origen:
          "Empieza su historia en la edad media, en los palacios reales de la Europa central, más concretamente en Bohemia (República Checa). Era una raza muy apreciada, presente hasta en las fiestas aristocráticas de la época.",
        caracteristica:
          "Es muy vivaz, activo, cariñoso y obediente. Nos sorprenderá con su energía y ganas de jugar, lleno de carácter y valentía. Además son muy sociables, especialmente con las personas, con quienes crea vínculos afectivos muy potentes.",
        recomendacion:
          "Su educación es algo muy importante si hay niños en casa, pero también fundamental para evitar que ladre mucho o que se comporte de una forma negativa .",
        ideal:
          "Si no tienes tiempo para hacer largos paseos, jugar activamente o educarlo de forma responsable, mejor piensa en otra raza de perro.",
        dato: "En su etapa adulta no suele superar los 3,5 kilogramos de peso. Antiguamente príncipes, reyes y otros cargos altos disfrutaban de la compañía del ratón de Praga como símbolo de estatus. Tal era la devoción que tenían por el perro, que el entonces príncipe Vladislav II empezó a ofrecerlo como regalo a los reyes y nobles eslovacos, y más tarde a otros miembros de cortes Europeas.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/raton-de-praga.html",
        n: "/img/razas/133.jpg",
      },
      {
        nombre1: "Ratonero Valenciano",
        nombre2: "Gos Rater Valencià",
        pais_origen: "España",
        origen:
          "Su remoto origen data del siglo XVI, cuando algunos relatos de la época lo retratan como un animal propio de campesinos y terratenientes.  La raza se reconoce oficialmente en 2004 por la Federación Canina Española, aunque ya en 1994 debutó en una exposición canina y se creó posteriormente el Club Español del Ratonero Valenciano-CERVA .",
        caracteristica:
          "Son animales muy activos e inquietos, que necesitan actividad y juego. Son excelentes guardianes, ladran a los desconocidos mantienen el hogar seguro, ya que destacan por ser valientes y no asustarse ante extraños. Destacan también por ser inteligentes y por tener una saldud muy buena.",
        recomendacion:
          "Resulta vital proporcionarle la actividad física que necesitan para mantenerse tranquilo y equilibrado. Debido a su pelaje corto debemos tener cuidado en épocas de frío, ya que nuestro animal estará más expuesto a sufrir hipotermia.",
        ideal: "",
        dato: "Fue históricamente utilizado para acabar con las plagas de roedores que perjudican a los agricultores y campesinos.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/ratonero-valenciano-o-gos-rater-valencia.html",
        n: "/img/razas/90.jpg",
      },
      {
        nombre1: "Rottweiler",
        nombre2: "",
        pais_origen: "Alemania",
        origen:
          "La raza tiene su origen formal en la región alemana de Rottweil. Cuando los romanos llegaron a la región de Rottweil, sus perros se cruzaron con perros nativos del lugar, y el resultado dio origen al perro de carnicero de Rottweil. Éste era empleado para colaborar a los carniceros locales durante el faenado de las reses, encargándose de controlar a los toros y las vacas más agresivas.",
        caracteristica:
          "Atento, obediente, calmado, valiente, seguro, confiable y leal con los suyos. Su flexibilidad y estabilidad emocional le permiten adecuarse bien a diferentes actividades,y puede ser entrenado para la protección de su familia, obediencia, perro de policía, perro de terapia o perro de asistencia. El problema es que, de no tener una buena crianza, pueden ser muy agresivos, por lo que es muy importante socializarlos desde cachorros.  Ha caído en la categoría de perros potencialmente peligrosos en muchos países, pero es importante entender que solamente es un perro peligroso cuando es educado por personas irresponsables.",
        recomendacion:
          "Son muy enérgicos, y esta vitalidad irá aumentando conforme el cachorro vaya creciendo. Por eso, es muy importante jugar con ellos todos los días mientras son cachorros. Es muy importante socializar a nuestro rottweiler desde que es cachorro para que se convierta en un perro sociable, equilibrado y feliz (y lo más importante, no agresivo). Es un perro con tendencia a engordar por lo que dedicaremos tiempo a prevenir la obesidad mediante las dosis adecuadas de alimento, ejercicio físico y los snacks moderados.",
        ideal: "",
        dato: "Esta raza es una de las que ha caído en la categoría de perros potencialmente peligrosos en muchos países. Esto es una lástima ya que el rottweiler solamente es un perro peligroso cuando es educado por personas irresponsables para fomentar su agresividad. El carácter correctamente socializado está lejos de ser peligroso y, por el contrario, es el de un perro dócil y amigable.",
        size: 3,
        vida: 2,
        deporte: 2,
        intel: 6,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "inline",
        intel2: "inline",
        link: "https://www.expertoanimal.com/razas-de-perros/rottweiler.html",
        n: "/img/razas/7.jpg",
      },
      {
        nombre1: "Salchicha",
        nombre2: "Dachshund",
        pais_origen: "Alemania",
        origen:
          "Son originarios de Alemania. El primer estándar de la raza data de 1888, aunque hay constancia de ellos en exposiciones de años anteriores en Inglaterra. La reina Victoria de Reino Unido era una enamorada de la raza.",
        caracteristica:
          "Son muy juguetones y amigables con los suyos, pero tienen un impulso de presa muy fuerte que los hace perseguir y atacar a animales pequeños. También suelen ser ladradores. Son muy testarudos y difíciles de adiestrar. Los principales problemas de comportamiento son los ladridos excesivos y la tendencia a excavar en el jardín. Es un perro propenso a lesiones de columna vertebral.",
        recomendacion:
          "Es importante socializarlos desde pequeños porque su naturaleza es desconfiada con desconocidos. Sin una correcta socialización tienden a ser agresivos o miedosos, tanto con personas desconocidas como con otros perros. Si se quedan solos por mucho tiempo o se aburren, suelen destruir muebles o cavar el jardín.",
        ideal:
          "Se adaptan bien a la vida en departamentos o casas pequeñas. Sin embargo, pueden causar algunos problemas con los vecinos porque tienden a ser ladradores.",
        dato: "En alemán significa perro tejonero, hace referencia a la función original de este can que era la de cazar tejones. Existen 3 perros salchichas: de pelo corto, pelo largo y pelo duro.",
        size: 1,
        vida: 4,
        deporte: 1,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/dachshund-o-teckel-estandar.html",
        n: "/img/razas/162.jpg",
      },
      {
        nombre1: "Saluki",
        nombre2: "",
        pais_origen: "Egipto",
        origen:
          "También conocido como pero real de Egipto, es una de las razas de lebreles más antiguas y domesticadas que se conocen. Se originó en Oriente Medio donde fue empleado por miles de años como galgo de caza. Se dice que descienden de los lobos del desierto de Ara. Gracias a sus grandes cualidades de perro cazador, logró un espacio importante en el mundo árabe.",
        caracteristica:
          "Es un perro resistente y muy veloz, llegando a ser unos de los perros más rápidos del mundo.  Tiene un carácter reservado, pacífico y muy leal. El problema es que no es fácil de educar, necesitando de muchas repeticiones y paciencia para lograrlo. ",
        recomendacion:
          "Se debe tener cuidado de no soltarlos en lugares cercanos a calles o avenidas transitadas. Dado que son perros tan veloces, pueden salirse del parque sin que sus dueños se den cuenta.",
        ideal:
          "Debido a su carácter desconfiado e independiente este perro no es ideal para familias con niños pequeños, pero es una buena mascota para familias con niños grandes que puedan asumir responsabilidades en el cuidado del perro. No es adecuado para casas en las que hay otras mascotas pequeñas, ya que el instinto de caza del saluki lo lleva a perseguir y matar animales pequeños. Necesitan mucho ejercicio y no son aptos para vivir en departamentos o casas pequeñas. ",
        dato: "De acuerdo con la tradición árabe, el Saluki no se vende y solamente se entrega como regalo en señal de honor.",
        size: 3,
        vida: 3,
        deporte: 4,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/saluki.html",
        n: "/img/razas/158.jpg",
      },
      {
        nombre1: "Samoyedo",
        nombre2: "",
        pais_origen: "Asia",
        origen:
          "La tribus samoyedas habitaban el territorio comprendido entre el noroeste de Siberia y Asia Central. Esos pueblos nómadas dependían de sus perros para pastorear y cuidar los renos, protegerse de depredadores y cazar.  Estos perros cautivaron al explorador británico Ernest Kilburn-Scott durante sus investigaciones en el Ártico en 1889, y a su vuelta a Inglaterra llevó consigo un cachorro de samoyedo marrón como regalo para su esposa. La familia estaba tan encantada con los perros blancos que decidieron usarlos como base de su crianza.",
        caracteristica:
          "Es amistoso, vivaz y alerta. Aunque su origen puede hacernos pensar que es un perro con predisposición a la caza, lo cierto es que su instinto es muy leve. Es un perro amigable, que suele llevarse bien con los niños y con otros animales.",
        recomendacion:
          "Hay que tener cuidado en los días calurosos. Son perros que están acostumbrados a climas de hasta 30 grados bajo cero, por lo que en un día de altas temperaturas pueden sufrir un golpe de calor.",
        ideal:
          "Tiene un carácter muy especial y sociable, perfecto para familias activas y con niños o adolescentes. La raza se adapta bien a la vida tanto en campo como en ciudad si se le brinda suficiente ejercicio.",
        dato: "La raza también fue usada para explorar el otro hemisferio del planeta. Se dice que una perra de esta raza lideró la expedición de Roald Amundsen al Polo Sur. Es la primera de la especie canina en haber pasado por el Polo Sur... y lo hizo un poco antes que el primer hombre en hacerlo.",
        size: 2,
        vida: 3,
        deporte: 2,
        intel: 4,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "inline",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/samoyedo.html",
        n: "/img/razas/109.jpg",
      },
      {
        nombre1: "San Bernardo",
        nombre2: "",
        pais_origen: "Suiza",
        origen:
          "La historia dempieza en el Gran Monte de St. Bernhard, un collado entre Suiza e Italia de más de 2.473 metros sobre el nivel del mar. Allí se fundó en el siglo XI un hospicio para viajeros y peregrinos, el mismo lugar en el que en el siglo XVII se empezaron a criar perros grandes y robustos, con la intención de proteger y vigilar el hogar. Inicialmente estos perros eran guardianes dentro del hospicio y protectores de los monjes. En el año 1.887 el perro San Bernardo fue reconocido como una raza suiza y se convirtió en el perro nacional suizo.",
        caracteristica:
          "Gentil, sociable y amable. A pesar de su gran tamaño, estos gigantes bondadosos son normalmente tranquilos y no son tan juguetones como muchos perros de otras razas. Sin embargo, demandan compañía constante y pueden ser sobreprotectores con sus familiares. Además es una mascota paciente, obediente y leal.",
        recomendacion:
          "Si son abandonados en el jardín o se quedan solos por mucho tiempo pueden desarrollar conductas agresivas o sufrir ansiedad. Ojo con el calor, sobre todo en verano, cuando el perro no es capaz de regular correctamente la temperatura corporal.",
        ideal:
          "Es un perro que necesitará vivir en un departamento muy grande o una casa con jardín: debe tener espacio para moverse libremente. No requiere un nivel alto de ejercicio, por lo que son buenos compañeros para personas más sedentarias. Son también excelentes compañeros de los niños y, de hecho, son conocidos como perros niñeras.",
        dato: "El perro más pesado de esta raza llegó a pesar 118 kilogramos y alcanzar una altura de 90 centímetros.",
        size: 4,
        vida: 1,
        deporte: 2,
        intel: 2,
        clima: 1,
        child: "inline",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/san-bernardo.html",
        n: "/img/razas/139.jpg",
      },
      {
        nombre1: "Schipperke",
        nombre2: "",
        pais_origen: "Bélgica",
        origen:
          "En el siglo XVII estos perros eran mascotas predilectas de los zapateros del barrio San Gery en Bruselas, y se encargaban de mantener reducidas las poblaciones de ratas, ratones y otras alimañas.",
        caracteristica:
          "Tiene un carácter curioso y activo. Es ideal para la vigilancia por sus ladridos agudos que nos avisarán de cualquier cosa, y es desconfiado con los desconocidos. Aunque son independientes, también necesitan mucha compañía y son amigables con su familia. Pierden pelo regularmente.",
        recomendacion:
          "Hay que tener cuidado de no exigir demasiado a los perros, especialmente con ejercicios de saltos, para evitar dañar sus caderas.",
        ideal:
          "A pesar de su pequeño tamaño, necesita dosis media-alta de ejercicio diario, por lo que estará mucho mejor viviendo en una casa o departamento con espacio al aire libre. Son muy chicos para tolerar el trato rudo de niños pequeños, por lo que no son recomendables como mascotas para familias con niños menores de ocho años.",
        dato: "En el siglo XVII se les amputaba la cola, por una tradición que afortunadamente está perdiéndose.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/schipperke.html",
        n: "/img/razas/161.jpg",
      },
      {
        nombre1: "Schnauzer Gigante",
        nombre2: "",
        pais_origen: "Alemania",
        origen:
          "Esta raza se originó en Alemania, a partir de su primo el schnauzer. Los ganaderos alemanes estaban tan impresionados con las cualidades de esa raza que decidieron crear una nueva que tuviera las mismas cualidades, pero que fuese más grande. El tamaño era una cualidad necesaria para manejar ganado vacuno. No existe un registro de los cruces realizados para obtener al schnauzer gigante, pero se piensa que en esta raza existe sangre de gran danés y bouvier des Flandres, entre otras.",
        caracteristica:
          "Tiene un temperamento estable, inteligente, leal, valiente y activo. Les encanta jugar y disfrutar las actividades físicas al aire libre. Suelen ser territoriales e independientes, siendo uno de los mejores perros de guardia y defensa. Pierde muy poco pelo y no tiene un olor tan fuerte como otros perros.",
        recomendacion: " Requieren de buena cantidad de ejercicio diario.",
        ideal:
          "No suelen ser las mejores mascotas para familias con niños pequeños, ya que estos perros disfrutan mucho de juegos rudos y pueden llegar a ser muy torpes con los niños. Lo mejor es que viva en una casa con jardín y pase tiempo tanto en el exterior como en el interior.",
        dato: "Antiguamente se exigía la cola amputada, y aún existen muchos perros de esta raza con colas cortadas. Afortunadamente esta práctica está desapareciendo.",
        size: 4,
        vida: 3,
        deporte: 4,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/schnauzer-gigante.html",
        n: "/img/razas/125.jpg",
      },
      {
        nombre1: "Schnauzer Miniatura",
        nombre2: "Zwergschnauzer",
        pais_origen: "Alemania",
        origen:
          "Se originó en Alemania, concretamente en Frankfurt, a partir del schnauzer estándar. Aunque no se tiene certeza absoluta de los cruces realizados para conseguir la raza actual, se piensa que el affenpinscher y el caniche miniatura son sus ancestros. Originalmente se los utilizaba como perros ratoneros en las granjas, pero por su apariencia y agradable personalidad hoy es extremadamente popular en todo el mundo.",
        caracteristica:
          "Son muy activos, inteligentes, curiosos y leales. Aprenden con facilidad y, cuando son tratados de buena manera, son muy gentiles con los suyos. También son animales intrépidos y perseverantes. Aprenden con facilidad pero también pueden ser muy ladradores.",
        recomendacion:
          "Suelen tener un carácter fuerte, por lo que es importante tomar en serio la socialización desde que son cachorros. Esto permite evitar que en la edad adulta se conviertan en perros peleadores, agresivos o miedosos. Necesitan una buena dosis de ejercicio diaria y compañía frecuente.",
        ideal:
          "Es la versión en miniatura del schnauzer estándar y schnauzer gigante, por lo que es el compañero de vida perfecto para aquellas personas que adoran esta raza de perro pero no disponen del espacio necesario para criarlos. No muda pelo, por lo que es ideal para personas con alergias.",
        dato: "Años atrás se amputaba la cola y, lamentablemente, actualmente se puede seguir viendo esta tradición en muchos países.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 5,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/schnauzer-miniatura.html",
        n: "/img/razas/105.jpg",
      },
      {
        nombre1: "Schnauzer",
        nombre2: "",
        pais_origen: "Alemania",
        origen:
          "El origen de esta raza se encuentra en Alemania, donde el schnauzer acompañaba los carruajes, cuidaba los establos y mataba roedores y otras alimañas. Además, era muy apreciado como perro de compañía y para cuidar a los niños. A fines de los 1800, se presentó por primera vez a la raza en una exposición canina. Con el paso del tiempo se cruzó a esta raza con otras razas caninas para buscar las mismas cualidades en diferentes tamaños, y es así que el schnauzer dio origen al schnauzer gigante y al schnauzer miniatura.",
        caracteristica:
          "Tienen una personalidad fuerte y suelen ser muy seguros de ellos mismos, intrépidos y confiados, llegando muchos incluso a ser arrogantes. A pesar de esto, o quizás a causa de esto, su temperamento suele ser muy estable y son perros confiables y muy leales. Pueden ser reactivos con otros perros del mismo sexo, ser cazadores de animales pequeños y ser reservados con extraños.",
        recomendacion:
          "Es muy importante socializarlos desde cachorros para que su fuerte personalidad no cause problemas en el futuro.",
        ideal:
          "Son excelentes mascotas para personas solas y familias que disfrutan de actividad física moderada. También son excelentes mascotas para familias con niños grandes, ya que se llevan bien con ellos, pero no es la raza más adecuada para familias con niños muy pequeños. Pueden vivir muy bien en un departamento.",
        dato: "A diferencia de muchas otras razas de perros, el schnauzer tiende a ser un perro saludable sin enfermedades hereditarias. ",
        size: 2,
        vida: 3,
        deporte: 2,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/schnauzer-estandar.html",
        n: "/img/razas/183.jpg",
      },
      {
        nombre1: "Schnocker",
        nombre2: "",
        pais_origen: "Alemania",
        origen:
          "Es una raza mestiza de aparición reciente, pues existe desde hace menos de 10 años. No se han recogido ni el lugar ni la fecha exacta de aparición de los primeros ejemplares, pero se sabe que son mezcla de cocker spaniel y schnauzer miniatura.",
        caracteristica:
          "Presentan unas capacidades mentales brillantes: destacan por tener una increíble memoria y aprender a una velocidad de vértigo. Son una raza leal y que crea unos vínculos fuertes con los humanos con los que convive. Son tolerantes, pacientes y muy sociables, por lo que tienden a interactuar incluso con desconocidos.",
        recomendacion:
          "Que no nos engañe su carita de no haber roto un plato, pues se trata de una raza en la que es fundamental comenzar un educación temprano, de lo contrario pueden volverse realmente incontrolables. También les cuesta mucho pasar tiempo solos, pues sufren mucho ante la soledad, requieren atención y buscan cariño constantemente.",
        ideal:
          "Son una de las razas híbridas más recomendadas para personas que viven solas, pues al ser tan atentos y cariñosos brindan amor y compañía sin límites.",
        dato: "Destaca su tendencia a padecer todo tipo de alergias. Esto, combinado con su curiosidad por olfatear todo aquello que se le cruza, puede hacer que la alergia se complique.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/schnocker.html",
        n: "/img/razas/36.jpg",
      },
      {
        nombre1: "Schnoodle",
        nombre2: "",
        pais_origen: "?",
        origen:
          "Son  perros mestizos que provienen del cruce de perros de la raza schnauzer con caniches estándar. No se sabe a ciencia cierta el momento o lugar de origen.",
        caracteristica:
          "Se trata de unos perros increíblemente amistosos, que no dudan a la hora de demostrar su afecto hacia los que lo rodean. Son muy activos, por lo que les encanta jugar, saltar y correr a todas horas. Además son inteligentes y curiosos, lo que los hace unos aprendices excelentes. Tienen una curiosa ansia de complacer a su familia.",
        recomendacion:
          "Destaca la timidez de esta raza, por lo que se hace fundamental realizar una socialización temprana. Para eso lo mejor es exponerlos desde muy pequeños a diferentes entornos, así como a distintas personas y animales.",
        ideal:
          "Es una raza enérgica y vivaz. Esto, que para muchos es adorable, para otros puede resultar un inconveniente, por lo que hay que considerar que estos perros necesitan actividad física diaria.",
        dato: "Es considerados uno de los mejores perros para personas alérgicas (pierden poco pelo y no desarrollan caspa). Existen cinco tipos de schnoodle: gigante, estándar, mediano, miniatura y toy.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/schnoodle.html",
        n: "/img/razas/44.jpg",
      },
      {
        nombre1: "Scottish terrier",
        nombre2: "Terrier Escocés",
        pais_origen: "Escocia",
        origen:
          "Antiguamente todos los terrier de Escocia se dividían solamente en dos grupos, terrier de patas cortas y terrier de patas largas, por lo que todas las razas pequeñas se cruzaban entre sí. Esto es causa de gran confusión cuando se buscan los orígenes del Scottish terrier, y lo único que se sabe con certeza es que era empleado como perro cazador de alimañas en las tierras altas de Escocia. A fines del siglo XIX, sin embargo, se había hecho la distinción entre los diferentes perros terrier escoceses de patas cortas",
        caracteristica:
          "Son valientes y muy leales. Con los suyos tienden a ser muy amigables y juguetones, aunque son independientes y les gusta pasar una parte del día solos. Con los extraños tienden a ser desconfiados y no hacen amigos con facilidad, pero tampoco tienden a ser agresivos con la gente. Suelen ser agresivos con otros perros del mismo sexo y tienden a perseguir y matar animales pequeños. Son buenos para ladrar y el cavar en el jardín, aunque aprenden con facilidad si se les educa de buena forma.",
        recomendacion:
          "Desgraciadamente ésta es una de las razas de perros más propensa a los diferentes tipos de cáncer. Tiene predisposición a desarrollar cáncer de vejiga, intestinal, de estómago, cáncer de piel y de mama. Es muy importante que tenga una vida sana y que lo llevemos al veterinario con frecuencia.",
        ideal:
          "Son bastante independientes, y no es recomendable que los adopten personas poco cariñosas o que no necesiten estar en contacto continuo con sus mascotas, aunque eso no significa que podemos dejarlos solos durante un largo período de tiempo.",
        dato: "Entre la primera y la segunda guerra mundial esta raza ganó mucha popularidad, ya que se utilizó como perro de exposición y como mascota.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 2,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/scottish-terrier.html",
        n: "/img/razas/196.jpg",
      },
      {
        nombre1: "Setter Irlandés Rojo",
        nombre2: "",
        pais_origen: "Irlanda",
        origen:
          "En el siglo XVIII ya existía un tipo bien definido de setter irlandés rojo y blanco que era ampliamente usado para la caza de aves, pero fue recién a finales de ese siglo y principios del siglo XIX que se empezaron a criar setter enteramente rojos. En la actualidad cuando se habla de setter irlandés, generalmente se habla del rojo.",
        caracteristica:
          "Son alegres, independientes, muy sociables y curiosos. También son inteligentes y amables, con fuerte instinto cazador. Son fáciles de socializar, tanto con personas adultas, con niños, con otros perros e incluso con otras mascotas, ya que su agresión innata es baja.",
        recomendacion:
          "Necesitan mucho ejercicio diario. En caso de no recibirlo se frustran y fácilmente desarrollan hábitos de perros destructores. Aunque son perros independientes y necesitan correr al aire libre, también necesitan estar con su familia.",
        ideal:
          "Son excelentes mascotas para familias con niños o que ya tienen otras mascotas. Eso si, no se adaptan bien a vivir en un departamento o casa pequeña, ni en zonas urbanas muy pobladas en las que hay pocas áreas abiertas.",
        dato: "D ebido a su figura esbelta y su pelaje rojizo es considerado uno de los perros más hermosos y glamurosos del planeta. Es una de las razas más típicas de las exposiciones caninas.",
        size: 3,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/setter-irlandes-rojo.html",
        n: "/img/razas/186.jpg",
      },
      {
        nombre1: "Shar pei",
        nombre2: "",
        pais_origen: "China",
        origen:
          "El shar pei es un perro de origen asiático. Se estima que nació en el mar del sur de China durante la dinastía Hang, y sus antepasados son el mastín tibetano y el chow chow. También existen creencias de un posible origen tibetano. Durante buena parte de su existencia se utilizó básicamente como perro guardián, perro de pelea, perro de caza y como perro pastor.",
        caracteristica:
          "Es un perro calmado, tranquilo y muy leal. Afectuoso con sus familiares, a quienes cuida, respeta y protege ante todo. Es por lo general un perro relajado, obediente y algo independiente, que no necesita la atención constante como otras razas de perro.",
        recomendacion:
          "Necesita una alimentación rica y de calidad, ya que tiene el estómago muy sensible y es propicio a sufrir alergias. La comida basada en pescado y arroz proporcionan una mejor digestibilidad. Aunque esta raza agradece enormemente el calor del sol, debemos tomar precaución para evitar que se queme.",
        ideal: "",
        dato: "Se cree que es una de las razas chinas más antiguas que existen, y algunos especulan que data del 200 a.C.",
        size: 2,
        vida: 1,
        deporte: 2,
        intel: 3,
        clima: 4,
        child: "none",
        depa: "inline",
        antig: "inline",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/shar-pei.html",
        n: "/img/razas/208.jpg",
      },
      {
        nombre1: "Shiba Inu",
        nombre2: "",
        pais_origen: "Japón",
        origen:
          "Algunas fuentes aseguran que es originario de Corea o el Sur, aunque popularmente se le atribuye origen Japonés.  Se han hallado representaciones en ruinas del 500 dc. Su nombre significa literalmente “perro pequeño”.",
        caracteristica:
          "Es independiente y silencioso, aunque es un excelente perro vigilante que disfrutará patrullando el terreno de la casa y avisándonos de la presencia de extraños. Suele apegarse a los dueños, a quienes muestra mucha lealtad y cariño. Es algo tímido con los desconocidos, nervioso, juguetón y un poco travieso. Es especialmente limpio, muy parecido a un gato, pudiendo llegar a dedicar horas a acicalarse y dejándose cepillar por sus familiares.",
        recomendacion:
          "Hay que dedicar tiempo al proceso de socialización para disfrutar de un perro sociable y sin miedos.",
        ideal:
          "Es afectuosa con sus dueños y muy adaptable a distintos ambientes y familias.",
        dato: "El perro más longevo del mundo tenía 26 años y era un Shiba Inu que vivía en Japón.",
        size: 1,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 1,
        child: "none",
        depa: "inline",
        antig: "inline",
        salud: "inline",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/shiba-inu.html",
        n: "/img/razas/209.jpg",
      },
      {
        nombre1: "Shih tzu",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Es originario de los monasterios budistas, donde era considerado un perro sagrado. Cuando los primeros shih tzu llegaron a Inglaterra, en la década de los  30, eran confundidos con los Lhasa apso (se consideraba a ambos perros como una sola raza). En la misma década se decidió separar a ambas razas tal como las conocemos actualmente.",
        caracteristica:
          "Son muy sociables y alegres. Así como existe la gente de perros, se dice que los shih tzu son perros de gente, porque les encanta estar con personas (es más fácil socializar a los shih tzu que a otras razas de perros). También son juguetones y activos cuando se los mantiene en forma. Aprenden con facilidad y rapidez.",
        recomendacion:
          "Su pelo tiende a enredarse con facilidad y es necesario cepillarlo y peinarlo frecuentemente. Tienden a subir de peso con facilidad, por lo que es bueno brindarles ejercicio suficiente para mantenerlos en forma.",
        ideal:
          "Son excelentes mascotas para personas solas, parejas y familias con niños de diferentes edades. Tambipen son buenas mascotas para propietarios novatos. Sin embargo, no son recomendados para familias y personas que pasan la mayor parte del día fuera de casa, a menos que puedan llevarse a sus perros al trabajo.",
        dato: "Fue un perro exclusivo de la nobleza china, donde también se lo tenía como un perro sagrado y se le daban cuidados dignos de la realeza.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 1,
        clima: 3,
        child: "none",
        depa: "inline",
        antig: "inline",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/shih-tzu.html",
        n: "/img/razas/195.jpg",
      },
      {
        nombre1: "Shih-Poo",
        nombre2: "",
        pais_origen: "China",
        origen:
          "El nombre de shih-poo proviene de la combinación de los nombres de las dos razas padres. “Shih” viene del shih tzu y “poo” del caniche (poodle). Lamentablemente se desconoce el momento exacto en el que esta raza híbrida se originó.",
        caracteristica:
          "Destaca notablemente por todas sus bondades. Por una parte, se trata de un perro muy alegre, cariñoso y muy sensible. Por otra, es un can inquieto, que puede ser algo travieso e increíblemente juguetón. Destaca su necesidad de compañía, pues estamos ante un perro que no lleva nada bien la soledad, y tienen bastante predisposición a ser ladradores.",
        recomendacion:
          "Una soledad prolongada puede causarle alteraciones como ansiedad por separación o dificultades para socializar. Este rasgo lo hereda tanto del shih tzu como del caniche.",
        ideal:
          "Es una raza ideal para familias, ya que adora jugar, sobre todo con niños. Es fundamental, sin embargo, que tanto los niños como el perro estén bien educados para tratarse con respeto y que no haya sustos ni ninguno salga dañado.",
        dato: "No se ha expandido aún por muchas regiones y, por ende, no cuenta con un número de ejemplares exacto ni con los estudios necesarios para establecer una media en cuanto a su tamaño y peso. Su cuerpo es sumamente proporcionado, de manera que no pierde el equilibrio casi nunca.",
        size: 1,
        vida: 4,
        deporte: 2,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/shih-poo.html",
        n: "/img/razas/37.jpg",
      },
      {
        nombre1: "Shikoku Inu",
        nombre2: "",
        pais_origen: "Japón",
        origen:
          "Se origina en la región montañosa de Kochi, Japón, motivo por el que al principio su nombre era kochi ken (perro de Kochi).  En los comienzos existían tres variedades de esta raza: hata, awa y hongawa. Los awa no tuvieron muy buen destino, pues desaparecieron por completo durante la Segunda Guerra Mundial, mientras que las otras dos variedades siguen existiendo hasta el día de hoy.",
        caracteristica:
          "Tiene carácter fuerte, independiente y muy benévolo. Se trata de una raza entrenada desde hace siglos para la caza y la vigilancia, por lo que tiene una increíble capacidad de atención y una alerta continua. Es, además, un perro muy astuto y activo. No confía en las personas desconocidas, pudiendo responder de forma agresiva ante cualquier “ataque” o algo que considere un ataque a su familia.",
        recomendacion:
          "El pelaje denso y bicapa del shikoku necesita al menos 2-3 cepillados semanales, solo así se puede asegurar que se esté eliminando correctamente la acumulación de pelo muerto, polvo y cualquier tipo de suciedad. Estos perros necesitan ejercitarse cada día, siendo aconsejable que la actividad sea de moderada a intensa, para mantenerlos equilibrados y saludables.",
        ideal:
          "Es muy muy activo y rebosa de energía, por lo que no es recomendado para personas mayores o de vida sedentaria, así como para departamentos pequeños. Equilibra perfectamente el acompañar a los miembros de la familia a lo largo del día en sus actividades, pero sin resultar intrusivo. ",
        dato: "Son algunas de las razas caninas más antiguas del mundo. Únicamente se suele encontrar en determinadas regiones de Japóndonde que fue declarada como monumento nacional en 1937.",
        size: 2,
        vida: 2,
        deporte: 3,
        intel: 4,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/shikoku-inu.html",
        n: "/img/razas/22.jpg",
      },
      {
        nombre1: "Shorkie",
        nombre2: "",
        pais_origen: "USA",
        origen:
          "Surgen a comienzos del siglo XXI en Estados Unidos, donde criadores de diseño decidieron hacer cruces controlados entre dos emblemáticas razas: el yorkshire terrier y el shih tzu.",
        caracteristica:
          "Tienen un potente carácter y al parecer no es conciente de su tamaño. Son tremendamentes impulsivos y no suelen meditar mucho lo que hacen, lo cual puede meterlos en problemas con cierta facilidad, pues no ven los peligros a tiempo. Son muy enérgicos, buscando siempre juego con todo lo que vean en movimiento y deseando atenciones de su familia humana. Pueden llegar a ser muy ladradores, igual que los yorkshires, sobre todo ante ruidos, visitas o desconocidos, ya que son algo desconfiados con los que no conoce.",
        recomendacion:
          "Los premios con golosinas o comida suelen funcionar muy bien para entrenarlo. Eso si necesitan realizar bastante ejercicio a diario, algo muy importante para mantenerlos con un peso adecuado (tienen tendencia a ganar mucho peso porque son bastante glotones y ansiosos con la comida).",
        ideal:
          "No son los más adecuados para personas que no dispongan de tiempo para educarlo y acompañarlo.",
        dato: "Cuando son cachorros apenas llegan al kilo de peso, mientras que un shorkie adulto apenas pesa entre 3 y los 6 kilos.",
        size: 1,
        vida: 2,
        deporte: 2,
        intel: 4,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/shorkie.html",
        n: "/img/razas/26.jpg",
      },
      {
        nombre1: "Skye Terrier",
        nombre2: "",
        pais_origen: "Escocia",
        origen:
          "Esta raza parece ser una de las más antiguas de todas las razas de terrier, y ya se describieron perros de esta raza en el siglo XVI. Fue criado para cazar animales de madriguera. El nombre de esta raza deriva de su lugar de origen: la isla de Skye, cerca de la costa escocesa.",
        caracteristica:
          "Es de carácter tenaz y valiente. Son perros muy leales y afectuosos con los suyos, pero tienden a ser más afectuosos con una sola persona, por lo que se los considera perros de un solo dueño. No demandan mucho ejercicio, por lo que es perfecto para personas menos activas.",
        recomendacion:
          "Es muy importante iniciar pronto la socialización, porque de adultos tienden a ser desconfiados con desconocidos e incluso pueden ser agresivos. Necesitan mucha compañía y no basta con verlos de cuando en cuando, porque no soportan bien los largos períodos de soledad y necesitan estar con su familia el mayor tiempo posible.",
        ideal:
          "Pueden ser excelentes mascotas para personas mayores o para jóvenes que no tienen hijos. Eso sí, los propietarios deben disponer de mucho tiempo para estar junto a sus mascotas o deben poder llevarlo al trabajo para que no se queden solos. Estos perros no son buenas mascotas para familias con niños, porque tienden a morder cuando son molestados o cuando se sienten amenazados. Se adaptan muy bien para vivir en un departamento pequeño.",
        dato: "En 1840 la raza ganó popularidad entre la aristocracia del Reino Unido, debido a la afición de la reina Victoria por estos perros.",
        size: 1,
        vida: 3,
        deporte: 1,
        intel: 2,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/skye-terrier.html",
        n: "/img/razas/160.jpg",
      },
      {
        nombre1: "Sloughi",
        nombre2: "Lebrel Árabe",
        pais_origen: "Egipto",
        origen:
          "Procedentes del continente africano, acompañaron a la realeza bereber y a los faraones egipcios, siendo unos compañeros desde tiempos muy lejanos. Aunque no se conocen sus orígenes exactos ni su genealogía, se cree que pueden estar emparentados con los lebreles de Nubia. Diferentes hallazgos arqueológicos, como tablillas o bajo relieves, parecen señalar que los sloughis son una raza realmente antigua, contando con más de 2000 años de antigüedad.",
        caracteristica:
          "Tiene una indudable lealtad, puesto que permanecerá al lado de sus familiares pase lo que pase y será un excelente perro guardián. Esto contrasta severamente con su carácter miedoso, el cual es capaz de superar si ha de proteger a los suyos. Es, por ello, un perro bastante desconfiado con los extraños, inteligente y de muy buena salud.",
        recomendacion:
          "Es muy activo, por lo que es necesario estimularlo con juegos y actividades que permitan que realice suficiente ejercicio diario. No es recomendable tenerlo encerrado en un espacio pequeño, como un departamento, si es que no podemos asegurarnos de que realizará ejercicio intenso cada día. Un cuidado esencial será controlar el crecimiento de sus uñas, cortándolas periódicamente, porque crecen más rápido de lo que lo hacen en la mayoría de las razas caninas. ",
        ideal: "",
        dato: "No presentan enfermedades asociadas a la raza, y no tienen especial predisposición genética a sufrir ninguna enfermedad en particular.",
        size: 3,
        vida: 4,
        deporte: 4,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/sloughi-o-lebrel-arabe.html",
        n: "/img/razas/71.jpg",
      },
      {
        nombre1: "Soft Coated Wheaten Terrier Irlandés",
        nombre2: "Wheaten Terrier",
        pais_origen: "Irlanda",
        origen:
          "Aunque no se tiene un registro preciso del desarrollo de la raza, se sabe que este terrier se originó en las zonas rurales de Irlanda. Cumplía las mismas funciones que otros terrier, cazando animales de madriguera, pero también era usado como perro pastor y cobrador. La traducción al castellano del nombre sería terrier irlandés de suave manto trigo.",
        caracteristica:
          "Tienden a ser más sociables y menos agresivos que la mayoría de los terrier. Con las personas tienden a ser más amigables y suelen llevarse bien con niños. Sus grandes ventajas son que pierden muy poco pelo (se consideran perros hipoalergénicos), su educación es relativamente fácil y aprende muy rápidamente.",
        recomendacion:
          "No hay que olvidar que siguen siendo perros terrier y que, además de su gran energía, es necesario socializarlos muy bien desde cachorros. Bien socializados pueden llevarse bien con otros animales, pero siempre hay que tener algún cuidado para evitar peleas entre perros del mismo sexo. ",
        ideal: "Suelen adaptarse mejor a la vida en la ciudad.",
        dato: "Es uno de los terrier más grandes. Aunque es una raza antigua, permaneció sin reconocimiento oficial por muchos años hasta que fue reconocida en Irlanda en los años  30.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/soft-coated-wheaten-terrier-irlandes.html",
        n: "/img/razas/180.jpg",
      },
      {
        nombre1: "Spaniel Bretón",
        nombre2: "Epagneul Bretón",
        pais_origen: "Francia",
        origen:
          "La raza surgió del cruce de diferentes razas de spaniels, como setters o springers ingleses. Existen pruebas de que la primera camada nació en la década de los  90. El nacimiento fue en Fougères, una localidad francesa, más concretamente en la casa del vizconde francés Du Pontavice, gran criador de setters y amante de la caza.",
        caracteristica:
          "Es atento y perspicaz, lo que hace notablemente fácil su educación y entrenamiento. También es una raza muy apegada, que adora pasar tiempo con sus familiares y recibir atención y cariño, mostrándose muy tierna y sociable. Gracias a su gran capacidad e inteligencia, su educación será sencilla.",
        recomendacion:
          "Es un perro muy activo que necesita liberar energía de forma diaria.",
        ideal:
          "Su carácter destaca por ser muy flexible, es decir, que se adapta sin problemas a todo tipo de ambientes y familias. Es capaz de desarrollarse perfectamente tanto en un medio rural como en el núcleo urbano.",
        dato: "Al principio la raza se denominaba spaniel bretón de cola corta, pero el calificativo que hace referencia a la longitud de la cola acabó perdiéndose, quedando reducido a spaniel bretón. ",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/spaniel-breton.html",
        n: "/img/razas/73.jpg",
      },
      {
        nombre1: "Spitz alemán",
        nombre2: "",
        pais_origen: "Alemania",
        origen:
          "Los orígenes del spitz alemán no están muy definidos, pero la teoría más común señala que esta raza de perros desciende de los perros de la tundra de la Edad de Piedra, siendo así la raza de perros más antigua de Europa Central. La expansión de la raza en el mundo occidental se hizo gracias a que llegaron a Gran Bretaña en el bagaje de la reina Charlote, la mujer de George III de Inglaterra.",
        caracteristica:
          "Estos perros son alegres, alertas, dinámicos y muy apegados a sus familias humanas. También son reservados con los extraños y ladradores, por lo que pueden ser buenos guardianes, aunque no son buenos perros de protección. Pueden tolerar de buena gana a perros desconocidos y personas extrañas, pero pueden ser conflictivos con perros del mismo sexo. Con otras mascotas de la casa suelen llevarse muy bien.",
        recomendacion:
          "Pueden adaptarse bien a la vida en departamentos. Toleran muy bien los climas fríos a templados, pero no el calor.",
        ideal:
          "No suelen ser buenos perros para niños muy pequeños, pero son buenos compañeros de niños grandes que saben cuidar y respetar a un perro.",
        dato: "Tienen cinco razas separadas que la Federación Cinológica Internacional (FCI) agrupa bajo un solo estándar (tipo lobo, grande, mediano, chico y enano). Todas estas razas son iguales excepto por el tamaño.",
        size: 2,
        vida: 3,
        deporte: 1,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/spitz-aleman.html",
        n: "/img/razas/191.jpg",
      },
      {
        nombre1: "Spitz Finlandés",
        nombre2: "Suomenpystykorva",
        pais_origen: "Finlandia",
        origen:
          "Fueron empleados tradicionalmente como perros cazadores en diversos países nórdicos como Finlandia o Suecia.  Se desconocen los ancestros, aunque los investigadores dicen que comparten gran carga genética con los lobos salvajes.  Comenzaron a tener un registro oficial en el año 1890.",
        caracteristica:
          "Destaca por ser sociable y por mostrarse muy alegre y cariñoso con la gente. Incluso con los extraños es agradable, lo que no lo hace un buen perro guardián. Es muy equilibrado, con altas dosis de valentía y determinación. Sueleser un poco independiente pero demostrar cariño.",
        recomendacion:
          "No le gusta la soledad, pero sí que le dejemos su espacio para ser independiente. Es sumamente activo, por lo que tenemos que asegurarnos de que se ejercite lo suficiente y de que no se aburra cuando no estamos. La piel de estos perros es bastante sensible, debemos cuidarla y estar atentos por si aparecen puntos rojos o picazones.",
        ideal:
          "Es ideal para convivir con niños, ya que es paciente, muy atento y juguetón.",
        dato: "Es el más sociable y enérgico de todas las razas de perros nórdicas. Bajo el estándar de la raza se recogen las que antes se distinguían como dos razas independientes: el karelian-finnish laika y el spitz finlandés. Ambas razas se unificaron en el spitz finlandés en el año 2006.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 3,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "inline",
        salud: "inline",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/spitz-finlandes-suomenpystykorva.html",
        n: "/img/razas/64.jpg",
      },
      {
        nombre1: "Springer Spaniel Inglés",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "El nombre Spaniel dice que la raza es proveniente de España, pero sus orígenes se remontan al siglo XVI en Inglaterra, cuando sus antecesores eran compañeros de caza y se los usaba para atrapar a las presas, hacerlas salir y saltar de sus escondites (de allí el nombre springer, del inglés que significa hacer saltar). Su antiguo nombre era norfolk spaniel, ya que provenían de Norfolk, Inglaterra.",
        caracteristica:
          "Es una raza muy amistosa y sociable, llevándose muy bien con los niños y otros perros. Siempre está muy atento a lo que ocurre en su entorno porque antiguamente se usaba para cazar. Es un perro muy inteligente y les encanta meterse en el agua.",
        recomendacion:
          "Necesita hacer mucho ejercicio físico. Es muy importante la sociabilización cuando cachorro ya que se llevan muy bien con los niños, por lo que si crecen juntos puede llegar a ser un excelente compañero y fiel protector.",
        ideal: "",
        dato: "Es una raza cuyo origen se remonta hace varios siglos atrás, y que ha permanecido practicamente invariable.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/springel-spaniel-ingles.html",
        n: "/img/razas/5.jpg",
      },
      {
        nombre1: "Staffordshire Bull Terrier",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "La historia de esta raza está íntimamente ligada a la historia del pit bull terrier y a la de otros terrier tipo bull. El staffordshire bull terrier deriva de los extintos bull and terrier británicos que eran empleados para pelear con toros.",
        caracteristica:
          "Alegre y positivo, es un perro perfecto para familias activas. Suele ser muy amigable con las personas y particularmente con los niños, a quienes adora y protege. Siempre están felices y demostrando cariño, obedeciendo las ordenes y siendo muy atento a su familia.",
        recomendacion: "Necesita hacer mucho ejercicio diario.",
        ideal: "",
        dato: "De entre todas las razas de perros, esta es la única en cuyo estándar se indica que debe ser completamente confiable. Por supuesto, eso no significa que todos los staffies son completamente confiables, sino que eso es a lo que apunta el ideal de la raza.",
        size: 2,
        vida: 3,
        deporte: 4,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/staffordshire-bull-terrier.html",
        n: "/img/razas/154.jpg",
      },
      {
        nombre1: "Staffordshire Terrier Americano",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "El amstaff tiene sus orígenes en aquellos perros que ayudaban a los carniceros británicos a controlar y abatir a los toros más peligrosos. Posteriormente, los ancestros de estos perros fueron usados en actividades que hoy en día se consideran ilegales en gran parte del mundo (peleas con toros y peleas de perros). Posteriormente, el amstaff se separó oficialmente del pitbull y su cría se desarrolló de forma separada. Sin embargo, durante mucho tiempo los perros de esta raza fueron registrados por partida doble, como american Staffordshire terrier.",
        caracteristica:
          "Es un perro alegre, confiado, curioso y amigable con la gente. A pesar de la mala prensa que reciben todas las razas del tipo bull, el amstaff suele ser un perro muy sociable y especialmente extrovertido. Incluso es encantador y afectuoso, muy tierno y amable con su familia.",
        recomendacion:
          "Es un perro que se aburre con cierta facilidad si se encuentra solo, llegando a sufrir ansiedad por separación. Recomendamos que le dejes a su disposición juguetes, ya que fomentarás su diversión y estimularás su mente. Es importante el ejercicio regular.",
        ideal: "Se llevará de maravilla con niños pequeños.",
        dato: "Un perro de esta raza se hizo famoso en la segunda guerra mundial: Stubby fue el único perro nombrado sargento por el ejército de EEUU, debido a su labor manteniendo cautivo a un espía alemán hasta la llegada de las tropas norteamericanas. También fue Stubby quién activó la alarma por un ataque de gas.",
        size: 2,
        vida: 3,
        deporte: 3,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/staffordshire-terrier-americano.html",
        n: "/img/razas/172.jpg",
      },
      {
        nombre1: "Teddy Roosevelt Terrier",
        nombre2: "",
        pais_origen: "USA",
        origen:
          "Surge en Estados Unidos en honor al presidente norteamericano Theodore Roosevelt. Se supone que esta mención honorífica se hizo no porque él tuviera un teddy roosevelt como compañero, sino porque compartía su vida con un un terrier ratonero de raza mixta y manto negro y marrón, que supuestamente fue uno de los precursores de la raza teddy roosevelt terrier. Fue reconocida por el American Kennel Club (AKC) como raza oficial en julio de 2019.",
        caracteristica:
          "Agradable, tranquilo y muy leales, adoran la compañía tanto de las personas como de otros animales y son muy protectores (que pese a su escaso tamaño no dudan en enfrentarse a cualquier cosa para proteger a su familia). Son buenos perros guardianes y sumamente adaptativos, ya que se adapta con mucha facilidad a diferentes entornos, ya se una casa de campo, una granja o un departamento en la ciudad.",
        recomendacion:
          "Necesitan realizar cierta cantidad de ejercicio físico de forma diaria, ya que son perros muy activos que si no hacen ejercicio a diario se vuelven inquietos y nerviosos. Esta raza parece ser más sensible ante las alergias, ya sean ambientales o hacia determinadas sustancias como medicamentos o alimentos.",
        ideal: "",
        dato: "Es una de las razas más nuevas del mundo, y la única llamada debido a un presidente.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 5,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/teddy-roosevelt-terrier.html",
        n: "/img/razas/31.jpg",
      },
      {
        nombre1: "Terrier Australiano",
        nombre2: "Australian Terrier",
        pais_origen: "Tasmania",
        origen:
          "Este terrier nació en la isla australiana de Tasmania, a partir de cruces entre diferentes perros terrier que habían sido llevados desde Europa. Entre las razas que se piensa dieron origen al terrier australiano, se encuentran: Dandie Dinmont terrier, Yorkshire terrier, Skye terrier y Manchester terrier.",
        caracteristica:
          "Es un perro pequeño pero rudo y resistente, capaz de cazar roedores y serpientes y de dar la alarma ante la presencia de extraños. Es un terrier de trabajo, y por eso tiene un temperamento valiente y decidido. Sin embargo, es más estable y tranquilo que la mayoría de los demás terrier y también es un excelente perro de compañía. Puede ser agresivo con perros del mismo sexo y con animales pequeños, pero no tiene tanta tendencia a la agresión como otras razas de terrier. Es uno de los terrier más fáciles de adiestrar, ya que no es tan hiperactivo como otros y es bastante inteligente. Una desventaja son sus los ladridos excesivos y la tendencia a cavar en el jardín.",
        recomendacion:
          "Necesita mucha compañía de su familia. Es importante socializar al perro desde que es un cachorro con la gente, con perros y con otros animales, desde temprana edad.",
        ideal:
          "Debido a su tamaño y a la poca actividad física que necesitan, estos perros son excelentes mascotas para niños un poco mayores, ya que pueden vivir en una casa o departamento pequeño perfectamente y son muy familiares con los suyos.",
        dato: "Tiene mezcla de tantas razas que dio lugar a una buena genética, lo que podría explicar la poca frecuencia de enfermedades hereditarias que tiene.",
        size: 1,
        vida: 3,
        deporte: 1,
        intel: 4,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/terrier-australiano.html",
        n: "/img/razas/181.jpg",
      },
      {
        nombre1: "Terrier Negro Ruso",
        nombre2: "Tchiorny Terrier",
        pais_origen: "Rusia",
        origen:
          "En la década de los  40, las fuerzas armadas soviéticas decidieron crear una raza de perros de trabajo muy versátiles, capaces de responder bien en diferentes condiciones y dispuestos a defender a los suyos en cualquier circunstancia. Para ésto cruzaron el schnauzer gigante, el airedale terrier y el rottweiler, dando origen al terrier negro ruso.",
        caracteristica:
          "Enérgicos, desconfiados con los extraños y agresivos. Son excelentes perros guardianes, tanto por su gran físico como por su carácter asertivo y valiente. Con su familia, y especialmente con niños, tienden a ser excelentes mascotas y muy amigables.",
        recomendacion:
          "Es muy importante socializar a temprana edad a estos perros, porque tienden a ser desconfiados y agresivos con los extraños. Aunque son perros de trabajo, no son perros de canil y sufren mucho cuando se quedan solos por mucho tiempo.",
        ideal:
          "Pueden causar problemas a los propietarios inexpertos. No se adaptan bien a la vida en ciudades grandes y densamente pobladas, a menos que su propietario sea un conocedor de perros de protección.",
        dato: "En realidad no pertenecen al grupo de los terrier. Llevan su nombre por la participación del airedale en la creación de la raza, pero son perros de trabajo tipo schnauzer.",
        size: 3,
        vida: 2,
        deporte: 3,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/terrier-negro-ruso.html",
        n: "/img/razas/119.jpg",
      },
      {
        nombre1: "Terrier Tibetano",
        nombre2: "",
        pais_origen: "China",
        origen:
          "Provienen de la región del Tíbet (China). Allí estos perros servían en los monasterios como animales guardianes, a la par que acompañaba a los monjes y guiaban a sus rebaños.  Sus orígenes se remontan más de 2.000 años atrás, y se dice que surgieron cuando los tibetanos decidieron separar a los perros grandes (de los cuales descendieron los actuales dogos del Tíbet) y los pequeños.",
        caracteristica:
          "A pesar de estar dentro de la categoría de los terrier, esta raza se diferencia de sus congéneres en que presenta un carácter mucho más dulce y dócil. Adora jugar y pasar tiempo con los suyos, aunque desconfía de los desconocidos. Son tenaces, muy valientes y fáciles de educar.",
        recomendacion:
          "Si va a convivir con niños, debemos acostumbrarlos a ambos a convivir y a relacionarse de forma respetuosa.Debemos educar a nuestro terrier desde pequeño y conseguir que la socialización sea plena y satisfactoria. Son animales sociables, que no toleran bien la soledad, ya que necesitan cariño y atención constantes.",
        ideal: "",
        dato: "La raza llegó a Europa en la década de 1920, a raíz de que una doctora (Agnes Grey) atendiera a unos locales que lo llevaban como mascota. Tras recibir su atención médica, ellos le regalaron a uno de los cachorros, que pasó a formar parte de un programa de cría y posteriormente viajó con su dueña a Inglaterra en 1922.",
        size: 2,
        vida: 3,
        deporte: 2,
        intel: 2,
        clima: 1,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/terrier-tibetano.html",
        n: "/img/razas/86.jpg",
      },
      {
        nombre1: "Thai Ridgeback",
        nombre2: "",
        pais_origen: "Tailandia",
        origen:
          "Se ha originado en Tailandia, más precisamente en la parte Este de su territorio. Si bien los primeros registros escritos sobre su existencia datan de hace unos 360 años, se estima que estos perros son mucho más antiguos. Al principio fueron entrenados para la caza de diferentes animales (serpientes hasta jabalíes y chanchos salvajes). ",
        caracteristica:
          "Se trata de un can vigoroso, activo y muy versátil. Se puede adaptar fácilmente al desempeño de diversas actividades y tareas, mostrando una excelente predisposición al trabajo y al entrenamiento. Tienen gran energía y necesitan contar con una rutina adecuada de actividad física para gastarla de forma positiva y conservar un comportamiento equilibrado en su hogar. Cuando son sometidos a un estilo de vida sedentario, pueden mostrarse algo nerviosos e inquietos, llegando a desarrollar problemas de comportamiento. Son muy leales a sus tutores y poseen una excelente salud.",
        recomendacion:
          "Son perros independientes que necesitarán tener sus momentos de paz y tranquilidad, en especial mientras duermen y se alimentan. Son un poco desconfiados con los extraños, y necesitan ser socializados desde cachorros para aprender a relacionarse de forma positiva con otros animales, personas y estímulos de su entorno. Para gastar su elevada energía, estos perros necesitan practicar ejercicios a diario.",
        ideal: "",
        dato: "Los escasos medios de comunicación y transporte disponibles en la zona este de Tailandia han provocado que estos perros permanecieran aislados durante más de tres siglos. De hecho, hace menos de dos décadas que han empezado a darse a conocer en el Occidente. Por eso siguen manteniendo características casi iguales a aquellas descritas en los primeros escritos sobre su existencia.",
        size: 2,
        vida: 3,
        deporte: 4,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/thai-ridgeback.html",
        n: "/img/razas/58.jpg",
      },
      {
        nombre1: "Tosa Inu",
        nombre2: "Tosa Japonés",
        pais_origen: "Japón",
        origen:
          "Tiene su origen en la antigua provincia japonesa de Tosa, actual prefectura de Kochi, como raza de pelea. En ese país, las peleas de perros tienen una larga historia que data del siglo XIV, y forman parte de la cultura de algunas provincias. Para desarrollar la raza tosa Inu, se llevaron a cabo diversos cruces entre el perro japonés Shikoku-ken y seis razas occidentales: bulldog inglés, mastín inglés, pointer, gran danés, san bernardo y bullterrier.",
        caracteristica:
          "Paciente, audaz y de gran valor. Se trata de un perro muy leal a la familia, muy seguro de si mismo y de la capacidad física que sobresale. Suelen ser algo tímidos y desconfiados con quienes no conoce, a los que apenas les hará caso, pero es muy entregado a quienes le traten con afecto y cariño. Con otros perros suele llevarse muy bien.",
        recomendacion:
          "Es un perro de gran tamaño que puede lastimar sin querer a alguien cuando juega, y es muy recomendable supervisarlo siempre y educar a los niños para que comprendan cómo deben tratarlo. Es recomendable que la adopción se lleve a cabo por una persona experimentada y conocedora de la raza. La parte más importante de su educación será sin duda la socialización, que debe empezar de forma pronta para evitar conductas no deseables.",
        ideal:
          "Tiene un instinto natural de protección y un temperamento tranquilo y relajado dentro del hogar, calzando perfectamente con los más pequeños, a quienes soportará sus travesuras y tirones de oreja. Puede adaptarse a vivir en un departamento si se le proporcionan los cuidados y el ejercicio suficiente.",
        dato: "Es un perro considerado como potencialmente peligroso en España y otros países. Antes de adoptarlo deberás consultar la ley y la normativa aplicable de tu país.",
        size: 3,
        vida: 2,
        deporte: 2,
        intel: 3,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/tosa-inu.html",
        n: "/img/razas/173.jpg",
      },
      {
        nombre1: "Weimaraner ",
        nombre2: "Braco de Weimar",
        pais_origen: "Alemania",
        origen:
          "Aunque se muestran perros similares en pinturas y grabados anteriores a 1800, la historia de la raza anterior al siglo XIX es desconocida. En el siglo XIX el Gran Duque Carlos Augusto gobernó el ducado de Sajonia-Weimar-Eisenach, en territorio que hoy día forma parte de Alemania. Tan fuerte fue la impresión que causaron esos perros grises y robustos sobre el Gran Duque que decidió desarrollar una raza de perros muy versátiles para la caza. Además, decretó que estos perros solamente podían ser criados por la nobleza.",
        caracteristica:
          "Es dinámico, curioso, inteligente y leal. Si decidimos adoptar un perro de esta raza, nos sorprenderá su carácter dulce y entregado así como su paciencia y bondad.",
        recomendacion:
          "Es tímido con los extraños, especialmente si no trabajamos adecuadamente la socialización. Si no recibe suficiente ejercicio físico y mental, además de mucha compañía, puede volverse ladrador y destructivo.",
        ideal:
          "Precisamente por su carácter tan positivo, es una de las razas más recomendadas para familias con niños mayores, familias jóvenes y personas con un ritmo de vida activo y estimulante. Eso no significa que no sean perros apropiados para convivir con niños pequeños, pero en este caso será recomendable supervisar siempre a ambos miembros de la familia, para evitar que la brusquedad de movimientos del weimaraner pueda lastimar sin querer a los pequeños. No es una raza apropiada para personas sedentarias.",
        dato: "Su rasgo más característico es el pelaje grisáceo, que le hace realmente inconfundible (es apodado como el fantasma gris). La variedad más conocida de esta raza es la de pelo corto, pero también existen bracos de Weimar de pelo largo.",
        size: 3,
        vida: 2,
        deporte: 4,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/weimaraner-o-braco-de-weimar.html",
        n: "/img/razas/156.jpg",
      },
      {
        nombre1: "Welsh Corgi Cardigan",
        nombre2: "",
        pais_origen: "Gales",
        origen:
          "Se desconoce su origen. Se acepta que se desarrolló en gran medida en el condado galés de Cardiganshire, de donde obtiene el nombre. Inicialmente estos perros se usaban como guardianes, tanto de propiedades como de rebaños y ganado vacuno. Sin embargo, cuando los pastores galeses se dieron cuenta de la habilidad de los perros para dirigir al rebaño, empezaron a utilizarlos como perros pastores y boyeros.",
        caracteristica:
          "Son activos, inteligentes y alertas. Se destacan por tener un temperamento estable, sin ser tímidos ni agresivos (a veces pueden ser agresivos con otros perros). Sus fuertes instintos de pastoreo los llevan a ser muy ladradores.",
        recomendacion:
          "Como la mayoría de los perros pastores, necesitan mucha estimulación física y mental, así como compañía frecuente. La socialización temprana es muy importante para evitar que sean agresivos o enojones con las personas. ",
        ideal:
          "Necesitan mucha compañía y es mejor que vivan dentro de la casa, aún cuando resisten bien climas templados o fríos.",
        dato: "Es una de las razas más antiguas de Gran Bretaña.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/welsh-corgi-cardigan.html",
        n: "/img/razas/118.jpg",
      },
      {
        nombre1: "Welsh Corgi Pembroke",
        nombre2: "",
        pais_origen: "Gales",
        origen:
          "Los ancestros comunes del corgi galés de Pembroke y del cardigan eran empleados en el sur de Gales como guardianes, pastores y boyeros. Sin embargo, la raza cardigan se desarrolló en el condado de Cardiganshire, mientras que los Pembroke se desarrollaron en el condado galés de Pembrokeshire, de donde la raza obtiene el nombre.",
        caracteristica:
          "Son activos, inteligentes y guardianes. Suelen ser amistosos y muy leales con su familia, pero no están entre las razas de perros más sociables porque tienden a ser reservados con los extraños y agresivos con perros desconocidos. Además, tienen ladridos excesivos y una tendencia a empujar a las personas mordiéndoles los tobillos.",
        recomendacion:
          "Necesitan recibir adiestramiento canino. Esto no es algo opcional con estos perros, ya que demandan mucha estimulación mental. Es muy importante socializarlos desde temprana edad para así evitar problemas de agresión y timidez.",
        ideal:
          "Si reciben suficiente ejercicio, estos perros pueden adaptarse muy bien a la vida en departamento o casa pequeña, pero hay que tomar en cuenta que pueden ser ladradores.",
        dato: "Su atractiva apariencia, y la afición de la reina Elizabeth II por la raza, han hecho que estos canes pasen de ser de humildes pastores a miembros de la realeza.",
        size: 1,
        vida: 3,
        deporte: 2,
        intel: 5,
        clima: 2,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/welsh-corgi-pembroke.html",
        n: "/img/razas/122.jpg",
      },
      {
        nombre1: "West Highland White Terrier",
        nombre2: "Westy",
        pais_origen: "Escocia",
        origen:
          "Se originó en las tierras altas del oeste de Escocia, originalmente como perros para la caza del zorro y el tejón. Se dice que el coronel Edward Donald Malcolm decidió criar solamente los perros blancos después de que uno de sus perros de color rojo falleció porque lo confundieron con un zorro al salir de la madriguera (si la leyenda es cierta, esa sería la razón por la que el westie es un perro blanco). De hecho, la traducción literal de su nombre es terrier blanco de las tierras altas del oeste.",
        caracteristica:
          "Valiente, pícaro, muy seguro de sí mismo y dinámico, el westie es quizás el más afectuoso y sociable de los perros terrier. Suele relacionarse perfectamente con otros perros gracias a su temperamento equilibrado y simpático. Tiene una fuerte personalidad y es que es muy decidido y valiente, a pesar de su pequeño tamaño.",
        recomendacion:
          "No es un perro que necesita grandes dosis de ejercicio, y con un paseo diario será suficiente para tenerlo feliz y sano. Son especialmente vulnerables a sufrir osteopatia craniomandibular, una enfermedad que consiste en el crecimiento anormal de la mandíbula. Suele aparecer sobre los 3-6 meses de edad del cachorro y desaparece a los 12, por lo que es importante ir al veterinario y estar atentos.",
        ideal:
          "Es ideal para quienes tienen un departamento, y muy buen compañero de los niños. Tienen tendencia a ladrar y cavar, así que pueden complicar las cosas a quienes gustan del silencio extremo o disfrutan de un jardín bien cuidado.",
        dato: "Desarrollado como perro cazador, hoy en día es una de las mejores mascotas que existen para ello.",
        size: 1,
        vida: 3,
        deporte: 1,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "inline",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/west-highland-white-terrier.html",
        n: "/img/razas/104.jpg",
      },
      {
        nombre1: "Whippet",
        nombre2: "",
        pais_origen: "Inglaterra",
        origen:
          "Se originó de cruces entre el greyhound y razas de perros del tipo terrier. Los cruces realizados dieron lugar a uno de los perros más rápidos que existen actualmente. Estos perros fueron empleados como perros de carreras y perros de caza de liebres y conejos.",
        caracteristica:
          "Tiene un carácter tranquilo, gentil, dulce y sensible. No soportan bien los castigos, ni físicos ni psicológicos, por lo que es importante no usarlos en el momento de educarlos.  Tienden a llevarse bien con los niños.",
        recomendacion:
          "Puede ser reservado con los extraños, por lo que es recomendable socializarlo desde cachorro para evitar problemas de timidez cuando el perro es adulto. Son muy sensibles al frío, del que debemos tener cuidado.",
        ideal:
          "No son perros a los que les gusten los juegos rudos y, por eso, no son las mejores mascotas para niños pequeños. No es fácil tener un perro de esta raza junto con otra mascota de talla pequeña ya que estos perros tienen un fuerte instinto cazador y tienden a perseguir. Se sabe de varios casos en que whippets han matado a otras mascotas, como gatos y conejos. Pueden adaptarse a vivir en un departamento, pero necesitan hacer ejercicio intenso con cierta frecuencia.",
        dato: "Es capaz de alcanzar una velocidad de 60 kilómetros por hora en pocos segundos. De hecho, el whippet es el perro que alcanza la mayor aceleración del mundo.",
        size: 2,
        vida: 4,
        deporte: 3,
        intel: 3,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/whippet.html",
        n: "/img/razas/174.jpg",
      },
      {
        nombre1: "Xoloitzcuintle",
        nombre2: "",
        pais_origen: "México",
        origen:
          "Es originario de México y estaba presente en la vida de los antiguos aztecas, que lo consideraban una representación viva de su dios Xototl, el dios azteca de la muerte. Los aztecas creían que los perros xoloitzcuintles fueron creados por su Dios, el cual los fabricó con una astilla del hueso de la vida para guiar a los difuntos en su travesía hasta el más allá, razón por la que cuando fallecía alguien los sacrificaban y los enterraban junto con el difunto.",
        caracteristica:
          "Destacamos que es ideal para familias, puesto que es un perro obediente, inteligente, leal y muy amigable. También es un magnífico perro guardián debido a su capacidad de mantenerse alerta y atento, así como por su coraje. Son animales cariñosos, a los que les encanta que les prestemos atención y les dediquemos nuestro tiempo y cariño.",
        recomendacion:
          "Debido a que no tienen pelo están más expuestos a las heridas, quemaduras, alergias o rozaduras en su piel, por lo que tenemos que estar atentos a factores como la luz solar o los alérgenos que puedan entrar en contacto con él. Además hay que tener cuidado con el frío.",
        ideal:
          "Es un ideal compañero de juego para los pequeños de la casa, pues es juguetón y muy paciente, no mostrándose nunca agresivo. Si pasamos muchas horas fuera del hogar quizá esta raza no sea la más idónea para nosotros.",
        dato: "En México es muy apreciado y se le considera una joya arqueológica viviente, ya que esta raza canina era ya compañera de los aztecas hace más de 7000 años. ",
        size: 2,
        vida: 3,
        deporte: 2,
        intel: 5,
        clima: 4,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/xoloitzcuintle.html",
        n: "/img/razas/89.jpg",
      },
      {
        nombre1: "Yorkie Poo",
        nombre2: "Yorkipoo",
        pais_origen: "?",
        origen:
          "Nacen del cruce realizado entre un yorkshire terrier y un caniche miniatura. Estamos ante una raza realmente reciente, pues los primeros yorkie poo llegaron hace menos de una década. Además, el origen geográfico de los yorkipoo es toda una incógnita, aunque existen múltiples teorías que sitúan a los primeros ejemplares en Norteamérica o Australia.",
        caracteristica:
          "Es sumamente cautivador, pues se trata de un perro amable, cariñoso, dulce y amigable.  Es algo obstinado y desconfiado, por lo que puede qmostrarse muy receptivo cuando está con otras personas, pero en cuanto gana algo de confianza no duda en demostrar todo su cariño. Puede ser un poco ladrador, especialmente durante las noches.",
        recomendacion:
          "Se trata de un can que no acostumbra a estar solo, por lo que es habitual que desarrolle ansiedad por separación. Para evitar esto es muy importante enseñarle a estar solo y a gestionar sus emociones, dejándolo solo en casa de vez en cuando con jugetes o algo para entretenerse.",
        ideal:
          "Se adapta sin problemas a la vida en cualquier tipo de hogar, siempre que reciba el cariño y la atención que necesita. Esto es fundamental, ya que pese a parecer un perro independiente, realmente necesita atención.",
        dato: "Este curioso perro mestizo se encuentra dentro del grupo de los perros de compañía, destacando además por tener la característica de no producir, casi nunca, reacciones alérgicas debido a que no pierde apenas pelo.",
        size: 1,
        vida: 3,
        deporte: 1,
        intel: 4,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/yorkie-poo-o-yorkipoo.html",
        n: "/img/razas/46.jpg",
      },
      {
        nombre1: "Yorkshire Terrier",
        nombre2: "Terrier de Yorkshire",
        pais_origen: "Inglaterra",
        origen:
          "Aparece por primera vez en el siglo XIX, cuando se empieza a desarrollar una raza de terriers pequeña y de fácil mantenimiento para la caza de ratas. No es hasta el 1860 cuando se presenta de forma oficial.",
        caracteristica:
          "Es un perro alerta, inteligente y muy vivo. Pueden llegar a ladrar mucho ya que es un perro vigilante y guardián por naturaleza.",
        recomendacion:
          "Debes tener muy claro que la educación debe empezar desde que es cachorro con el proceso de socialización, para que puedas disfrutar de un perro adulto sociable, entrenado y mentalmente sano. Será importante prevenir el frío utilizando ropa para perros pequeños y protegiéndolo de la lluvia.",
        ideal:
          "Al ser hipoalergénico, ideal para las personas muy alérgicas.  Es una raza excelente para convivir con todo tipo de familias ya que se adapta maravillosamente a cualquier entorno.",
        dato: "Fueron tan populares para cazar ratas que empezaron a participar en diversos “deportes” relacionados con la muerte de las ratas y las apuestas de la época.",
        size: 1,
        vida: 4,
        deporte: 3,
        intel: 4,
        clima: 4,
        child: "none",
        depa: "inline",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/yorkshire-terrier.html",
        n: "/img/razas/148.jpg",
      },
      {
        nombre1: "Zuchón",
        nombre2: "Shichón",
        pais_origen: "Estados Unidos",
        origen:
          "Surge del cruce de dos razas tan icónicas: el bichón frisé y el shih tzu. Surgió de manera controlada en las últimas décadas del siglo XX (siendo una raza de aparición reciente) pero se desconocen el lugar y fecha concretos en los que nacieron los primeros cachorros.",
        caracteristica:
          "Tienen una personalidad muy marcada, que incluso puede ser contradictoria para su reducido tamaño. Son perros activos, que guardan muchas cantidades de energía, por lo que son bastante inquietos y juguetones.  Son sumamente cariñosos, por lo que tienden a volcarse mucho con su familia.",
        recomendacion:
          "No es una de las razas más exigentes en cuanto a los cuidados. Lo que si, necesita recibir atención y afecto porque no llevan bien la soledad y la falta de cariño. La falta de compañía los hace padecer grandes niveles de ansiedad.",
        ideal:
          "Se adaptan muy bien a la vida tanto en hogares con niños pequeños como de gente anciana, siendo siempre preferible la vida en interiores, ya que no están preparados para aguantar los rigores de la vida fuera de una casa.",
        dato: "El pelaje de los zuchón tiene la particularidad de no perder apenas pelo, lo que lo convierte en un perro catalogado como hipoalaergénico.",
        size: 1,
        vida: 4,
        deporte: 2,
        intel: 1,
        clima: 3,
        child: "none",
        depa: "none",
        antig: "none",
        salud: "none",
        ladrido: "none",
        intel2: "none",
        link: "https://www.expertoanimal.com/razas-de-perros/zuchon-o-shichon.html",
        n: "/img/razas/19.jpg",
      },
    ];
    set_aux_lista(lista_razas);
    set_lista(lista_razas);
    window.scrollTo(0, 0);
  }, []);

  const buscar_bar = (e) => {
    if (e === "") {
      set_lista(aux_lista);
      return;
    } else {
      const filtered = aux_lista.filter((raza) =>
        raza.nombre1.toLowerCase().includes(e.toLowerCase())
      );
      set_lista(filtered);
    }
  };

  return (
    <div>
      <Float></Float>
      <Portada img="/img/portada6.jpg" name_tag="Razas"></Portada>
      <p className="razas_titulo">¡Encuentra tu Raza favorita!</p>
      <input
        className="buscar"
        placeholder="Buscar..."
        onInput={(e) => buscar_bar(e.target.value)}
      ></input>
      <ul className="grid_razas">
        {lista.map((items) => {
          return (
            <li key={items.nombre1}>
              <Tips items={items}></Tips>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Grid_razas;
